/* eslint-disable default-case */
/* eslint-disable no-extend-native */
import * as React from 'react';
import { createRoot } from 'react-dom/client'
import { CallbackWrapper } from 'react-callback';
import { AccordionComponent, AccordionItemsDirective, AccordionItemDirective } from '@syncfusion/ej2-react-navigations';
import { GridComponent, ColumnsDirective, ColumnDirective, Toolbar, ExcelExport, DetailRow, CommandColumn, PdfExport, Page, Filter, Inject, Sort, headerContent } from '@syncfusion/ej2-react-grids';
import { ChartComponent, SeriesCollectionDirective, SeriesDirective,  Legend, Category, Tooltip, LineSeries, DateTime, Trendlines, TrendlinesDirective, TrendlineDirective, ColumnSeries, DataLabel } from '@syncfusion/ej2-react-charts';
import { DropDownListComponent, MultiSelectComponent } from '@syncfusion/ej2-react-dropdowns';
import { DialogComponent } from '@syncfusion/ej2-react-popups';
import { CheckBoxComponent, ButtonComponent } from '@syncfusion/ej2-react-buttons';
import { DataManager, Query } from '@syncfusion/ej2-data';
import { SampleBase } from './sample-base';
import * as CustomJS from '../Custom';
import _ from 'underscore/underscore-min';
import '../Custom.css';
import CurvaObiettivi from '../assets/CurvaObiettivi2026.json';
import BlockUi from '@availity/block-ui';
import { ToastContainer, toast, Slide, Zoom, Flip, Bounce } from 'react-toastify';
import { random, isUndefined } from 'underscore';
import $ from 'jquery';
import LavoriInCorso from '../assets/LavoriInCorso2.jpg';

Array.prototype.sum = function (prop, tipo) {
    let total = 0
    for ( let i = 0, _len = this.length; i < _len; i++ ) {
        if (this[i].Raggruppamento === tipo)
            total += this[i][prop];
    }
    return total;
}

Array.prototype.mediaPonderataMedie = function (campoMedia, campoNumerosita, tipo) {
    let mediaTotale = 0, pesoTotale = 0, numerositaTotale = 0;
    for ( var i = 0, _len = this.length; i < _len; i++ ) {
        if (this[i].Raggruppamento === tipo){
            pesoTotale += (this[i][campoMedia] * this[i][campoNumerosita]);
            //media = Math.round(((media * numerosita) + (this[i][campoMedia] * this[i][campoNumerosita]) / (numerosita + this[i][campoNumerosita])) * 100) / 100;
            numerositaTotale += this[i][campoNumerosita]; 
        }
    }   
    mediaTotale = numerositaTotale === 0 ? 0 : pesoTotale / numerositaTotale;
    return Math.round(mediaTotale * 100) / 100;
}

let periti = [];
var dataCorrente = new Date();
var dd = String(dataCorrente.getDate()).padStart(2, '0');
var mm = String(dataCorrente.getMonth() + 1).padStart(2, '0');
var yyyy = dataCorrente.getFullYear();
dataCorrente = yyyy.toString() + mm + dd;
let mesiChar = ['GENNAIO', 'FEBBRAIO', 'MARZO', 'APRILE', 'MAGGIO', 'GIUGNO', 'LUGLIO', 'AGOSTO', 'SETTEMBRE', 'OTTOBRE', 'NOVEMBRE', 'DICEMBRE'];
let ObietMeseAC = 0;
let ObietMeseRE = 0;
let ObietMeseRC = 0;
let ObietMeseEN = 0;
let GridData1 = [], GridData2 = [], ddlData = [];
let data1 = [], data2 = [], ObietMese = [], data3 = [], data4 = [];
const RAGGRUPPAMENTI_CONFIG = {
    AC: { label: 'Acqua Condotta', color: 'PaleTurquoise' },
    RE: { label: 'Rami Elementari', color: 'LightGreen' },
    RC: { label: 'Responsabilità Civile', color: 'LightPink' },
    EN: { label: 'Eventi Naturali', color: '#FFD54F' }
};
const stylesLegend = {
    legendContainer: {
        background: 'white',
        padding: '24px',
        fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif"
    },
    infoBox: {
        background: 'linear-gradient(135deg, #5dccde 0%, #7de5ff 100%)',
        borderRadius: '10px',
        padding: '18px 20px',
        marginBottom: '24px',
        display: 'flex',
        alignItems: 'flex-start',
        boxShadow: '0 4px 12px rgba(23, 162, 184, 0.25)',
        border: '2px solid rgba(255, 255, 255, 0.5)'
    },
    infoIcon: {
        fontSize: '28px',
        marginRight: '16px',
        flexShrink: 0
    },
    infoContent: {
        flex: 1
    },
    infoTitle: {
        fontSize: '16px',
        fontWeight: '700',
        color: '#004085',
        marginBottom: '8px',
        textTransform: 'uppercase',
        letterSpacing: '0.5px'
    },
    infoText: {
        fontSize: '14px',
        color: '#0056b3',
        marginBottom: '10px',
        lineHeight: '1.5',
        fontWeight: '500'
    },
    areaList: {
        fontSize: '15px',
        fontWeight: '700',  // GRASSETTO
        color: '#003d82',
        background: 'rgba(255, 255, 255, 0.8)',
        padding: '12px 14px',
        borderRadius: '6px',
        letterSpacing: '0.3px',
        lineHeight: '1.6',
        fontFamily: "'Courier New', monospace"
    },
    kpiSection: {
        marginBottom: '28px'
    },
    kpiHeader: {
        fontSize: '20px',
        fontWeight: '700',
        color: '#34495e',
        marginBottom: '16px',
        display: 'flex',
        alignItems: 'center'
    },
    kpiBadge: {
        background: '#3498db',
        color: 'white',
        padding: '8px 18px',
        borderRadius: '24px',
        fontSize: '16px',
        marginRight: '14px',
        fontWeight: '600'
    },
    legendItem: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '16px 20px',
        marginBottom: '10px',
        background: '#f8f9fa',
        borderRadius: '8px',
        transition: 'all 0.3s ease',
        border: '1px solid #e9ecef'
    },
    legendLabel: {
        display: 'flex',
        alignItems: 'center',
        fontSize: '17px',
        color: '#2c3e50',
        fontWeight: '500'
    },
    legendIndicator: {
        width: '20px',
        height: '20px',
        borderRadius: '50%',
        marginRight: '14px',
        flexShrink: 0
    },
    indicatorBlue: {
        background: '#3498db',
        border: '3px solid #2980b9'
    },
    indicatorOrange: {
        background: '#e67e22',
        border: '3px solid #d35400'
    },
    indicatorGreen: {
        background: '#27ae60',
        border: '3px solid #229954'
    },
    indicatorPurple: {
        background: '#9b59b6',
        border: '3px solid #8e44ad'
    },
    legendValue: {
        fontWeight: '700',
        fontSize: '19px',
        color: '#2c3e50'
    },
    euroSymbol: {
        color: '#27ae60',
        marginRight: '4px',
        fontWeight: '700'
    },
    daysLabel: {
        fontSize: '20px',
        color: '#7f8c8d',
        marginLeft: '6px',
        fontWeight: '700'
    },
    rcInfoBox: {
        background: 'linear-gradient(135deg, #d7bde2 0%, #e8daef 100%)',
        borderRadius: '10px',
        padding: '18px 20px',
        marginBottom: '24px',
        display: 'flex',
        alignItems: 'flex-start',
        boxShadow: '0 4px 12px rgba(142, 68, 173, 0.25)',
        border: '2px solid rgba(255, 255, 255, 0.5)'
    },
    rcInfoTitle: {
        fontSize: '16px',
        fontWeight: '700',
        color: '#4a235a',
        marginBottom: '8px',
        textTransform: 'uppercase',
        letterSpacing: '0.5px'
    },
    rcInfoText: {
        fontSize: '14px',
        color: '#6c3483',
        marginBottom: '10px',
        lineHeight: '1.5',
        fontWeight: '500'
    },
    rcAreaList: {
        fontSize: '15px',
        fontWeight: '700',
        color: '#4a235a',
        background: 'rgba(255, 255, 255, 0.8)',
        padding: '12px 14px',
        borderRadius: '6px',
        letterSpacing: '0.3px',
        lineHeight: '1.6',
        fontFamily: "'Courier New', monospace"
    }
};

function calcolaSinistriObiettivo(sinistriEntrati, ramo) {
    if (sinistriEntrati === 0)
        return 0;
    
    const obiettivi = {
        'AC': ObietMeseAC,
        'RE': ObietMeseRE,
        'RC': ObietMeseRC,
        'EN': ObietMeseEN
    };
    
    const obiettivo = obiettivi[ramo] || 0;
    
    for (let ind = 1;; ind++) {
        let scaricoSimul = Math.floor(((ind / sinistriEntrati) * 100));
        if (scaricoSimul >= parseInt(obiettivo))
            return ind;
    }
}

function headerTemplate(props) { 
    return (<div>
        <span style={{ fontSize: '0.9vw', fontWeight: 'bolder' }}>{props.headerText}</span>
   </div>);
}

function headerTemplate2(props) { 
    return (<div>
        <span style={{ fontSize: '0.72vw', fontWeight: 'bolder' }}>{props.headerText}</span>
   </div>);
}

function headerTemplate3(props) { 
    return (<div>
        <span style={{ fontSize: '0.67vw', fontWeight: 'bolder' }}>{props.headerText}</span>
   </div>);
}

function getInitialVisibleGroups() {
    try {
        const saved = localStorage.getItem('visibleColumnGroups');
        if (saved) {
            const groups = JSON.parse(saved);
            if (Array.isArray(groups) && groups.length > 0 && groups.length <= 3) {
                return groups;
            }
        }
    } catch (e) {
        console.error('Errore caricamento preferenze:', e);
    }
    return ['AC', 'RE', 'RC', 'EN']; // Default
}

function getInitialVisibleGroupsAree() {
    try {
        const saved = localStorage.getItem('visibleColumnGroupsAree');
        if (saved) {
            const groups = JSON.parse(saved);
            if (Array.isArray(groups) && groups.length > 0 && groups.length <= 3) {
                return groups;
            }
        }
    } catch (e) {
        console.error('Errore caricamento preferenze aree:', e);
    }
    return ['AC', 'RE', 'RC', 'EN']; // Default
}

export default class PaginaObiettivi extends SampleBase {
    constructor() {
        super(...arguments);  
        this.toolbarOptions = ['ExcelExport', { template: this.ddlPeritiToolbar.bind(this) }, '    ', { template: this.chkPeritiObiettToolbar.bind(this) }, '    ', { template: this.chkPeritiNoObiettToolbar.bind(this) }]; 
        this.toolbarOptions2 = ['ExcelExport', { template: this.ddlPeritiToolbar2.bind(this) }, '    ', { template: this.chkPeritiObiettToolbar2.bind(this) }, '    ', { template: this.chkPeritiNoObiettToolbar2.bind(this) }, 'Search']; 
        this.toolbarOptions3 = ['ExcelExport', 'Search']; 
        this.periti = [];
        this.childGrid = {
            queryString: 'IdCompagnia',
            allowPaging: true,
            allowSelection: false,
            enableHover: false,
            pageSettings: { pageSize: 10, pageCount: 5 },
            toolbar: [ 'ExcelExport', 'Search' ],
            dataSource: [],
            columns: [
                { field: 'NominativoPerito', headerText: 'Nominativo Perito', headerTemplate: headerTemplate, textAlign: 'Center', width: '15%' },
                { headerText: 'Acqua Condotta', headerTemplate: headerTemplate, textAlign: 'Center', 
                    columns: [{ field: 'ScarTotSinAC', headerText: 'Scarico Totale', headerTemplate: headerTemplate3, textAlign: 'Center' }, 
                              { field: 'NumSinistriMancantiAC', headerText: 'Sinistri Mancanti', headerTemplate: headerTemplate3, textAlign: 'Center' },
                              { field: 'TempoMedioScaricoAC', headerText: 'Tempo Medio Scarico', headerTemplate: headerTemplate3, textAlign: 'Center' }]},
                { headerText: 'Rami Elementari', headerTemplate: headerTemplate, textAlign: 'Center', 
                    columns: [{ field: 'ScarTotSinRE', headerText: 'Scarico Totale', headerTemplate: headerTemplate3, textAlign: 'Center' }, 
                              { field: 'NumSinistriMancantiRE', headerText: 'Sinistri Mancanti', headerTemplate: headerTemplate3, textAlign: 'Center' },
                              { field: 'TempoMedioScaricoRE', headerText: 'Tempo Medio Scarico', headerTemplate: headerTemplate3, textAlign: 'Center'}]},
                { headerText: 'Responsabilità Civile', headerTemplate: headerTemplate, textAlign: 'Center', 
                    columns: [{ field: 'ScarTotSinRC', headerText: 'Scarico Totale', headerTemplate: headerTemplate3, textAlign: 'Center' }, 
                            { field: 'NumSinistriMancantiRC', headerText: 'Sinistri Mancanti', headerTemplate: headerTemplate3, textAlign: 'Center' },
                            { field: 'TempoMedioScaricoRC', headerText: 'Tempo Medio Scarico', headerTemplate: headerTemplate3, textAlign: 'Center'}]},
                { headerText: 'Eventi Naturali', headerTemplate: headerTemplate, textAlign: 'Center', 
                    columns: [
                        { field: 'ScarTotSinEN', headerText: 'Scarico Totale', headerTemplate: headerTemplate3, textAlign: 'Center' }, 
                        { field: 'NumSinistriMancantiEN', headerText: 'Sinistri Mancanti', headerTemplate: headerTemplate3, textAlign: 'Center' },
                        { field: 'TempoMedioScaricoEN', headerText: 'Tempo Medio Scarico', headerTemplate: headerTemplate3, textAlign: 'Center'}
                    ]
                }          
            ], 
            queryCellInfo: this.onQueryCellInfo2.bind(this),
            dataBound: this.onDatabound2 
        };
        this.childGrid2 = {
            queryString: 'DescrArea',
            allowPaging: true,
            allowSelection: false,
            enableHover: false,
            pageSettings: { pageSize: 5, pageCount: 5 },
            toolbar: [ 'ExcelExport', 'Search' ],
            dataSource: [],
            columns: [
                { field: 'NominativoPerito', headerText: 'Nominativo Perito', headerTemplate: headerTemplate, textAlign: 'Center', width: '15%' },
                { headerText: 'Acqua Condotta', headerTemplate: headerTemplate, textAlign: 'Center', 
                    columns: [{ field: 'ScarTotSinAC', headerText: 'Scarico Totale', headerTemplate: headerTemplate3, textAlign: 'Center' }, 
                              { field: 'NumSinistriMancantiAC', headerText: 'Sinistri Mancanti', headerTemplate: headerTemplate3, textAlign: 'Center' },
                              { field: 'TempoMedioScaricoAC', headerText: 'Tempo Medio Scarico', headerTemplate: headerTemplate3, textAlign: 'Center'}]},
                { headerText: 'Rami Elementari', headerTemplate: headerTemplate, textAlign: 'Center', 
                    columns: [{ field: 'ScarTotSinRE', headerText: 'Scarico Totale', headerTemplate: headerTemplate3, textAlign: 'Center' }, 
                              { field: 'NumSinistriMancantiRE', headerText: 'Sinistri Mancanti', headerTemplate: headerTemplate3, textAlign: 'Center' },
                              { field: 'TempoMedioScaricoRE', headerText: 'Tempo Medio Scarico', headerTemplate: headerTemplate3, textAlign: 'Center'}]},
                { headerText: 'Responsabilità Civile', headerTemplate: headerTemplate, textAlign: 'Center', 
                    columns: [{ field: 'ScarTotSinRC', headerText: 'Scarico Totale', headerTemplate: headerTemplate3, textAlign: 'Center' }, 
                            { field: 'NumSinistriMancantiRC', headerText: 'Sinistri Mancanti', headerTemplate: headerTemplate3, textAlign: 'Center' },
                            { field: 'TempoMedioScaricoRC', headerText: 'Tempo Medio Scarico', headerTemplate: headerTemplate3, textAlign: 'Center'}]},
                { headerText: 'Eventi Naturali', headerTemplate: headerTemplate, textAlign: 'Center', 
                    columns: [
                        { field: 'ScarTotSinEN', headerText: 'Scarico Totale', headerTemplate: headerTemplate3, textAlign: 'Center' }, 
                        { field: 'NumSinistriMancantiEN', headerText: 'Sinistri Mancanti', headerTemplate: headerTemplate3, textAlign: 'Center' },
                        { field: 'TempoMedioScaricoEN', headerText: 'Tempo Medio Scarico', headerTemplate: headerTemplate3, textAlign: 'Center'}
                    ]
                }          
            ], 
            queryCellInfo: this.onQueryCellInfo2.bind(this),
            dataBound: this.onDatabound2
        };
        this.childGrid3 = {
            queryString: 'TipoSinistro',
            allowPaging: true,
            allowSelection: false,
            enableHover: false,
            pageSettings: { pageSize: 10, pageCount: 5 },
            toolbar: [ 'Search' ],
            columns: [
                { field: 'NominativoPerito', headerText: 'Nominativo Perito', width: '20%', headerTemplate: headerTemplate, textAlign: 'Center' },
                { field: 'MediaGiorniCentroNord', headerText: '', textAlign: 'Center' },
                { field: 'MediaGiorniSud', headerText: '', textAlign: 'Center' },
            ], 
            queryCellInfo: this.onQueryCellInfo4.bind(this),
            dataBound: this.onDatabound5
        };
        this.childGrid4 = {
            queryString: 'TipoSinistro',
            allowPaging: true,
            allowSelection: false,
            enableHover: false,
            pageSettings: { pageSize: 10, pageCount: 5 },
            toolbar: [ 'Search' ],
            columns: [
                { field: 'NominativoPerito', headerText: 'Nominativo Perito', width: '20%', headerTemplate: headerTemplate, textAlign: 'Center' },
                { field: 'LiquidatoMedio', headerText: '', textAlign: 'Center' },
                { field: 'DeltaObiettivoKPI1', headerText: '', textAlign: 'Center' },
                { field: 'PercScaricoAnnuale', headerText: '', textAlign: 'Center' },
                // { field: 'DeltaObiettivoKPI2', headerText: '', textAlign: 'Center' },
                { field: 'TempoMedioRestituzione', headerText: '', textAlign: 'Center' },
                { field: 'DeltaObiettivoKPI4', headerText: '', textAlign: 'Center' },
                { field: 'PercNonIndennizzabili', headerText: '', textAlign: 'Center' },
            ], 
            queryCellInfo: this.onQueryCellInfo5,
            dataBound: this.onDatabound7
        };
        this.childGridHDI = {
            queryString: 'TipoSinistro',
            allowPaging: true,
            allowSelection: false,
            enableHover: false,
            pageSettings: { pageSize: 10, pageCount: 5 },
            toolbar: [ 'Search' ],
            columns: [
                { field: 'NominativoPerito', headerText: 'Nominativo Perito', width: '20%', headerTemplate: headerTemplate, textAlign: 'Center' },
                { field: 'LiquidatoMedio', headerText: '', textAlign: 'Center' },
                { field: 'DeltaObiettivoKPI1', headerText: '', textAlign: 'Center' },
                { field: 'PercScaricoAnnuale', headerText: '', textAlign: 'Center' },
                { field: 'TempoMedioRestituzione', headerText: '', textAlign: 'Center' },
                { field: 'DeltaObiettivoKPI4', headerText: '', textAlign: 'Center' },
                { field: 'PercNonIndennizzabili', headerText: '', textAlign: 'Center' },
            ],
            queryCellInfo: this.onQueryCellInfo5,
            dataBound: this.onDatabound7
        };
        this.childGridSARA = {
            queryString: 'TipoSinistro',
            allowPaging: true,
            allowSelection: false,
            enableHover: false,
            pageSettings: { pageSize: 10, pageCount: 5 },
            toolbar: [ 'Search' ],
            columns: [
                { field: 'NominativoPerito', headerText: 'Nominativo Perito', width: '20%', headerTemplate: headerTemplate, textAlign: 'Center' },
                { field: 'LiquidatoMedio', headerText: '', textAlign: 'Center' },
                { field: 'DeltaObiettivoKPI1', headerText: '', textAlign: 'Center' },
                { field: 'PercScaricoAnnuale', headerText: '', textAlign: 'Center' },
                { field: 'TempoMedioRestituzione', headerText: '', textAlign: 'Center' },
                { field: 'DeltaObiettivoKPI4', headerText: '', textAlign: 'Center' },
                { field: 'PercNonIndennizzabili', headerText: '', textAlign: 'Center' },
            ],
            queryCellInfo: this.onQueryCellInfo5,
            dataBound: this.onDatabound7
        };
        this.childGrid5 = {
            queryString: 'TipoSinistro',
            allowPaging: true,
            allowSelection: false,
            enableHover: false,
            pageSettings: { pageSize: 10, pageCount: 5 },
            toolbar: [ 'Search' ],
            columns: [
                { field: 'NominativoPerito', headerText: 'Nominativo Perito', width: '20%', headerTemplate: headerTemplate, textAlign: 'Center' },
                { field: 'LiquidatoMedio', headerText: '', textAlign: 'Center' },
                { field: 'DeltaObiettivoKPI4', headerText: '', textAlign: 'Center' },
                { field: 'PercScaricoAnnuale', headerText: '', textAlign: 'Center' },
                // { field: 'DeltaObiettivoKPI3', headerText: '', textAlign: 'Center' },
                { field: 'TempoMedioRestituzione', headerText: '', textAlign: 'Center' },
                { field: 'DeltaObiettivoKPI2', headerText: '', textAlign: 'Center' },
                { field: 'IncidenzaConcordato', headerText: '', textAlign: 'Center' },
            ], 
            queryCellInfo: this.onQueryCellInfo6,
            dataBound: this.onDatabound9
        };
        this.childGrid6 = {
            queryString: 'TipoSinistro',
            allowPaging: true,
            allowSelection: false,
            enableHover: false,
            pageSettings: { pageSize: 10, pageCount: 5 },
            toolbar: [ 'Search' ],
            columns: [
                { field: 'NominativoPerito', headerText: 'Nominativo Perito', width: '15%', headerTemplate: headerTemplate, textAlign: 'Center' },
                { field: 'LiquidatoMedioGFRE', headerText: 'Liquidato Medio GF-RE (KPI2)', headerTemplate: headerTemplate2, textAlign: 'Center' },
                { field: 'DeltaObiettivoKPI2', headerText: 'Delta su obiettivo (KPI2)', headerTemplate: headerTemplate2, textAlign: 'Center' },
                { field: 'PercScaricoGFRE', headerText: '% Scarico GF-RE (KPI1)', headerTemplate: headerTemplate2, textAlign: 'Center' },
                { field: 'DeltaObiettivoKPI1', headerText: 'Sinistri mancanti obiettivo (KPI1)', headerTemplate: headerTemplate2, textAlign: 'Center' },
                { field: 'PercScaricoHome30GG', headerText: '% Scarico Rami HOME 30 GG (KPI3)', headerTemplate: headerTemplate2, textAlign: 'Center' },
                { field: 'DeltaObiettivoKPI330', headerText: 'Sinistri mancanti obiettivo 30 GG (KPI3)', headerTemplate: headerTemplate2, textAlign: 'Center' },
                { field: 'PercScaricoHome45GG', headerText: '% Scarico Rami HOME 45 GG (KPI3)', headerTemplate: headerTemplate2, textAlign: 'Center' },
                { field: 'DeltaObiettivoKPI345', headerText: 'Sinistri mancanti obiettivo 45 GG (KPI3)', headerTemplate: headerTemplate2, textAlign: 'Center' },
                { field: 'PercScaricoRCD', headerText: '% Scarico RCD (KPI4)', headerTemplate: headerTemplate2, textAlign: 'Center' },
                { field: 'DeltaObiettivoKPI4', headerText: 'Sinistri mancanti obiettivo (KPI4)', headerTemplate: headerTemplate2, textAlign: 'Center' },
                { field: 'PercScaricoVideoperiziaHome', headerText: '% Videoper. Rami HOME (KPI5)', headerTemplate: headerTemplate2, textAlign: 'Center' },
                { field: 'DeltaObiettivoKPI5', headerText: 'Sinistri mancanti obiettivo (KPI5)', headerTemplate: headerTemplate2, textAlign: 'Center' },
            ], 
            queryCellInfo: this.onQueryCellInfo7.bind(this),
            dataBound: this.onDatabound11
        };
        this.commands = [{ type: "Vedi Situazione Aree Compagnia", buttonOption: { iconCss: "fas fa-chart-area fa-10x", cssClass: "e-details" }},
                         { id: 'KPI-Intesa', title: "Vedi KPI Compagnia", buttonOption: { content: 'KPI', cssClass: "e-details" }},
                         { id: 'KPI-Generali', title: "Vedi KPI Compagnia", buttonOption: { content: 'KPI', cssClass: "e-details" }},
                         { id: 'KPI-Unipol', title: "Vedi KPI Compagnia", buttonOption: { content: 'KPI', cssClass: "e-details" }},
                         { id: 'KPI-Allianz', title: "Vedi KPI Compagnia", buttonOption: { content: 'KPI', cssClass: "e-details" }},
                         { id: 'KPI-Vittoria', title: "Vedi KPI Compagnia", buttonOption: { content: 'KPI', cssClass: "e-details" }},
                         { id: 'KPI-HDI', title: "Vedi KPI Compagnia", buttonOption: { content: 'KPI', cssClass: "e-details" }},
                         { id: 'KPI-SARA', title: "Vedi KPI Compagnia", buttonOption: { content: 'KPI', cssClass: "e-details" }},
                         { id: 'KPI-RealeMutua', title: "Vedi KPI Compagnia", buttonOption: { content: 'KPI', cssClass: "e-details" }}
        ];
        this.ddlFields = { text: 'Text', value: 'Value' };
        this.gruppiColonne = [
            { Value: 'AC', Text: 'Acqua Condotta' },
            { Value: 'RE', Text: 'Rami Elementari' },
            { Value: 'RC', Text: 'Responsabilità Civile' },
            { Value: 'EN', Text: 'Eventi Naturali' }
        ];
        this.mesi = [{Text: mesiChar[0], Value: '01'}, {Text: mesiChar[1], Value: '02'}, {Text: mesiChar[2], Value: '03'}, {Text: mesiChar[3], Value: '04'}, 
                    {Text: mesiChar[4], Value: '05'}, {Text: mesiChar[5], Value: '06'}, {Text: mesiChar[6], Value: '07'}, {Text: mesiChar[7], Value: '08'}, 
                    {Text: mesiChar[8], Value: '09'}, {Text: mesiChar[9], Value: '10'}, {Text: mesiChar[10], Value: '11'}, {Text: mesiChar[11], Value: '12'}];
        this.ddlMesiFiltr = _.filter(this.mesi, elm => { return parseInt(elm.Value) <= parseInt(mm) }); 
        this.toggleBlocking = this.toggleBlocking.bind(this);
        this.toggleBlocking2 = this.toggleBlocking2.bind(this);
        this.animationSettings = { effect: 'FadeZoom' };
        this.excludedCompany = [57, 79];
        this.kpiGeneraliRawData = [];
        this.gridDataProv1 = [];
        this.gridDataProv2 = [];
        this.childGridProvince = {
            queryString: 'ProvinciaCorta',
            allowPaging: true,
            allowSelection: false,
            enableHover: false,
            pageSettings: { pageSize: 10, pageCount: 5 },
            toolbar: ['Search'],
            columns: [
                { field: 'NominativoPerito', headerText: 'Nominativo Perito', width: '22%', headerTemplate: headerTemplate, textAlign: 'Center' },
                { field: 'LiquidatoMedio', headerText: 'Liquidato Medio (KPI1)', headerTemplate: headerTemplate, textAlign: 'Center' },
                { field: 'DeltaObiettivoKPI1', headerText: 'Delta su obiettivo (KPI1)', headerTemplate: headerTemplate, textAlign: 'Center' },
                { field: 'PercScaricoAnnuale', headerText: '% Scarico Annuale (KPI2)', headerTemplate: headerTemplate, textAlign: 'Center' },
                { field: 'TempoMedioRestituzione', headerText: 'Tempo Medio Rest. (KPI4)', headerTemplate: headerTemplate, textAlign: 'Center' },
                { field: 'DeltaObiettivoKPI4', headerText: 'Delta su obiettivo (KPI4)', headerTemplate: headerTemplate, textAlign: 'Center' },
                { field: 'PercNonIndennizzabili', headerText: '% Non Indennizzabili (KPI3)', headerTemplate: headerTemplate, textAlign: 'Center' },
            ],
            queryCellInfo: this.onQueryCellInfoProvincePerito.bind(this),
            dataBound: this.onDataboundProvincePerito
        };
        this.tipiConDettaglioProvince = ['ACQUA CONDOTTA'];
        this.provinceButtonTemplate = (rowData) => {
            if (!this.tipiConDettaglioProvince.includes(rowData.TipoSinistro)) return <span></span>;
            return (
                <button onClick={() => this.openProvinceModal(rowData.TipoSinistro, 'generali')} style={{
                    background: 'linear-gradient(135deg, #1565c0 0%, #42a5f5 100%)',
                    color: 'white',
                    border: 'none',
                    borderRadius: '20px',
                    padding: '5px 14px',
                    fontSize: '0.78vw',
                    fontWeight: '600',
                    cursor: 'pointer',
                    boxShadow: '0 2px 6px rgba(21,101,192,0.4)',
                    letterSpacing: '0.3px',
                    whiteSpace: 'nowrap'
                }}>
                    💧 per Provincia
                </button>
            );
        };
        this.provinceButtonTemplateHDI = (rowData) => {
            if (!this.tipiConDettaglioProvince.includes(rowData.TipoSinistro)) return <span></span>;
            return (
                <button onClick={() => this.openProvinceModal(rowData.TipoSinistro, 'hdi')} style={{
                    background: 'linear-gradient(135deg, #1565c0 0%, #42a5f5 100%)',
                    color: 'white',
                    border: 'none',
                    borderRadius: '20px',
                    padding: '5px 14px',
                    fontSize: '0.78vw',
                    fontWeight: '600',
                    cursor: 'pointer',
                    boxShadow: '0 2px 6px rgba(21,101,192,0.4)',
                    letterSpacing: '0.3px',
                    whiteSpace: 'nowrap'
                }}>
                    💧 per Provincia
                </button>
            );
        };
        this.provinceButtonTemplateSARA = (rowData) => {
            if (!this.tipiConDettaglioProvince.includes(rowData.TipoSinistro)) return <span></span>;
            return (
                <button onClick={() => this.openProvinceModal(rowData.TipoSinistro, 'sara')} style={{
                    background: 'linear-gradient(135deg, #1565c0 0%, #42a5f5 100%)',
                    color: 'white',
                    border: 'none',
                    borderRadius: '20px',
                    padding: '5px 14px',
                    fontSize: '0.78vw',
                    fontWeight: '600',
                    cursor: 'pointer',
                    boxShadow: '0 2px 6px rgba(21,101,192,0.4)',
                    letterSpacing: '0.3px',
                    whiteSpace: 'nowrap'
                }}>
                    💧 per Provincia
                </button>
            );
        };
        this.kpiHDIRawData = [];
        this.kpiSARARawData = [];
        this.kpiUnipolRawData = [];
        this.activeChildGridProvince = null;
        this.activeProvQCIParent = null;
        this.activeContext = 'generali';
        this.activeTipoSinistro = '';
        this.activeGiorni = 0;
        this.activeIntesaTarget = 17;
        this.allianzRawData = [];
        this.allianzRawDataAll = [];
        this.intesaRawData = [];
        this.childGridProvinceAllianz = {
            queryString: 'ProvinciaCorta',
            allowPaging: true,
            allowSelection: false,
            enableHover: false,
            pageSettings: { pageSize: 10, pageCount: 5 },
            toolbar: ['Search'],
            columns: [
                { field: 'NominativoPerito', headerText: 'Nominativo Perito', width: '55%', headerTemplate: headerTemplate, textAlign: 'Center' },
                { field: 'LiquidatoMedioGFRE', headerText: 'Liquidato Medio GF-RE (KPI2)', headerTemplate: headerTemplate, textAlign: 'Center' },
            ],
            queryCellInfo: this.onQueryCellInfoProvincePeritorAllianz.bind(this),
            dataBound: this.onDataboundProvincePerito
        };
        this.allianzKPI2ProvinceButton = (rowData) => (
            <button onClick={() => this.openKPI2PerProvinciaAllianz(rowData.id_perito || null)} style={{
                background: 'linear-gradient(135deg, #c62828 0%, #ef5350 100%)',
                color: 'white', border: 'none', borderRadius: '20px',
                padding: '5px 14px', fontSize: '0.78vw', fontWeight: '600',
                cursor: 'pointer',
                letterSpacing: '0.3px', lineHeight: '1.4', textAlign: 'center',
                whiteSpace: 'normal'
            }}>
                🗺️ per Provincia<br/>(solo KPI2)
            </button>
        );
        this.childGridProvinceUnipol = {
            queryString: 'ProvinciaCorta',
            allowPaging: true,
            allowSelection: false,
            enableHover: false,
            pageSettings: { pageSize: 10, pageCount: 5 },
            toolbar: ['Search'],
            columns: [
                { field: 'NominativoPerito', headerText: 'Nominativo Perito', width: '22%', headerTemplate: headerTemplate, textAlign: 'Center' },
                { field: 'LiquidatoMedio', headerText: 'Liquidato Medio (KPI4)', headerTemplate: headerTemplate, textAlign: 'Center' },
                { field: 'DeltaObiettivoKPI4', headerText: 'Delta su obiettivo (KPI4)', headerTemplate: headerTemplate, textAlign: 'Center' },
                { field: 'PercScaricoAnnuale', headerText: '% Scarico Annuale (KPI3)', headerTemplate: headerTemplate, textAlign: 'Center' },
                { field: 'TempoMedioRestituzione', headerText: 'Tempo Medio Rest. (KPI2)', headerTemplate: headerTemplate, textAlign: 'Center' },
                { field: 'DeltaObiettivoKPI2', headerText: 'Delta su obiettivo (KPI2)', headerTemplate: headerTemplate, textAlign: 'Center' },
                { field: 'PercIncidenzaConcordato', headerText: '% Incidenza Concordato (KPI5)', headerTemplate: headerTemplate, textAlign: 'Center' },
            ],
            queryCellInfo: this.onQueryCellInfoProvincePeritorUnipol.bind(this),
            dataBound: this.onDataboundProvincePerito
        };
        this.provinceButtonTemplateUnipol = (rowData) => {
            const icon =
                rowData.TipoSinistro === 'ACQUA CONDOTTA'  ? '💧' :
                rowData.TipoSinistro === 'EVENTO NATURALE' ? '🌪️' :
                rowData.TipoSinistro === 'R.C. Auto'       ? '🚗' : '🗺️';
            return (
                <button onClick={() => this.openProvinceModal(rowData.TipoSinistro, 'unipol')} style={{
                    background: 'linear-gradient(135deg, #6a1b9a 0%, #ab47bc 100%)',
                    color: 'white',
                    border: 'none',
                    borderRadius: '20px',
                    padding: '5px 14px',
                    fontSize: '0.78vw',
                    fontWeight: '600',
                    cursor: 'pointer',
                    boxShadow: '0 2px 6px rgba(106,27,154,0.4)',
                    letterSpacing: '0.3px',
                    whiteSpace: 'nowrap'
                }}>
                    {icon} per Provincia
                </button>
            );
        };
    }
    state = {
        blocking2: false,  
        blocking3: false,  
        showDialog1: false,  
        meseAtt: mesiChar[parseInt(mm)-1], 
        ObietMeseACatt: ObietMeseAC,
        ObietMeseREatt: ObietMeseRE,
        ObietMeseRCatt: ObietMeseRC,
        ObietMeseENatt: ObietMeseEN, 
        visibleColumnGroups: getInitialVisibleGroups(),
        visibleColumnGroupsAree: getInitialVisibleGroupsAree(),
        kpiAllianzViewMode: 'realtime'
    }
    toggleBlocking() {
        this.setState({blocking2: !this.state.blocking2});
    }
    toggleBlocking2() {
        this.setState({blocking3: !this.state.blocking3});
    }
    onQueryCellInfo(args) {
        args.cell.style.color = args.column.index === 0 ? '#133B95' : 'purple';
        args.cell.style.fontSize = args.column.index === 0 ? '1.1vw' : '1.0vw';
        args.cell.style.fontWeight = 'bold'; 
        
        // AC: 2,3,4 | RE: 6,7,8 | RC: 10,11,12 | EN: 14,15,16
        if ([2, 3, 4, 6, 7, 8, 10, 11, 12, 14, 15, 16].includes(args.column.index)) {
            args.cell.innerText = parseFloat(args.cell.innerText).toLocaleString('it-IT'); 
        }
        
        // Aggiungi % per scarico totale
        if ([2, 6, 10, 14].includes(args.column.index)) {
            args.cell.innerText = args.cell.innerText + '%';
        }
        
        if (args.cell.innerText === 'NaN' || args.cell.innerText === '%' || args.cell.innerText === 'NaN%')
            args.cell.innerText = '';  
        
        // Colorazione sinistri mancanti (positivi = verde, negativi = rosso)
        if ([3, 7, 11, 15].includes(args.column.index) && parseInt(args.cell.innerText) > 0) {
            args.cell.style.color = 'whitesmoke';  
            args.cell.bgColor = '#00802B';          
        }
        
        if ([3, 7, 11, 15].includes(args.column.index) && parseInt(args.cell.innerText) < 0) {
            args.cell.style.color = 'whitesmoke';
            args.cell.bgColor = '#DC143C';
        }     
    }    
    onQueryCellInfo2(args) {
        args.cell.style.color = args.column.index === 0 ? '#133B95' : 'purple';
        args.cell.style.fontSize = '1.0vw';
        args.cell.style.fontWeight = 'bold';   
        
        if ([2, 3, 4, 6, 7, 8, 10, 11, 12, 14, 15, 16].includes(args.column.index)) {
            args.cell.innerText = parseFloat(args.cell.innerText).toLocaleString('it-IT');  
        }
        
        if ([2, 6, 10, 14].includes(args.column.index))
            args.cell.innerText = args.cell.innerText + '%'; 
        
        if (args.cell.innerText === 'NaN' || args.cell.innerText === '%' || args.cell.innerText === 'NaN%')
            args.cell.innerText = ''; 
        
        if ([3, 7, 11, 15].includes(args.column.index) && parseInt(args.cell.innerText) > 0) {
            args.cell.style.color = 'whitesmoke';    
            args.cell.bgColor = '#00802B';
        }  
        
        if ([3, 7, 11, 15].includes(args.column.index) && parseInt(args.cell.innerText) < 0) {
            args.cell.style.color = 'whitesmoke';
            args.cell.bgColor = '#DC143C';
        }           
    }     
    onQueryCellInfo3(args) {
        args.cell.style.color = args.column.index === 0 ? '#133B95' : 'purple';
        args.cell.style.fontSize = args.column.index === 0 ? '0.9vw' : '1.0vw';
        args.cell.style.fontWeight = 'bold';   
        
        if ([2, 3, 4, 6, 7, 8, 10, 11, 12, 14, 15, 16].includes(args.column.index)) {
            args.cell.innerText = parseFloat(args.cell.innerText).toLocaleString('it-IT');  
        }
        
        if ([2, 6, 10, 14].includes(args.column.index))
            args.cell.innerText = args.cell.innerText + '%'; 
        
        if (args.cell.innerText === 'NaN' || args.cell.innerText === '%' || args.cell.innerText === 'NaN%')
            args.cell.innerText = ''; 
        
        if ([3, 7, 11, 15].includes(args.column.index) && parseInt(args.cell.innerText) > 0) {
            args.cell.style.color = 'whitesmoke';    
            args.cell.bgColor = '#00802B';
        }  
        
        if ([3, 7, 11, 15].includes(args.column.index) && parseInt(args.cell.innerText) < 0) {
            args.cell.style.color = 'whitesmoke';
            args.cell.bgColor = '#DC143C';
        }              
    }    
    onQueryCellInfo4(args) {
        args.cell.style.color = args.column.index === 0 ? '#133B95' : 'purple';
        args.cell.style.fontSize = '1.0vw';
        args.cell.style.fontWeight = 'bold';   
        if (args.column.index === 1 || args.column.index === 2) {
            const target = args.column.index === 2 ? 21 : 17;
            const area   = args.column.index === 1 ? 'CentroNord' : 'Sud';
            args.cell.innerText = parseFloat(args.cell.innerText).toLocaleString('it-IT');
            if (args.cell.innerText === 'NaN') args.cell.innerText = '';
            const val = parseFloat(args.cell.innerText.replace(',', '.'));
            if (!isNaN(val) && val > 0) {
                if (val > target) {
                    args.cell.style.color = 'whitesmoke';
                    args.cell.bgColor = '#DC143C';
                    args.cell.innerText += ` (${parseInt(args.cell.innerText) - (target - 1)})`;
                    if (!args.data.NominativoPerito) {
                        args.cell.style.cursor = 'pointer';
                        args.cell.classList.add('kpi-glow-pulse');
                    }
                } else {
                    args.cell.style.color = 'whitesmoke';
                    args.cell.bgColor = '#00802B';
                    if (!args.data.NominativoPerito) {
                        args.cell.style.cursor = 'pointer';
                        args.cell.classList.add('kpi-glow-pulse');
                    }
                }
                if (!args.data.NominativoPerito) {
                    const idPerito = args.data?.id_perito || null;
                    args.cell.title = `Clicca per i sinistri ${area} aperti — ${args.data.TipoSinistro}`;
                    args.cell.onclick = () => this.openSinistriPotenzialiIntesa(area, args.data.TipoSinistro, idPerito, target);
                }
            }
        }
    } 
    onQueryCellInfo5(args) {
        args.cell.style.color = args.column.index === 0 ? '#133B95' : 'purple';
        args.cell.style.fontSize = '1.0vw';
        args.cell.style.fontWeight = 'bold';   
        if (args.column.index === 1 ||  args.column.index === 2 ||  args.column.index === 3 ||  args.column.index === 4 || args.column.index === 5 
            || args.column.index === 6) {
            args.cell.innerText = parseFloat(args.cell.innerText).toLocaleString('it-IT');  
            if (args.column.index === 3 || args.column.index === 6)
                 args.cell.innerText += '%';
        }
        if (args.cell.innerText === 'NaN' || args.cell.innerText === '%' || args.cell.innerText === 'NaN%')
            args.cell.innerText = ''; 
        if ((args.column.index === 1 && parseFloat(args.cell.innerText.replace('.', '').replace(',', '.')) > 0 
            && parseFloat(args.cell.innerText.replace('.', '').replace(',', '.')) > (args.data.TipoSinistro === "EVENTO NATURALE" ? 2200 :
                args.data.TipoSinistro === "ALTRI RAMI ELEMENTARI" ? 2500 : 1250)) || (args.column.index === 4 && parseInt(args.cell.innerText) > 0 
                && parseInt(args.cell.innerText) >= 45)) {
            args.cell.style.color = 'whitesmoke';
            args.cell.bgColor = '#DC143C';
        }        
        if ((args.column.index === 2 && (parseFloat(args.cell.innerText.replace(',','.')) > 0))
            || (args.column.index === 5 && parseInt(args.cell.innerText) > 0)) {    
            args.cell.style.color = 'whitesmoke';
            args.cell.bgColor = '#DC143C';
        }   
        if ((args.column.index === 1 && parseFloat(args.cell.innerText.replace('.', '').replace(',', '.')) > 0
            && parseFloat(args.cell.innerText.replace('.', '').replace(',', '.')) <= (args.data.TipoSinistro === "EVENTO NATURALE" ? 2200 :
                args.data.TipoSinistro === "ALTRI RAMI ELEMENTARI" ? 2500 : 1250)) || (args.column.index === 4 && parseInt(args.cell.innerText) > 0
                && parseInt(args.cell.innerText) < 45)) {
            args.cell.style.color = 'whitesmoke';
            args.cell.bgColor = '#00802B';
        }
        if (args.column.index === 1 && args.data.ConteggioCampione !== undefined) {
            const testo = args.cell.innerText;
            args.cell.innerHTML = `${testo}<span style="font-size:0.65em;margin-left:5px">(${args.data.ConteggioCampione})</span>`;
        }
    }
    onQueryCellInfoProvince(args) {
        args.cell.style.fontSize = '1.0vw';
        args.cell.style.fontWeight = 'bold';
        if (args.column.index === 0) {
            args.cell.style.color = 'white';
            args.cell.bgColor = '#1565c0';
            args.cell.style.textAlign = 'center';
        } else if (args.column.index === 1) {
            args.cell.style.color = '#133B95';
        } else {
            args.cell.style.color = 'purple';
        }
        if (args.column.index >= 2 && args.column.index <= 7) {
            args.cell.innerText = parseFloat(args.cell.innerText).toLocaleString('it-IT');
            if (args.column.index === 4 || args.column.index === 7)
                args.cell.innerText += '%';
        }
        if (args.cell.innerText === 'NaN' || args.cell.innerText === '%' || args.cell.innerText === 'NaN%') {
            args.cell.innerText = '';
            return;
        }
        const val = parseFloat(args.cell.innerText.replace('.', '').replace(',', '.'));
        if (args.column.index === 2 && val > 0) {
            args.cell.style.color = 'whitesmoke';
            args.cell.bgColor = val > 1250 ? '#DC143C' : '#00802B';
        }
        if (args.column.index === 3 && val > 0) {
            args.cell.style.color = 'whitesmoke';
            args.cell.bgColor = '#DC143C';
        }
        if (args.column.index === 5 && val > 0) {
            args.cell.style.color = 'whitesmoke';
            args.cell.bgColor = val >= 45 ? '#DC143C' : '#00802B';
        }
        if (args.column.index === 6 && val > 0) {
            args.cell.style.color = 'whitesmoke';
            args.cell.bgColor = '#DC143C';
        }
        if (args.column.index === 2 && args.data.ConteggioCampione !== undefined) {
            const testo = args.cell.innerText;
            args.cell.innerHTML = `${testo}<span style="font-size:0.65em;margin-left:5px">(${args.data.ConteggioCampione})</span>`;
        }
    }
    onQueryCellInfoProvincePerito(args) {
        args.cell.style.color = args.column.index === 0 ? '#133B95' : 'purple';
        args.cell.style.fontSize = '1.0vw';
        args.cell.style.fontWeight = 'bold';
        if (args.column.index >= 1 && args.column.index <= 6) {
            args.cell.innerText = parseFloat(args.cell.innerText).toLocaleString('it-IT');
            if (args.column.index === 3 || args.column.index === 6)
                args.cell.innerText += '%';
        }
        if (args.cell.innerText === 'NaN' || args.cell.innerText === '%' || args.cell.innerText === 'NaN%') {
            args.cell.innerText = '';
            return;
        }
        const val = parseFloat(args.cell.innerText.replace('.', '').replace(',', '.'));
        if (args.column.index === 1 && val > 0) {
            args.cell.style.color = 'whitesmoke';
            args.cell.bgColor = val > 1250 ? '#DC143C' : '#00802B';
        }
        if (args.column.index === 2 && val > 0) {
            args.cell.style.color = 'whitesmoke';
            args.cell.bgColor = '#DC143C';
        }
        if (args.column.index === 4 && val > 0) {
            args.cell.style.color = 'whitesmoke';
            args.cell.bgColor = val >= 45 ? '#DC143C' : '#00802B';
        }
        if (args.column.index === 5 && val > 0) {
            args.cell.style.color = 'whitesmoke';
            args.cell.bgColor = '#DC143C';
        }
        if (args.column.index === 1 && args.data.ConteggioCampione !== undefined) {
            const testo = args.cell.innerText;
            args.cell.innerHTML = `${testo}<span style="font-size:0.65em;margin-left:5px">(${args.data.ConteggioCampione})</span>`;
        }
    }
    onQueryCellInfoProvinceUnipol(args) {
        // Province level-1 rows, Unipol context
        // Cols: 0=ProvinciaCorta, 1=Provincia, 2=LiquidatoMedio, 3=DeltaObiettivoKPI4, 4=PercScaricoAnnuale, 5=TempoMedioRestituzione, 6=DeltaObiettivoKPI2, 7=PercIncidenzaConcordato
        args.cell.style.fontSize = '1.0vw';
        args.cell.style.fontWeight = 'bold';
        if (args.column.index === 0) {
            args.cell.style.color = 'white';
            args.cell.bgColor = '#6a1b9a';
            args.cell.style.textAlign = 'center';
        } else if (args.column.index === 1) {
            args.cell.style.color = '#133B95';
        } else {
            args.cell.style.color = 'purple';
        }
        if (args.column.index >= 2 && args.column.index <= 7) {
            args.cell.innerText = parseFloat(args.cell.innerText).toLocaleString('it-IT');
            if (args.column.index === 4 || args.column.index === 7)
                args.cell.innerText += '%';
        }
        if (args.cell.innerText === 'NaN' || args.cell.innerText === '%' || args.cell.innerText === 'NaN%') {
            args.cell.innerText = '';
            return;
        }
        const sogliaLiqUnipol =
            this.activeTipoSinistro === 'EVENTO NATURALE' ? 1400 :
            this.activeTipoSinistro === 'ALTRI RAMI ELEMENTARI' ? 1400 : 1250;
        const val = parseFloat(args.cell.innerText.replace(/\./g, '').replace(',', '.').replace('%', ''));
        if (args.column.index === 2 && val > 0) {
            args.cell.style.color = 'whitesmoke';
            args.cell.bgColor = val > sogliaLiqUnipol ? '#DC143C' : '#00802B';
        }
        if (args.column.index === 3 && val > 0) {
            args.cell.style.color = 'whitesmoke';
            args.cell.bgColor = '#DC143C';
        }
        if (args.column.index === 5 && val > 0) {
            args.cell.style.color = 'whitesmoke';
            args.cell.bgColor = val >= 45 ? '#DC143C' : '#00802B';
        }
        if (args.column.index === 6 && val > 0) {
            args.cell.style.color = 'whitesmoke';
            args.cell.bgColor = '#DC143C';
        }
        if (args.column.index === 2 && args.data.ConteggioCampione !== undefined) {
            const testo = args.cell.innerText;
            args.cell.innerHTML = `${testo}<span style="font-size:0.65em;margin-left:5px">(${args.data.ConteggioCampione})</span>`;
        }
    }
    onQueryCellInfoProvincePeritorUnipol(args) {
        // Perito level-2 rows inside Unipol province childGrid
        // Cols: 0=NominativoPerito, 1=LiquidatoMedio, 2=DeltaObiettivoKPI4, 3=PercScaricoAnnuale, 4=TempoMedioRestituzione, 5=DeltaObiettivoKPI2, 6=PercIncidenzaConcordato
        args.cell.style.color = args.column.index === 0 ? '#133B95' : 'purple';
        args.cell.style.fontSize = '1.0vw';
        args.cell.style.fontWeight = 'bold';
        if (args.column.index >= 1 && args.column.index <= 6) {
            args.cell.innerText = parseFloat(args.cell.innerText).toLocaleString('it-IT');
            if (args.column.index === 3 || args.column.index === 6)
                args.cell.innerText += '%';
        }
        if (args.cell.innerText === 'NaN' || args.cell.innerText === '%' || args.cell.innerText === 'NaN%') {
            args.cell.innerText = '';
            return;
        }
        const sogliaLiqPerito =
            this.activeTipoSinistro === 'EVENTO NATURALE' ? 1400 :
            this.activeTipoSinistro === 'ALTRI RAMI ELEMENTARI' ? 1400 : 1250;
        const val = parseFloat(args.cell.innerText.replace(/\./g, '').replace(',', '.').replace('%', ''));
        if (args.column.index === 1 && val > 0) {
            args.cell.style.color = 'whitesmoke';
            args.cell.bgColor = val > sogliaLiqPerito ? '#DC143C' : '#00802B';
        }
        if (args.column.index === 2 && val > 0) {
            args.cell.style.color = 'whitesmoke';
            args.cell.bgColor = '#DC143C';
        }
        if (args.column.index === 4 && val > 0) {
            args.cell.style.color = 'whitesmoke';
            args.cell.bgColor = val >= 45 ? '#DC143C' : '#00802B';
        }
        if (args.column.index === 5 && val > 0) {
            args.cell.style.color = 'whitesmoke';
            args.cell.bgColor = '#DC143C';
        }
        if (args.column.index === 1 && args.data.ConteggioCampione !== undefined) {
            const testo = args.cell.innerText;
            args.cell.innerHTML = `${testo}<span style="font-size:0.65em;margin-left:5px">(${args.data.ConteggioCampione})</span>`;
        }
    }
    onDataboundProvince(args) {
        for (let ind = 0; ind <= 8; ind++) {
            const cols = document.getElementById('GridProvince')?.querySelectorAll('.e-columnheader')[0]?.children;
            if (cols && cols[ind]) cols[ind].style.backgroundColor = 'Linen';
        }
    }
    onDataboundProvincePerito(args) {
        for (let ind = 0; ind <= 6; ind++) {
            const col = this.element?.querySelectorAll('.e-columnheader')[0]?.children[ind];
            if (col) col.style.backgroundColor = 'Linen';
        }
    }
    onRowDataboundProvince(args) {
        const filter = args.data.ProvinciaCorta;
        const activeGrid = this.activeChildGridProvince || this.childGridProvince;
        const childrecord = new DataManager(activeGrid.dataSource)
            .executeLocal(new Query().where('ProvinciaCorta', 'equal', filter, true));
        if (childrecord.length === 0) {
            args.row.querySelector('td').innerHTML = ' ';
            args.row.querySelector('td').className = 'e-customizedExpandcell';
        }
    }
    onQueryCellInfo6(args) {
        args.cell.style.color = args.column.index === 0 ? '#133B95' : 'purple';
        args.cell.style.fontSize = '1.0vw';
        args.cell.style.fontWeight = 'bold';   
        if (args.column.index === 1 ||  args.column.index === 2 ||  args.column.index === 3 ||  args.column.index === 4 || args.column.index === 5 
            || args.column.index === 6) {
            args.cell.innerText = parseFloat(args.cell.innerText).toLocaleString('it-IT');  
            if (args.column.index === 3 || args.column.index === 6)
                 args.cell.innerText += '%';
        }
        if (args.cell.innerText === 'NaN' || args.cell.innerText === '%' || args.cell.innerText === 'NaN%')
            args.cell.innerText = ''; 
        if ((args.column.index === 1 && parseFloat(args.cell.innerText.replace('.', '').replace(',', '.')) > 0 
            && parseFloat(args.cell.innerText.replace('.', '').replace(',', '.')) > (args.data.TipoSinistro === "EVENTO NATURALE" ? 1400 :
                args.data.TipoSinistro === "ALTRI RAMI ELEMENTARI" ? 1400 : 1250)) || (args.column.index === 4 && parseInt(args.cell.innerText) > 0 
                && parseInt(args.cell.innerText) >= 45)) {
            args.cell.style.color = 'whitesmoke';
            args.cell.bgColor = '#DC143C';
        }        
        if ((args.column.index === 2 && (parseFloat(args.cell.innerText.replace(',','.')) > 0))
            || (args.column.index === 5 && parseInt(args.cell.innerText) > 0)) {    
            args.cell.style.color = 'whitesmoke';
            args.cell.bgColor = '#DC143C';
        }   
        if ((args.column.index === 1 && parseFloat(args.cell.innerText.replace('.', '').replace(',', '.')) > 0
            && parseFloat(args.cell.innerText.replace('.', '').replace(',', '.')) <= (args.data.TipoSinistro === "EVENTO NATURALE" ? 1400 :
                args.data.TipoSinistro === "ALTRI RAMI ELEMENTARI" ? 1400 : 1250)) || (args.column.index === 4 && parseInt(args.cell.innerText) > 0
                && parseInt(args.cell.innerText) < 45)) {
            args.cell.style.color = 'whitesmoke';
            args.cell.bgColor = '#00802B';
        }
        if (args.column.index === 1 && args.data.ConteggioCampione !== undefined) {
            const testo = args.cell.innerText;
            args.cell.innerHTML = `${testo}<span style="font-size:0.65em;margin-left:5px">(${args.data.ConteggioCampione})</span>`;
        }
    }
    onQueryCellInfo7(args) {
        const meseCorrente = `${new Date().getFullYear()}${String(new Date().getMonth() + 1).padStart(2, '0')}`;
        const obiettivoJSONGFRE = CurvaObiettivi.CurvaObiettivi.find(o => o.RAMO === "PERCSCARALLIANZGFRE");
        const obiettivoMensileGFRE = obiettivoJSONGFRE ? parseFloat(obiettivoJSONGFRE[meseCorrente]) : 0;
        const obiettivoJSONRCD = CurvaObiettivi.CurvaObiettivi.find(o => o.RAMO === "PERCSCARALLIANZRCD");
        const obiettivoMensileRCD = obiettivoJSONRCD ? parseFloat(obiettivoJSONRCD[meseCorrente]) : 0;

        const colFieldMap = {
            1: 'LiquidatoMedioGFRE',
            2: 'DeltaObiettivoKPI2',
            3: 'PercScaricoGFRE',
            4: 'DeltaObiettivoKPI1',
            5: 'PercScaricoHome30GG',
            6: 'DeltaObiettivoKPI330',
            7: 'PercScaricoHome45GG',
            8: 'DeltaObiettivoKPI345',
            9: 'PercScaricoRCD',
            10: 'DeltaObiettivoKPI4',
            11: 'PercScaricoVideoperiziaHome',
            12: 'DeltaObiettivoKPI5'
        };

        // Colonna senza field (es. bottone province) — non toccare il template React
        if (!args.column.field) return;

        args.cell.style.color = args.column.index === 0 ? '#133B95' : 'purple';
        args.cell.style.fontSize = '1.0vw';
        args.cell.style.fontWeight = 'bold';

        const getNumericValue = () => {
            const field = colFieldMap[args.column.index];
            if (field && args.data && args.data[field] !== undefined && args.data[field] !== null) {
                return Number(args.data[field]);
            }
            const txt = (args.cell && args.cell.innerText) ? args.cell.innerText.toString().trim() : '';
            if (!txt) return NaN;
            const cleaned = txt.replace(/\./g, '').replace(',', '.').replace('%', '').trim();
            const n = parseFloat(cleaned);
            return isNaN(n) ? NaN : n;
        };

        const valore = getNumericValue();

        if (isNaN(valore)) {
            args.cell.innerText = args.cell.innerText && args.cell.innerText.trim() ? args.cell.innerText : '';
            return;
        }

        const isPercentColumn = [3,5,7,9,11].includes(args.column.index);
        const isIntegerColumn = [2,4,6,8,10,12].includes(args.column.index);

        // --- FORMATTARE IL VALORE
        if (valore === 0) {
            args.cell.innerText = isPercentColumn ? '0%' : '0';
            args.cell.bgColor = '';
            args.cell.style.color = args.column.index === 0 ? '#133B95' : 'purple';
            return;
        }

        if (isPercentColumn) {
            args.cell.innerText = Number.isInteger(valore)
                ? valore.toLocaleString('it-IT') + '%'
                : valore.toLocaleString('it-IT', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + '%';
        } else if (isIntegerColumn) {
            args.cell.innerText = Math.round(valore).toLocaleString('it-IT');
        } else {
            args.cell.innerText = Number(valore).toLocaleString('it-IT', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        }

        if (args.column.index === 1 && args.data.ConteggioCampionGFRE !== undefined) {
            const testo = args.cell.innerText;
            args.cell.innerHTML = `${testo}<span style="font-size:0.65em;margin-left:5px">(${args.data.ConteggioCampionGFRE})</span>`;
        }

        // --- CONDIZIONI ROSSO
        const isRed =
            (args.column.index === 1 && valore > 1679) ||
            (args.column.index === 3 && valore < obiettivoMensileGFRE) ||
            (args.column.index === 5 && valore < 75) ||
            (args.column.index === 6 && valore < 75) ||
            (args.column.index === 7 && valore < 80) ||
            (args.column.index === 8 && valore < 80) ||
            (args.column.index === 9 && valore < obiettivoMensileRCD) ||
            (args.column.index === 11 && valore < 45) ||
            ([2,4,6,8,10,12].includes(args.column.index) && valore > 0);

        if (isRed) {
            args.cell.style.color = 'whitesmoke';
            args.cell.bgColor = '#DC143C';
            // Celle delta KPI3 (col 6 = 30gg, col 8 = 45gg): rendi cliccabili
            if ((args.column.index === 6 || args.column.index === 8) && !args.data.NominativoPerito) {
                const giorni = args.column.index === 6 ? 30 : 45;
                const idPerito = args.data?.id_perito || null;
                args.cell.style.cursor = 'pointer';
                args.cell.style.textDecoration = 'underline';
                args.cell.classList.add('kpi-glow-pulse');
                args.cell.title = `Clicca per vedere i sinistri potenziali chiusura ${giorni} GG`;
                args.cell.onclick = () => this.openSinistriPotenziali(giorni, idPerito);
            }
            return;
        }

        // --- CONDIZIONI VERDE
        const isGreen =
            (args.column.index === 1 && valore <= 1679) ||
            (args.column.index === 3 && valore >= obiettivoMensileGFRE) ||
            (args.column.index === 5 && valore >= 75) ||
            (args.column.index === 6 && valore >= 75) ||
            (args.column.index === 7 && valore >= 80) ||
            (args.column.index === 8 && valore >= 80) ||
            (args.column.index === 9 && valore >= obiettivoMensileRCD) ||
            (args.column.index === 11 && valore >= 45);

        if (isGreen) {
            args.cell.style.color = 'whitesmoke';
            args.cell.bgColor = '#00802B';
        }
    }
    onDatabound(args) {
        const gridId = 'GridObiettivi';
        
        try {
            const header0 = document.getElementById(gridId).querySelectorAll('.e-columnheader')[0];
            const header1 = document.getElementById(gridId).querySelectorAll('.e-columnheader')[1];
            
            if (!header0 || !header1) return;
            
            // Colora header fissi (Compagnia)
            if (header0.children[0]) header0.children[0].style.backgroundColor = 'Linen';
            if (header0.children[1]) header0.children[1].style.backgroundColor = 'Linen';
            if (header1.children[0]) header1.children[0].style.backgroundColor = 'Linen';
            
            // ✅ Colora TUTTE le sezioni con indici FISSI
            // AC = colonna 2, sub-headers 1,2,3
            if (header0.children[2]) header0.children[2].style.backgroundColor = RAGGRUPPAMENTI_CONFIG.AC.color;
            for (let ind = 1; ind <= 3; ind++) {
                if (header1.children[ind]) header1.children[ind].style.backgroundColor = RAGGRUPPAMENTI_CONFIG.AC.color;
            }
            
            // RE = colonna 3, sub-headers 4,5,6
            if (header0.children[3]) header0.children[3].style.backgroundColor = RAGGRUPPAMENTI_CONFIG.RE.color;
            for (let ind = 4; ind <= 6; ind++) {
                if (header1.children[ind]) header1.children[ind].style.backgroundColor = RAGGRUPPAMENTI_CONFIG.RE.color;
            }
            
            // RC = colonna 4, sub-headers 7,8,9
            if (header0.children[4]) header0.children[4].style.backgroundColor = RAGGRUPPAMENTI_CONFIG.RC.color;
            for (let ind = 7; ind <= 9; ind++) {
                if (header1.children[ind]) header1.children[ind].style.backgroundColor = RAGGRUPPAMENTI_CONFIG.RC.color;
            }
            
            // EN = colonna 5, sub-headers 10,11,12 ✅ NUOVO
            if (header0.children[5]) header0.children[5].style.backgroundColor = RAGGRUPPAMENTI_CONFIG.EN.color;
            for (let ind = 10; ind <= 12; ind++) {
                if (header1.children[ind]) header1.children[ind].style.backgroundColor = RAGGRUPPAMENTI_CONFIG.EN.color;
            }
            
            // Header comandi (colonna 6)
            if (header0.children[6]) header0.children[6].style.backgroundColor = 'Linen';
            
            // Timestamp
            document.getElementById('TestoDatiAggiornati').innerText = 
                'Dati aggiornati al ' + new Date().getDate().toString().padStart(2, '0') + '/' + 
                (new Date().getMonth() + 1).toString().padStart(2, '0') + '/' + 
                new Date().getFullYear().toString() + ' alle ore ' + 
                new Date().getHours().toString() + ':' + 
                new Date().getMinutes().toString().padStart(2, '0');
        } catch (error) {
            console.warn('Errore in onDatabound:', error);
        }
    }
    onDatabound2(args) {
        if (!this.element || !this.element.querySelectorAll) {
            return;
        }

        try {
            const header0 = this.element.querySelectorAll('.e-columnheader')[0];
            const header1 = this.element.querySelectorAll('.e-columnheader')[1];
            
            if (!header0 || !header1) return;
            
            // Header fisso
            if (header0.children[0]) header0.children[0].style.backgroundColor = 'Linen';
            
            // AC = colonna 1, sub-headers 0,1,2
            if (header0.children[1]) header0.children[1].style.backgroundColor = RAGGRUPPAMENTI_CONFIG.AC.color;
            for (let ind = 0; ind <= 2; ind++) {
                if (header1.children[ind]) header1.children[ind].style.backgroundColor = RAGGRUPPAMENTI_CONFIG.AC.color;
            }
            
            // RE = colonna 2, sub-headers 3,4,5
            if (header0.children[2]) header0.children[2].style.backgroundColor = RAGGRUPPAMENTI_CONFIG.RE.color;
            for (let ind = 3; ind <= 5; ind++) {
                if (header1.children[ind]) header1.children[ind].style.backgroundColor = RAGGRUPPAMENTI_CONFIG.RE.color;
            }
            
            // RC = colonna 3, sub-headers 6,7,8
            if (header0.children[3]) header0.children[3].style.backgroundColor = RAGGRUPPAMENTI_CONFIG.RC.color;
            for (let ind = 6; ind <= 8; ind++) {
                if (header1.children[ind]) header1.children[ind].style.backgroundColor = RAGGRUPPAMENTI_CONFIG.RC.color;
            }
            
            // EN = colonna 4, sub-headers 9,10,11 ✅
            if (header0.children[4]) header0.children[4].style.backgroundColor = RAGGRUPPAMENTI_CONFIG.EN.color;
            for (let ind = 9; ind <= 11; ind++) {
                if (header1.children[ind]) header1.children[ind].style.backgroundColor = RAGGRUPPAMENTI_CONFIG.EN.color;
            }
        } catch (error) {
            console.warn('Errore in onDatabound2:', error);
        }
    }    
    onDatabound3(args) {   
        const gridId = 'GridObiettiviAree';
        
        try {
            const header0 = document.getElementById(gridId).querySelectorAll('.e-columnheader')[0];
            const header1 = document.getElementById(gridId).querySelectorAll('.e-columnheader')[1];
            
            if (!header0 || !header1) return;
            
            // Header fissi
            if (header0.children[0]) header0.children[0].style.backgroundColor = 'Linen';
            if (header0.children[1]) header0.children[1].style.backgroundColor = 'Linen';
            if (header1.children[0]) header1.children[0].style.backgroundColor = 'Linen';
            
            // AC
            if (header0.children[2]) header0.children[2].style.backgroundColor = RAGGRUPPAMENTI_CONFIG.AC.color;
            for (let ind = 1; ind <= 3; ind++) {
                if (header1.children[ind]) header1.children[ind].style.backgroundColor = RAGGRUPPAMENTI_CONFIG.AC.color;
            }
            
            // RE
            if (header0.children[3]) header0.children[3].style.backgroundColor = RAGGRUPPAMENTI_CONFIG.RE.color;
            for (let ind = 4; ind <= 6; ind++) {
                if (header1.children[ind]) header1.children[ind].style.backgroundColor = RAGGRUPPAMENTI_CONFIG.RE.color;
            }
            
            // RC
            if (header0.children[4]) header0.children[4].style.backgroundColor = RAGGRUPPAMENTI_CONFIG.RC.color;
            for (let ind = 7; ind <= 9; ind++) {
                if (header1.children[ind]) header1.children[ind].style.backgroundColor = RAGGRUPPAMENTI_CONFIG.RC.color;
            }
            
            // EN ✅
            if (header0.children[5]) header0.children[5].style.backgroundColor = RAGGRUPPAMENTI_CONFIG.EN.color;
            for (let ind = 10; ind <= 12; ind++) {
                if (header1.children[ind]) header1.children[ind].style.backgroundColor = RAGGRUPPAMENTI_CONFIG.EN.color;
            }
        } catch (error) {
            console.warn('Errore in onDatabound3:', error);
        }
    }
    onDatabound4(args) {       
        for (let ind=0;ind<=3;ind++)
             document.getElementById('GridKPIIntesa').querySelectorAll('.e-columnheader')[0].children[ind].style.backgroundColor = 'Linen';  
    }
    onDatabound5(args) {       
        this.element.querySelectorAll('.e-columnheader')[0].children[0].style.backgroundColor = 'Linen';    
        this.element.querySelectorAll('.e-columnheader')[0].children[1].style.backgroundColor = 'Linen';    
        this.element.querySelectorAll('.e-columnheader')[0].children[2].style.backgroundColor = 'Linen';    
    }
    onDatabound6(args) {
        for (let ind=0;ind<=8;ind++)
             document.getElementById('GridKPIGenerali').querySelectorAll('.e-columnheader')[0].children[ind].style.backgroundColor = 'Linen';
    }
    onDataboundHDI(args) {
        for (let ind=0;ind<=8;ind++)
             document.getElementById('GridKPIHDI').querySelectorAll('.e-columnheader')[0].children[ind].style.backgroundColor = 'Linen';
    }
    onDataboundSARA(args) {
        for (let ind=0;ind<=8;ind++)
             document.getElementById('GridKPISARA').querySelectorAll('.e-columnheader')[0].children[ind].style.backgroundColor = 'Linen';
    }
    onDatabound7(args) {       
        this.element.querySelectorAll('.e-columnheader')[0].children[0].style.backgroundColor = 'Linen';    
        this.element.querySelectorAll('.e-columnheader')[0].children[1].style.backgroundColor = 'Linen';    
        this.element.querySelectorAll('.e-columnheader')[0].children[2].style.backgroundColor = 'Linen';  
        this.element.querySelectorAll('.e-columnheader')[0].children[3].style.backgroundColor = 'Linen';    
        this.element.querySelectorAll('.e-columnheader')[0].children[4].style.backgroundColor = 'Linen';    
        this.element.querySelectorAll('.e-columnheader')[0].children[5].style.backgroundColor = 'Linen';    
        this.element.querySelectorAll('.e-columnheader')[0].children[6].style.backgroundColor = 'Linen';    
    }
    onDatabound8(args) {
        for (let ind=0;ind<=8;ind++)
             document.getElementById('GridKPIUnipol').querySelectorAll('.e-columnheader')[0].children[ind].style.backgroundColor = 'Linen';
    }
    onDatabound9(args) {       
        this.element.querySelectorAll('.e-columnheader')[0].children[0].style.backgroundColor = 'Linen';    
        this.element.querySelectorAll('.e-columnheader')[0].children[1].style.backgroundColor = 'Linen';    
        this.element.querySelectorAll('.e-columnheader')[0].children[2].style.backgroundColor = 'Linen';  
        this.element.querySelectorAll('.e-columnheader')[0].children[3].style.backgroundColor = 'Linen';    
        this.element.querySelectorAll('.e-columnheader')[0].children[4].style.backgroundColor = 'Linen';    
        this.element.querySelectorAll('.e-columnheader')[0].children[5].style.backgroundColor = 'Linen';    
        this.element.querySelectorAll('.e-columnheader')[0].children[6].style.backgroundColor = 'Linen';    
    }
    onDatabound10(args) {
        const cols = document.getElementById('GridKPIAllianz')?.querySelectorAll('.e-columnheader')[0]?.children;
        for (let ind = 0; ind <= 14; ind++)
            if (cols && cols[ind]) cols[ind].style.backgroundColor = 'Linen';
    }
    onDatabound11(args) {
        this.element.querySelectorAll('.e-columnheader')[0].children[0].style.backgroundColor = 'Linen';    
        this.element.querySelectorAll('.e-columnheader')[0].children[1].style.backgroundColor = 'Linen';    
        this.element.querySelectorAll('.e-columnheader')[0].children[2].style.backgroundColor = 'Linen';  
        this.element.querySelectorAll('.e-columnheader')[0].children[3].style.backgroundColor = 'Linen';    
        this.element.querySelectorAll('.e-columnheader')[0].children[4].style.backgroundColor = 'Linen';    
        this.element.querySelectorAll('.e-columnheader')[0].children[5].style.backgroundColor = 'Linen';    
        this.element.querySelectorAll('.e-columnheader')[0].children[6].style.backgroundColor = 'Linen'; 
        this.element.querySelectorAll('.e-columnheader')[0].children[7].style.backgroundColor = 'Linen'; 
        this.element.querySelectorAll('.e-columnheader')[0].children[8].style.backgroundColor = 'Linen'; 
        this.element.querySelectorAll('.e-columnheader')[0].children[9].style.backgroundColor = 'Linen'; 
        this.element.querySelectorAll('.e-columnheader')[0].children[10].style.backgroundColor = 'Linen'; 
        this.element.querySelectorAll('.e-columnheader')[0].children[11].style.backgroundColor = 'Linen'; 
        this.element.querySelectorAll('.e-columnheader')[0].children[12].style.backgroundColor = 'Linen'; 
    }
    toolbarClick(args) {
        switch (args.item.properties.prefixIcon) {
            case 'e-pdfexport':
                this.gridInstance.pdfExport();
                break;
            case 'e-excelexport':
                this.gridInstance.excelExport();
                break;
        }
    }
    toolbarClick2(args) {
        switch (args.item.properties.prefixIcon) {
            case 'e-pdfexport':
                this.gridInstance2.pdfExport();
                break;
            case 'e-excelexport':
                this.gridInstance2.excelExport();
                break;
        }
    }
    toolbarClick3(args) {
        switch (args.item.properties.prefixIcon) {
            case 'e-pdfexport':
                this.gridInstance3.pdfExport();
                break;
            case 'e-excelexport':
                this.gridInstance3.excelExport();
                break;
        }
    }
    toolbarClick4(args) {
        switch (args.item.properties.prefixIcon) {
            case 'e-pdfexport':
                this.gridInstance4.pdfExport();
                break;
            case 'e-excelexport':
                this.gridInstance4.excelExport();
                break;
        }
    }
    toolbarClick5(args) {
        switch (args.item.properties.prefixIcon) {
            case 'e-pdfexport':
                this.gridInstance5.pdfExport();
                break;
            case 'e-excelexport':
                this.gridInstance5.excelExport();
                break;
        }
    }
    toolbarClick6(args) {
        switch (args.item.properties.prefixIcon) {
            case 'e-pdfexport':
                this.gridInstance6.pdfExport();
                break;
            case 'e-excelexport':
                this.gridInstance6.excelExport();
                break;
        }
    }
    toolbarClickHDI(args) {
        switch (args.item.properties.prefixIcon) {
            case 'e-pdfexport':
                this.gridInstanceHDI.pdfExport();
                break;
            case 'e-excelexport':
                this.gridInstanceHDI.excelExport();
                break;
        }
    }
    toolbarClickSARA(args) {
        switch (args.item.properties.prefixIcon) {
            case 'e-pdfexport':
                this.gridInstanceSARA.pdfExport();
                break;
            case 'e-excelexport':
                this.gridInstanceSARA.excelExport();
                break;
        }
    }
    toolbarClickRealeMutua(args) {
        switch (args.item.properties.prefixIcon) {
            case 'e-pdfexport':
                this.gridInstanceRealeMutua.pdfExport();
                break;
            case 'e-excelexport':
                this.gridInstanceRealeMutua.excelExport();
                break;
        }
    }
    onRowDatabound(args) {
        $($(args.row).find('button')[1]).hide();
        $($(args.row).find('button')[2]).hide();
        $($(args.row).find('button')[3]).hide();
        $($(args.row).find('button')[4]).hide();
        $($(args.row).find('button')[5]).hide();
        $($(args.row).find('button')[6]).hide();
        $($(args.row).find('button')[7]).hide();
        $($(args.row).find('button')[8]).hide();
        const filter = args.data.IdCompagnia;
        const childrecord = new DataManager(this.childGrid.dataSource)
        .executeLocal(new Query().where("IdCompagnia", "equal", filter, true));
        if (childrecord.length === 0) {
            args.row.querySelector('td').innerHTML=" ";
            args.row.querySelector('td').className = "e-customizedExpandcell";
        }
        if (args.data.DescrCompagnia === 'INTESA SANPAOLO PROTEZIONE SpA') {
            $($(args.row).find('button')[1]).show();
        }
        if (args.data.DescrCompagnia === 'GENERALI ITALIA S.P.A.') {
            $($(args.row).find('button')[2]).show();
        }
        if (args.data.DescrCompagnia === 'UNIPOL ASSICURAZIONI S.p.A.') {
            $($(args.row).find('button')[3]).show();
        }
         if (args.data.DescrCompagnia === 'ALLIANZ S.P.A') {
            $($(args.row).find('button')[4]).show();
         }
         if ((args.data.DescrCompagnia || '').toUpperCase().includes('VITTORIA')) {
            $($(args.row).find('button')[5]).show();
         }
         if (args.data.DescrCompagnia === 'HDI ASSICURAZIONI') {
            $($(args.row).find('button')[6]).show();
         }
         if (args.data.DescrCompagnia === 'SARA ASSICURAZIONI') {
            $($(args.row).find('button')[7]).show();
         }
         if (args.data.DescrCompagnia === 'GRUPPO REALE MUTUA') {
            $($(args.row).find('button')[8]).show();
         }
    }
    onRowDatabound2(args) {       
        const filter = args.data.DescrArea;
        const childrecord = new DataManager(this.childGrid.dataSource)
        .executeLocal(new Query().where("DescrArea", "equal", filter, true));
        if (childrecord.length === 0) {
            args.row.querySelector('td').innerHTML=" ";
            args.row.querySelector('td').className = "e-customizedExpandcell";
        }
    }
    onRowDatabound3(args) {       
        const filter = args.data.TipoSinistro;
        const childrecord = new DataManager(this.childGrid.dataSource)
        .executeLocal(new Query().where("TipoSinistro", "equal", filter, true));
        if (childrecord.length === 0) {
            args.row.querySelector('td').innerHTML=" ";
            args.row.querySelector('td').className = "e-customizedExpandcell";
        }
    }
    onRowDatabound4(args) {       
        const filter = args.data.TipoSinistro;
        const childrecord = new DataManager(this.childGrid.dataSource)
        .executeLocal(new Query().where("TipoSinistro", "equal", filter, true));
        if (childrecord.length === 0) {
            args.row.querySelector('td').innerHTML=" ";
            args.row.querySelector('td').className = "e-customizedExpandcell";
        }
    }
    onCommandClick(args){
        if (args.commandColumn.buttonOption.iconCss?.indexOf('fa-chart-area') > -1) {
            this.dialogInstance.header = `<span style='font-size: 2vw;font-weight: bold; color: #133B95'>SITUAZIONE OBIETTIVI PER AREE COMPAGNIA ${args.rowData.DescrCompagnia}</span>`;  
            this.dialogInstance.width = '98%';
            this.dialogInstance.height = '90%';
            this.dialogInstance.minHeight = '90%';
            this.dialogInstance.buttons = []; 
            this.dialogInstance.beforeOpen = (args2) => {
                const container = document.getElementById('defaultDialogContentObiettivi');
                const root = createRoot(container); 
                root.unmount();
            };
            this.dialogInstance.open = (args2) => { 
                const container = document.getElementById('defaultDialogContentObiettivi');
                const root = createRoot(container); 
                root.render(<CallbackWrapper callback={() => {
                    this.caricaDati2(args.rowData.IdCompagnia);
                }}>{this.GrigliaObiettiviAreeRender()}</CallbackWrapper>); 
            };
            this.dialogInstance.show();   
        }
        if (args.commandColumn.id === 'KPI-Intesa') {
            this.dialogInstance.header = `<span style='font-size: 2vw;font-weight: bold; color: #133B95'>SITUAZIONE KPI COMPAGNIA ${args.rowData.DescrCompagnia}</span>`;  
            this.dialogInstance.width = '80%';
            this.dialogInstance.height = '95%';
            this.dialogInstance.minHeight = '95%';
            this.dialogInstance.buttons = []; 
            this.dialogInstance.beforeOpen = (args2) => {
                const container = document.getElementById('defaultDialogContentObiettivi');
                const root = createRoot(container); 
                root.unmount();
            };
            this.dialogInstance.open = (args2) => { 
                const container = document.getElementById('defaultDialogContentObiettivi');
                const root = createRoot(container); 
                root.render(<CallbackWrapper callback={() => {
                    this.caricaDati3();
                }}>{this.GrigliaKPIIntesaRender()}</CallbackWrapper>); 
            };
            this.dialogInstance.show();
        }
        if (args.commandColumn.id === 'KPI-Generali') {
            this.dialogInstance.header = `<span style='font-size: 2vw;font-weight: bold; color: #133B95'>SITUAZIONE KPI COMPAGNIA ${args.rowData.DescrCompagnia}</span>`;  
            this.dialogInstance.width = '85%';
            this.dialogInstance.height = '95%';
            this.dialogInstance.minHeight = '95%';
            this.dialogInstance.buttons = []; 
            this.dialogInstance.beforeOpen = (args2) => {
                const container = document.getElementById('defaultDialogContentObiettivi');
                const root = createRoot(container); 
                root.unmount();
            };
            this.dialogInstance.open = (args2) => { 
                const container = document.getElementById('defaultDialogContentObiettivi');
                const root = createRoot(container); 
                root.render(<CallbackWrapper callback={() => {
                    this.caricaDati4();
                }}>{this.GrigliaKPIGeneraliRender()}</CallbackWrapper>); 
            };
            this.dialogInstance.show();
        }
        if (args.commandColumn.id === 'KPI-Unipol') {
            this.dialogInstance.header = `<span style='font-size: 2vw;font-weight: bold; color: #133B95'>SITUAZIONE KPI COMPAGNIA ${args.rowData.DescrCompagnia}</span>`;  
            this.dialogInstance.width = '80%';
            this.dialogInstance.height = '95%';
            this.dialogInstance.minHeight = '95%';
            this.dialogInstance.buttons = []; 
            this.dialogInstance.beforeOpen = (args2) => {
                const container = document.getElementById('defaultDialogContentObiettivi');
                const root = createRoot(container); 
                root.unmount();
            };
            this.dialogInstance.open = (args2) => { 
                const container = document.getElementById('defaultDialogContentObiettivi');
                const root = createRoot(container); 
                root.render(<CallbackWrapper callback={() => {
                    this.caricaDati5();
                }}>{this.GrigliaKPIUnipolRender()}</CallbackWrapper>); 
            };
            this.dialogInstance.show();
        }
        if (args.commandColumn.id === 'KPI-Allianz') {
            this.dialogInstance.header = `<span style='font-size: 2vw;font-weight: bold; color: #133B95'>SITUAZIONE KPI COMPAGNIA ${args.rowData.DescrCompagnia}</span>`;  
            this.dialogInstance.width = '100%';
            this.dialogInstance.height = '95%';
            this.dialogInstance.minHeight = '95%';
            this.dialogInstance.buttons = []; 
            this.dialogInstance.beforeOpen = (args2) => {
                const container = document.getElementById('defaultDialogContentObiettivi');
                const root = createRoot(container); 
                root.unmount();
            };
            this.dialogInstance.open = (args2) => { 
                const container = document.getElementById('defaultDialogContentObiettivi');
                const root = createRoot(container); 
                root.render(<CallbackWrapper callback={() => {
                    this.caricaDati6();
                }}>{this.GrigliaKPIAllianzRender()}</CallbackWrapper>);
            };
            this.dialogInstance.show();
        }
        if (args.commandColumn.id === 'KPI-Vittoria') {
            this.dialogInstance.header = `<span style='font-size: 2vw;font-weight: bold; color: #133B95'>SITUAZIONE KPI COMPAGNIA ${args.rowData.DescrCompagnia}</span>`;
            this.dialogInstance.width = '85%';
            this.dialogInstance.height = '95%';
            this.dialogInstance.minHeight = '95%';
            this.dialogInstance.buttons = [];
            this.dialogInstance.beforeOpen = (args2) => {
                const container = document.getElementById('defaultDialogContentObiettivi');
                const root = createRoot(container);
                root.unmount();
            };
            this.dialogInstance.open = (args2) => {
                const container = document.getElementById('defaultDialogContentObiettivi');
                const root = createRoot(container);
                root.render(<CallbackWrapper callback={() => {
                    this.caricaDatiVittoria();
                }}>{this.GrigliaKPIVittoriaRender()}</CallbackWrapper>);
            };
            this.dialogInstance.show();
        }
        if (args.commandColumn.id === 'KPI-HDI') {
            this.dialogInstance.header = `<span style='font-size: 2vw;font-weight: bold; color: #133B95'>SITUAZIONE KPI COMPAGNIA ${args.rowData.DescrCompagnia}</span>`;
            this.dialogInstance.width = '85%';
            this.dialogInstance.height = '95%';
            this.dialogInstance.minHeight = '95%';
            this.dialogInstance.buttons = [];
            this.dialogInstance.beforeOpen = (args2) => {
                const container = document.getElementById('defaultDialogContentObiettivi');
                const root = createRoot(container);
                root.unmount();
            };
            this.dialogInstance.open = (args2) => {
                const container = document.getElementById('defaultDialogContentObiettivi');
                const root = createRoot(container);
                root.render(<CallbackWrapper callback={() => {
                    this.caricaDatiHDI();
                }}>{this.GrigliaKPIHDIRender()}</CallbackWrapper>);
            };
            this.dialogInstance.show();
        }
        if (args.commandColumn.id === 'KPI-SARA') {
            this.dialogInstance.header = `<span style='font-size: 2vw;font-weight: bold; color: #133B95'>SITUAZIONE KPI COMPAGNIA ${args.rowData.DescrCompagnia}</span>`;
            this.dialogInstance.width = '85%';
            this.dialogInstance.height = '95%';
            this.dialogInstance.minHeight = '95%';
            this.dialogInstance.buttons = [];
            this.dialogInstance.beforeOpen = (args2) => {
                const container = document.getElementById('defaultDialogContentObiettivi');
                const root = createRoot(container);
                root.unmount();
            };
            this.dialogInstance.open = (args2) => {
                const container = document.getElementById('defaultDialogContentObiettivi');
                const root = createRoot(container);
                root.render(<CallbackWrapper callback={() => {
                    this.caricaDatiSARA();
                }}>{this.GrigliaKPISARARender()}</CallbackWrapper>);
            };
            this.dialogInstance.show();
        }
        if (args.commandColumn.id === 'KPI-RealeMutua') {
            this.dialogInstance.header = `<span style='font-size: 2vw;font-weight: bold; color: #133B95'>SITUAZIONE KPI COMPAGNIA ${args.rowData.DescrCompagnia}</span>`;
            this.dialogInstance.width = '90%';
            this.dialogInstance.height = '95%';
            this.dialogInstance.minHeight = '95%';
            this.dialogInstance.buttons = [];
            this.dialogInstance.beforeOpen = (args2) => {
                const container = document.getElementById('defaultDialogContentObiettivi');
                const root = createRoot(container);
                root.unmount();
            };
            this.dialogInstance.open = (args2) => {
                const container = document.getElementById('defaultDialogContentObiettivi');
                const root = createRoot(container);
                root.render(<CallbackWrapper callback={() => {
                    this.caricaDatiRealeMutua();
                }}>{this.GrigliaKPIRealeMutuaRender()}</CallbackWrapper>);
            };
            this.dialogInstance.show();
        }
    }
    ddlPeritiToolbar(args) {
        if (!this.periti) {
            return <div style={{ width: '20vw', height: '32px' }}></div>;
        }
        
        return (
            <div key="ddl-periti-wrapper" style={{ display: 'inline-block', marginRight: '15px' }}>
                <DropDownListComponent 
                    id='ddlPeriti' 
                    key='ddlPeriti-main'
                    fields={this.ddlFields} 
                    ref={ddlObj => {
                        if (ddlObj && !ddlObj.isDestroyed) {
                            this.ddlInstance = ddlObj;
                        }
                    }}
                    dataSource={this.periti} 
                    change={this.onChangePerito.bind(this)} 
                    allowFiltering={true} 
                    filterType='Contains'
                    style={{ width: '20vw' }} 
                    placeholder="Selezionare un perito da visualizzare" 
                    floatLabelType='always' 
                    popupHeight="250px" 
                    cssClass='e-outline'
                    enablePersistence={false}
                />
            </div>
        );
    }
    ddlPeritiToolbar2(args) {
        if (!this.periti) {
            return <div style={{ width: '20vw', height: '32px' }}></div>;
        }
        
        return (
            <div key="ddl-periti2-wrapper" style={{ display: 'inline-block', marginRight: '15px' }}>
                <DropDownListComponent 
                    id='ddlPeriti2' 
                    key='ddlPeriti-aree'
                    fields={this.ddlFields} 
                    ref={ddlObj => {
                        if (ddlObj && !ddlObj.isDestroyed) {
                            this.ddlInstance3 = ddlObj;
                        }
                    }}
                    dataSource={this.periti} 
                    change={this.onChangePerito2.bind(this)} 
                    allowFiltering={true} 
                    filterType='Contains'
                    style={{ width: '20vw' }} 
                    placeholder="Selezionare un perito da visualizzare" 
                    floatLabelType='always' 
                    popupHeight="250px" 
                    cssClass='e-outline'
                    enablePersistence={false}
                />
            </div>
        );
    }
    chkPeritiObiettToolbar(args) { 
        return (
            <div key="chk-obiett-wrapper" style={{ display: 'inline-block', marginLeft: '30px', marginRight: '15px' }}>
                <CheckBoxComponent 
                    id='chkPeritiObiett' 
                    key='chkPeritiObiett-main'
                    label='Visualizza periti CON obiettivo raggiunto' 
                    change={this.onChangeChkPeritiObiett.bind(this)}
                    enablePersistence={false}
                />
            </div>
        );   
    }
    chkPeritiObiettToolbar2(args) { 
        return (
            <div key="chk-obiett2-wrapper" style={{ display: 'inline-block', marginLeft: '30px', marginRight: '15px' }}>
                <CheckBoxComponent 
                    id='chkPeritiObiett2' 
                    key='chkPeritiObiett-aree'
                    label='Visualizza periti CON obiettivo raggiunto' 
                    change={this.onChangeChkPeritiObiett2.bind(this)}
                    enablePersistence={false}
                />
            </div>
        );   
    }
    chkPeritiNoObiettToolbar(args) { 
        return (
            <div key="chk-no-obiett-wrapper" style={{ display: 'inline-block', marginRight: '15px' }}>
                <CheckBoxComponent 
                    id='chkPeritiNoObiett' 
                    key='chkPeritiNoObiett-main'
                    label='Visualizza periti SENZA obiettivo raggiunto' 
                    change={this.onChangeChkPeritiNoObiett.bind(this)}
                    enablePersistence={false}
                />
            </div>
        );   
    }
    chkPeritiNoObiettToolbar2(args) { 
        return (
            <div key="chk-no-obiett2-wrapper" style={{ display: 'inline-block', marginRight: '15px' }}>
                <CheckBoxComponent 
                    id='chkPeritiNoObiett2' 
                    key='chkPeritiNoObiett-aree'
                    label='Visualizza periti SENZA obiettivo raggiunto' 
                    change={this.onChangeChkPeritiNoObiett2.bind(this)}
                    enablePersistence={false}
                />
            </div>
        );   
    }
    ddlGruppiColonneToolbar(args) {
        if (!this.state || !this.state.visibleColumnGroups) {
            return <div style={{ width: '16vw', height: '32px', marginRight: '15px' }}></div>;
        }
        
        return (
            <div key="ddl-gruppi-wrapper" style={{ display: 'none', marginRight: '15px' }}>
                <MultiSelectComponent 
                    id='ddlGruppiColonne' 
                    key='ddlGruppiColonne-main'
                    ref={ddl => {
                        if (ddl && !ddl.isDestroyed) {
                            this.ddlGruppiColonneInstance = ddl;
                        }
                    }}
                    dataSource={this.gruppiColonne} 
                    fields={{ text: 'Text', value: 'Value' }}
                    value={this.state.visibleColumnGroups}
                    change={this.onChangeGruppiColonne.bind(this)}
                    placeholder="Gruppi colonne (max 3)"
                    mode="CheckBox"
                    showDropDownIcon={true}
                    popupHeight="200px"
                    cssClass='e-outline'
                    style={{ width: '16vw' }}
                    enablePersistence={false}
                />
            </div>
        );
    }
    ddlGruppiColonneToolbar2(args) {
        if (!this.state || !this.state.visibleColumnGroupsAree) {
            return <div style={{ width: '16vw', height: '32px', marginRight: '15px' }}></div>;
        }
        
        return (
            <div key="ddl-gruppi2-wrapper" style={{ display: 'none', marginRight: '15px' }}>
                <MultiSelectComponent 
                    id='ddlGruppiColonne2' 
                    key='ddlGruppiColonne-aree'
                    ref={ddl => {
                        if (ddl && !ddl.isDestroyed) {
                            this.ddlGruppiColonneInstance2 = ddl;
                        }
                    }}
                    dataSource={this.gruppiColonne} 
                    fields={{ text: 'Text', value: 'Value' }}
                    value={this.state.visibleColumnGroupsAree}
                    change={this.onChangeGruppiColonne2.bind(this)}
                    placeholder="Gruppi colonne (max 3)"
                    mode="CheckBox"
                    showDropDownIcon={true}
                    popupHeight="200px"
                    cssClass='e-outline'
                    style={{ width: '22vw' }}
                    enablePersistence={false}
                />
            </div>
        );
    }
    onChangePerito(args) {
        let arrFiltrato = [];        
        if (CustomJS.isNullEmpty(args.value))
            arrFiltrato = JSON.parse(localStorage.getItem("MonitorDSObiettiviSecondoLiv"));
        else
            arrFiltrato = _.filter(JSON.parse(localStorage.getItem("MonitorDSObiettiviSecondoLiv")), elm => { return elm.IdPerito.toString() === args.value; });
        document.getElementById('GridObiettivi').ej2_instances[0].childGrid.dataSource = arrFiltrato; 
        document.getElementById('GridObiettivi').ej2_instances[0].refresh(); 
        setTimeout(() => {
            if (!CustomJS.isNullEmpty(args.value))
                document.getElementById('GridObiettivi').querySelectorAll('td.e-detailrowcollapse').forEach(elm => { 
                   elm.click();
                });
            document.getElementById('chkPeritiObiett').ej2_instances[0].checked = false;
            document.getElementById('chkPeritiObiett').ej2_instances[0].disabled = !CustomJS.isNullEmpty(args.value);
            document.getElementById('chkPeritiNoObiett').ej2_instances[0].checked = false;
            document.getElementById('chkPeritiNoObiett').ej2_instances[0].disabled = !CustomJS.isNullEmpty(args.value);
        }, 400);        
    }
    onChangePerito2(args) {
        let arrFiltrato = [];        
        if (CustomJS.isNullEmpty(args.value))
            arrFiltrato = JSON.parse(localStorage.getItem("MonitorDSObiettiviAreeSecondoLiv"));
        else
            arrFiltrato = _.filter(JSON.parse(localStorage.getItem("MonitorDSObiettiviAreeSecondoLiv")), elm => { return elm.IdPerito.toString() === args.value; });
        document.getElementById('GridObiettiviAree').ej2_instances[0].childGrid.dataSource = arrFiltrato; 
        document.getElementById('GridObiettiviAree').ej2_instances[0].refresh(); 
        setTimeout(() => {
            if (!CustomJS.isNullEmpty(args.value))
                document.getElementById('GridObiettiviAree').querySelectorAll('td.e-detailrowcollapse').forEach(elm => { 
                   elm.click();
                });
            document.getElementById('chkPeritiObiett2').ej2_instances[0].checked = false;
            document.getElementById('chkPeritiObiett2').ej2_instances[0].disabled = !CustomJS.isNullEmpty(args.value);
            document.getElementById('chkPeritiNoObiett2').ej2_instances[0].checked = false;
            document.getElementById('chkPeritiNoObiett2').ej2_instances[0].disabled = !CustomJS.isNullEmpty(args.value);
        }, 400);        
    }
    onChangeChkPeritiObiett(args) {
        let arrFiltrato = [];
        if (!args.checked)
            arrFiltrato = JSON.parse(localStorage.getItem("MonitorDSObiettiviSecondoLiv"));
        else
            arrFiltrato = _.filter(JSON.parse(localStorage.getItem("MonitorDSObiettiviSecondoLiv")), elm => { 
                return parseInt(elm.NumSinistriMancantiAC) > 0 || 
                    parseInt(elm.NumSinistriMancantiRE) > 0 || 
                    parseInt(elm.NumSinistriMancantiRC) > 0 || 
                    parseInt(elm.NumSinistriMancantiEN) > 0; 
            });
        document.getElementById('GridObiettivi').ej2_instances[0].childGrid.dataSource = arrFiltrato; 
        document.getElementById('GridObiettivi').ej2_instances[0].refresh(); 
        setTimeout(() => {
            if (args.checked)
            document.getElementById('GridObiettivi').querySelectorAll('td.e-detailrowcollapse').forEach(elm => { 
                elm.click();
            });
            document.getElementById('ddlPeriti').ej2_instances[0].enabled = !args.checked;
            document.getElementById('chkPeritiNoObiett').ej2_instances[0].disabled = args.checked;
        }, 400);     
    }
    onChangeChkPeritiObiett2(args) {
        let arrFiltrato = [];
        if (!args.checked)
            arrFiltrato = JSON.parse(localStorage.getItem("MonitorDSObiettiviAreeSecondoLiv"));
        else
            // ✅ AGGIUNGI EN al filtro
            arrFiltrato = _.filter(JSON.parse(localStorage.getItem("MonitorDSObiettiviAreeSecondoLiv")), elm => { 
                return parseInt(elm.NumSinistriMancantiAC) > 0 || 
                    parseInt(elm.NumSinistriMancantiRE) > 0 || 
                    parseInt(elm.NumSinistriMancantiRC) > 0 || 
                    parseInt(elm.NumSinistriMancantiEN) > 0; 
            });
        document.getElementById('GridObiettiviAree').ej2_instances[0].childGrid.dataSource = arrFiltrato; 
        document.getElementById('GridObiettiviAree').ej2_instances[0].refresh(); 
        setTimeout(() => {
            if (args.checked)
                document.getElementById('GridObiettiviAree').querySelectorAll('td.e-detailrowcollapse').forEach(elm => { 
                    elm.click();
                });
            document.getElementById('ddlPeriti2').ej2_instances[0].enabled = !args.checked;
            document.getElementById('chkPeritiObiett2').ej2_instances[0].disabled = args.checked;
        }, 400);     
    }
    onChangeChkPeritiNoObiett(args) {
        let arrFiltrato = [];
        if (!args.checked)
            arrFiltrato = JSON.parse(localStorage.getItem("MonitorDSObiettiviSecondoLiv"));
        else
            // ✅ AGGIUNGI EN al filtro
            arrFiltrato = _.filter(JSON.parse(localStorage.getItem("MonitorDSObiettiviSecondoLiv")), elm => { 
                return parseInt(elm.NumSinistriMancantiAC) < 0 && 
                    parseInt(elm.NumSinistriMancantiRE) < 0 && 
                    parseInt(elm.NumSinistriMancantiRC) < 0 && 
                    parseInt(elm.NumSinistriMancantiEN) < 0; 
            });
        document.getElementById('GridObiettivi').ej2_instances[0].childGrid.dataSource = arrFiltrato; 
        document.getElementById('GridObiettivi').ej2_instances[0].refresh(); 
        setTimeout(() => {
            if (args.checked)
            document.getElementById('GridObiettivi').querySelectorAll('td.e-detailrowcollapse').forEach(elm => { 
                elm.click();
            });
            document.getElementById('ddlPeriti').ej2_instances[0].enabled = !args.checked;
            document.getElementById('chkPeritiObiett').ej2_instances[0].disabled = args.checked;
        }, 400);     
    }    
    onChangeChkPeritiNoObiett2(args) {
        let arrFiltrato = [];
        if (!args.checked)
            arrFiltrato = JSON.parse(localStorage.getItem("MonitorDSObiettiviAreeSecondoLiv"));
        else
            // ✅ AGGIUNGI EN al filtro
            arrFiltrato = _.filter(JSON.parse(localStorage.getItem("MonitorDSObiettiviAreeSecondoLiv")), elm => { 
                return parseInt(elm.NumSinistriMancantiAC) < 0 && 
                    parseInt(elm.NumSinistriMancantiRE) < 0 && 
                    parseInt(elm.NumSinistriMancantiRC) < 0 && 
                    parseInt(elm.NumSinistriMancantiEN) < 0; 
            });
        document.getElementById('GridObiettiviAree').ej2_instances[0].childGrid.dataSource = arrFiltrato; 
        document.getElementById('GridObiettiviAree').ej2_instances[0].refresh(); 
        setTimeout(() => {
            if (args.checked)
                document.getElementById('GridObiettiviAree').querySelectorAll('td.e-detailrowcollapse').forEach(elm => { 
                    elm.click();
                });
            document.getElementById('ddlPeriti2').ej2_instances[0].enabled = !args.checked;
            document.getElementById('chkPeritiObiett2').ej2_instances[0].disabled = args.checked;
        }, 400);     
    }    
    onChangeMese(args) {
        this.setState({
            meseAtt: args.itemData.Text,
            ObietMeseACatt: _.find(CurvaObiettivi.CurvaObiettivi, elm => { return elm.RAMO === 'AC'})[yyyy.toString() + args.value],
            ObietMeseREatt: _.find(CurvaObiettivi.CurvaObiettivi, elm => { return elm.RAMO === 'RE'})[yyyy.toString() + args.value],
            ObietMeseRCatt: _.find(CurvaObiettivi.CurvaObiettivi, elm => { return elm.RAMO === 'RC'})[yyyy.toString() + args.value],
            ObietMeseENatt: _.find(CurvaObiettivi.CurvaObiettivi, elm => { return elm.RAMO === 'EN'})?.[yyyy.toString() + args.value]
        });
        setTimeout(() => {
            this.caricaDati();
            this.ddlInstance.enabled = true;
            this.ddlInstance.value = '';
            document.getElementById('chkPeritiObiett').ej2_instances[0].checked = false;
            document.getElementById('chkPeritiNoObiett').ej2_instances[0].checked = false;
        }, 300);        
    }    
    onChangeGruppiColonne(args) {
        if (!args || !args.value) {
            console.warn('onChangeGruppiColonne chiamato con args non validi', args);
            return;
        }
        
        const selectedGroups = args.value || [];
        
        if (selectedGroups.length === 0) {
            toast.warn('Seleziona almeno 1 gruppo di colonne', {
                containerId: 'toastContainer1',
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: false
            });
            
            if (this.ddlGruppiColonneInstance && !this.ddlGruppiColonneInstance.isDestroyed) {
                this.ddlGruppiColonneInstance.value = this.state.visibleColumnGroups;
            }
            return;
        }
        
        if (selectedGroups.length > 3) {
            toast.warn('Puoi selezionare massimo 3 gruppi di colonne', {
                containerId: 'toastContainer1',
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: false
            });
            return;
        }
        
        this.setState({ visibleColumnGroups: selectedGroups }, () => {
            try {
                localStorage.setItem('visibleColumnGroups', JSON.stringify(selectedGroups));
                
                const gridElement = document.getElementById('GridObiettivi');
                if (gridElement && gridElement.ej2_instances && gridElement.ej2_instances[0]) {
                    const gridInstance = gridElement.ej2_instances[0];
                    
                    // ✅ Mostra/Nascondi colonne usando hideColumns/showColumns
                    const allGroups = ['AC', 'RE', 'RC', 'EN'];
                    allGroups.forEach((gruppo, index) => {
                        const colIndex = 1 + index; // 0=Compagnia, 1=AC, 2=RE, 3=RC, 4=EN
                        if (selectedGroups.includes(gruppo)) {
                            gridInstance.showColumns([gruppo]); // Usa field name o header
                        } else {
                            gridInstance.hideColumns([gruppo]);
                        }
                    });
                    
                    if (gridInstance.childGrid) {
                        gridInstance.childGrid.visibleGroups = selectedGroups;
                    }
                    
                    gridInstance.refresh();
                }
            } catch (error) {
                console.error('Errore durante l\'aggiornamento della griglia:', error);
            }
        });
    }
    onChangeGruppiColonne2(args) {
        if (!args || !args.value) {
            console.warn('onChangeGruppiColonne2 chiamato con args non validi', args);
            return;
        }
        
        const selectedGroups = args.value || [];
        
        if (selectedGroups.length === 0) {
            toast.warn('Seleziona almeno 1 gruppo di colonne', {
                containerId: 'toastContainer1',
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: false
            });
            
            if (this.ddlGruppiColonneInstance2 && !this.ddlGruppiColonneInstance2.isDestroyed) {
                this.ddlGruppiColonneInstance2.value = this.state.visibleColumnGroupsAree;
            }
            return;
        }
        
        if (selectedGroups.length > 3) {
            toast.warn('Puoi selezionare massimo 3 gruppi di colonne', {
                containerId: 'toastContainer1',
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: false
            });
            return;
        }
        
        this.setState({ visibleColumnGroupsAree: selectedGroups }, () => {
            try {
                localStorage.setItem('visibleColumnGroupsAree', JSON.stringify(selectedGroups));
                
                const gridElement = document.getElementById('GridObiettiviAree');
                if (gridElement && gridElement.ej2_instances && gridElement.ej2_instances[0]) {
                    const gridInstance = gridElement.ej2_instances[0];
                    
                    // ✅ Mostra/Nascondi colonne usando hideColumns/showColumns
                    const allGroups = ['AC', 'RE', 'RC', 'EN'];
                    allGroups.forEach((gruppo, index) => {
                        const colIndex = 1 + index; // 0=Area, 1=AC, 2=RE, 3=RC, 4=EN
                        if (selectedGroups.includes(gruppo)) {
                            gridInstance.showColumns([gruppo]); // Usa field name o header
                        } else {
                            gridInstance.hideColumns([gruppo]);
                        }
                    });
                    
                    if (gridInstance.childGrid) {
                        gridInstance.childGrid.visibleGroups = selectedGroups;
                    }
                    
                    gridInstance.refresh();
                }
            } catch (error) {
                console.error('Errore durante l\'aggiornamento della griglia aree:', error);
            }
        });
    }
    GrigliaObiettiviAreeRender() {
        ++this.childKey;
        const { visibleColumnGroupsAree } = this.state;
        return(<React.Fragment>
                <div className="control-section card-control-section basic_card_layout">
                    <div className="e-card-resize-container">
                        <div className="card-layout">
                            <div className="col-xs-12 col-sm-12 col-lg-12 col-md-12">                                           
                                <div tabIndex="0" className="e-card" id="main_card">                                                
                                    <div className="e-card-content">
                                        <div className='row'>
                                            <div className="col-xs-12 col-sm-12 col-lg-12 col-md-12">
                                                <BlockUi tag='div' id='blockUI2' blocking={this.state.blocking3} keepInView={true} loader={CustomJS.loaderSpinners[random(CustomJS.loaderSpinners.length - 1)]}> 
                                                    <GridComponent id="GridObiettiviAree" key={this.childKey} ref={grid => this.gridInstance2 = grid} toolbar={this.toolbarOptions2} childGrid={this.childGrid2} allowSelection={false} enableHover={false} allowTextWrap={true}  
                                                        allowPaging={false} allowSorting={false} allowFiltering={false} allowExcelExport={true} allowPdfExport={true} queryCellInfo={this.onQueryCellInfo3.bind(this)} pageSettings={{ pageCount: 5, pageSize: 10, pageSizes: ['10', '50', 'Tutti'] }}
                                                        dataBound={this.onDatabound3.bind(this)} toolbarClick={this.toolbarClick2.bind(this)} rowDataBound={this.onRowDatabound2} enableAltRow={true} gridLines='Both' hierarchyPrintMode='All' height='600px'>
                                                        <ColumnsDirective>
                                                            <ColumnDirective field='DescrArea' headerText='Area' headerTemplate={headerTemplate} textAlign='Center' width='20%'></ColumnDirective>
                                                            <ColumnDirective 
                                                                visible={visibleColumnGroupsAree.includes('AC')}
                                                                columns={[
                                                                    { field: 'ScarTotSinAC', headerText: 'Scarico Totale', headerTemplate: headerTemplate3, textAlign: 'Center' }, 
                                                                    { field: 'NumSinistriMancantiAC', headerText: 'Sinistri Mancanti', headerTemplate: headerTemplate3, textAlign:'Center' },
                                                                    { field: 'TempoMedioScaricoAC', headerText: 'Tempo Medio Scarico', headerTemplate: headerTemplate3, textAlign: 'Center'}
                                                                ]} 
                                                                headerText='Acqua Condotta' 
                                                                headerTemplate={headerTemplate} 
                                                                textAlign='Center'>
                                                            </ColumnDirective>                                                            
                                                            <ColumnDirective 
                                                                visible={visibleColumnGroupsAree.includes('RE')}
                                                                columns={[
                                                                    { field: 'ScarTotSinRE', headerText: 'Scarico Totale', headerTemplate: headerTemplate3, textAlign: 'Center' }, 
                                                                    { field: 'NumSinistriMancantiRE', headerText: 'Sinistri Mancanti', headerTemplate: headerTemplate3, textAlign:'Center' },
                                                                    { field: 'TempoMedioScaricoRE', headerText: 'Tempo Medio Scarico', headerTemplate: headerTemplate3, textAlign: 'Center'}
                                                                ]} 
                                                                headerText='Rami Elementari' 
                                                                headerTemplate={headerTemplate} 
                                                                textAlign='Center'>
                                                            </ColumnDirective>                                                            
                                                            <ColumnDirective 
                                                                visible={visibleColumnGroupsAree.includes('RC')}
                                                                columns={[
                                                                    { field: 'ScarTotSinRC', headerText: 'Scarico Totale', headerTemplate: headerTemplate3, textAlign: 'Center' }, 
                                                                    { field: 'NumSinistriMancantiRC', headerText: 'Sinistri Mancanti', headerTemplate: headerTemplate3, textAlign:'Center' },
                                                                    { field: 'TempoMedioScaricoRC', headerText: 'Tempo Medio Scarico', headerTemplate: headerTemplate3, textAlign: 'Center'}
                                                                ]} 
                                                                headerText='Responsabilità Civile' 
                                                                headerTemplate={headerTemplate} 
                                                                textAlign='Center'>
                                                            </ColumnDirective>                                                            
                                                            <ColumnDirective 
                                                                visible={visibleColumnGroupsAree.includes('EN')}
                                                                columns={[
                                                                    { field: 'ScarTotSinEN', headerText: 'Scarico Totale', headerTemplate: headerTemplate3, textAlign: 'Center' }, 
                                                                    { field: 'NumSinistriMancantiEN', headerText: 'Sinistri Mancanti', headerTemplate: headerTemplate3, textAlign:'Center' },
                                                                    { field: 'TempoMedioScaricoEN', headerText: 'Tempo Medio Scarico', headerTemplate: headerTemplate3, textAlign: 'Center'}
                                                                ]} 
                                                                headerText='Eventi Naturali' 
                                                                headerTemplate={headerTemplate} 
                                                                textAlign='Center'>
                                                            </ColumnDirective> 
                                                        </ColumnsDirective>
                                                        <Inject services={[Toolbar, DetailRow, ExcelExport, CommandColumn, PdfExport, Filter, Sort, Page]}/>                    
                                                    </GridComponent>  
                                                </BlockUi>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </React.Fragment>);
    }
    onQueryCellInfoSinistriPotenzialiIntesa(args) {
        args.cell.style.fontWeight = 'bold';
        args.cell.style.fontSize = '1.0vw';
        if (args.column.index === 0 || args.column.index === 1) {
            args.cell.style.color = '#133B95';
        } else if (args.column.index === 2) {
            const val = parseInt(args.cell.innerText, 10);
            if (!isNaN(val)) {
                args.cell.innerText = val.toLocaleString('it-IT');
                args.cell.style.color = 'whitesmoke';
                args.cell.bgColor = '#2e7d32';
            }
        }
    }
    onDataboundSinistriPotenzialiIntesa(args) {
        for (let ind = 0; ind <= 2; ind++) {
            const col = document.getElementById('GridSinistriPotenzialiIntesa')?.querySelectorAll('.e-columnheader')[0]?.children[ind];
            if (col) col.style.backgroundColor = 'Linen';
        }
    }
    openSinistriPotenzialiIntesa(area, tipoSinistro, idPerito = null, target = 17) {
        this.activeIntesaTarget = target;
        const oggi = `${new Date().getFullYear()}-${String(new Date().getMonth()+1).padStart(2,'0')}-${String(new Date().getDate()).padStart(2,'0')}`;
        let sinistri = _.filter(this.intesaRawData, r =>
            r.Chiuso === 0 &&
            r.AreaGeografica === area &&
            r.TipoSinistro === tipoSinistro
        );
        if (idPerito) {
            sinistri = _.filter(sinistri, r => String(r.id_perito) === String(idPerito));
        }
        sinistri = _.sortBy(
            _.filter(
                sinistri.map(r => ({
                    ...r,
                    GiorniLavorativiApertura: CustomJS.workingDaysBetween(r.DataApertura, oggi)
                })),
                r => r.GiorniLavorativiApertura < target
            ),
            'GiorniLavorativiApertura'
        );

        const areaLabel = area === 'CentroNord' ? 'CENTRO/NORD' : area.toUpperCase();
        this.dialogInstance2.header = `<div style="display:flex;align-items:center;gap:10px;padding:2px 0">
            <span style="font-size:1.6em;line-height:1">⏱️</span>
            <span style="font-size:1.2vw;font-weight:bold;color:#e65100">SINISTRI ${areaLabel} APERTI — ${tipoSinistro}</span>
        </div>`;
        this.dialogInstance2.width = '45%';
        this.dialogInstance2.height = '82%';
        this.dialogInstance2.minHeight = '82%';
        this.dialogInstance2.buttons = [];
        this.dialogInstance2.beforeOpen = () => {
            const container = document.getElementById('defaultDialogContentProvince');
            const root = createRoot(container);
            root.unmount();
        };
        this.dialogInstance2.open = () => {
            const container = document.getElementById('defaultDialogContentProvince');
            const root = createRoot(container);
            root.render(this.GrigliaKPISinistriPotenzialiIntesa(sinistri));
        };
        this.dialogInstance2.show();
    }
    GrigliaKPISinistriPotenzialiIntesa(sinistri) {
        ++this.childKey;
        return (
            <React.Fragment>
                <div style={{
                    background: 'linear-gradient(135deg, #fff3e0 0%, #ffe0b2 60%, #fff8e1 100%)',
                    borderRadius: '10px', padding: '14px 24px', marginBottom: '16px',
                    display: 'flex', alignItems: 'center', gap: '24px',
                    boxShadow: '0 2px 10px rgba(230,81,0,0.12)', border: '1px solid #ffcc80'
                }}>
                    <div style={{ textAlign: 'center' }}>
                        <div style={{ fontSize: '1.8vw', fontWeight: '800', color: '#2e7d32', lineHeight: 1.1 }}>{sinistri.length}</div>
                        <div style={{ fontSize: '0.8vw', color: '#2e7d32', fontWeight: '600', marginTop: '2px' }}>Sinistri trovati</div>
                    </div>
                    <div style={{ width: '1px', height: '40px', background: '#ffcc80' }}></div>
                    <div style={{ fontSize: '0.85vw', color: '#546e7a', fontStyle: 'italic' }}>
                        ⏱️ Sinistri aperti da meno di {this.activeIntesaTarget} giorni lavorativi — potenzialmente chiudibili entro il target
                    </div>
                </div>
                <GridComponent
                    id="GridSinistriPotenzialiIntesa"
                    key={this.childKey}
                    ref={grid => this.gridInstancePotIntesa = grid}
                    dataSource={sinistri}
                    allowSorting={true}
                    allowPaging={false}
                    allowSelection={false}
                    enableHover={false}
                    allowTextWrap={true}
                    queryCellInfo={this.onQueryCellInfoSinistriPotenzialiIntesa.bind(this)}
                    dataBound={this.onDataboundSinistriPotenzialiIntesa.bind(this)}
                    enableAltRow={true}
                    gridLines='Both'
                    height='52vh'
                >
                    <ColumnsDirective>
                        <ColumnDirective field='IdSinistro' headerText='ID' headerTemplate={headerTemplate} textAlign='Center' width='20%'></ColumnDirective>
                        <ColumnDirective field='NominativoPerito' headerText='Perito' headerTemplate={headerTemplate} textAlign='Center' width='55%'></ColumnDirective>
                        <ColumnDirective field='GiorniLavorativiApertura' headerText='Giorni Lav.' headerTemplate={headerTemplate} textAlign='Center' width='25%'></ColumnDirective>
                    </ColumnsDirective>
                    <Inject services={[Sort]}/>
                </GridComponent>
            </React.Fragment>
        );
    }
    GrigliaKPIIntesaRender() {
        ++this.childKey;
        return(<React.Fragment>
                <div className="control-section card-control-section basic_card_layout">
                    <div className="e-card-resize-container">
                        <div className="card-layout">
                            <div className="col-xs-12 col-sm-12 col-lg-12 col-md-12">                                           
                                <div tabIndex="0" className="e-card" id="main_card">                                                
                                    <div className="e-card-content">
                                        <div className='row'>
                                            <div className="col-xs-12 col-sm-12 col-lg-12 col-md-12" style={{ marginTop: '15px', marginBottom: '15px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', paddingLeft: '8px', paddingRight: '8px' }}>
                                                <span style={{ fontSize: '1.4vw', fontWeight: 'bolder', color:'#133B95', whiteSpace: 'nowrap' }}>TARGET : 17 GG (Centro/Nord) &nbsp;·&nbsp; 21 GG (Sud)</span>
                                                <span style={{ fontSize: '1.4vw', fontWeight: 'bolder', color:'#133B95', whiteSpace: 'nowrap' }}>IMPORTO LIQUIDATO : ENTRO &euro;2000</span>
                                            </div>
                                        </div>
                                        <div className='row'>
                                            <div className="col-xs-12 col-sm-5 col-lg-12 col-md-12" style={{ marginTop: '5px', marginBottom: '5px' }}>
                                                <span style={{ fontSize: '1.0vw', fontWeight: 'bolder', color:'#133B95'}}>Conteggio eseguito considerando esclusivamente i giorni lavorativi</span>
                                            </div> 
                                        </div>
                                        <div className='row'>
                                            <div className="col-xs-12 col-sm-12 col-lg-12 col-md-12">
                                                <BlockUi tag='div' id='blockUI2' blocking={this.state.blocking3} keepInView={true} loader={CustomJS.loaderSpinners[random(CustomJS.loaderSpinners.length - 1)]}> 
                                                    <GridComponent id="GridKPIIntesa" key={this.childKey} ref={grid => this.gridInstance3 = grid} toolbar={this.toolbarOptions3} childGrid={this.childGrid3} allowSelection={false} enableHover={false} allowTextWrap={true}  
                                                        allowPaging={false} allowSorting={false} allowFiltering={false} allowExcelExport={true} allowPdfExport={true} queryCellInfo={this.onQueryCellInfo4.bind(this)} pageSettings={{ pageCount: 5, pageSize: 10, pageSizes: ['10', '50', 'Tutti'] }}
                                                        dataBound={this.onDatabound4.bind(this)} toolbarClick={this.toolbarClick3.bind(this)} rowDataBound={this.onRowDatabound3} enableAltRow={true} gridLines='Both' hierarchyPrintMode='All' height='60vh'>
                                                            <ColumnsDirective>
                                                                <ColumnDirective field='TipoSinistro' headerText='Tipo Sinistro' headerTemplate={headerTemplate} textAlign='Center' width='20%'></ColumnDirective>
                                                                <ColumnDirective field='MediaGiorniCentroNord' headerText='Media Giorni Centro/Nord (GG mancanti al target)' headerTemplate={headerTemplate} textAlign='Center'></ColumnDirective>
                                                                <ColumnDirective field='MediaGiorniSud' headerText='MediaGiorniSud  (GG mancanti al target)' headerTemplate={headerTemplate} textAlign='Center'></ColumnDirective>
                                                            </ColumnsDirective>
                                                        <Inject services={[Toolbar, DetailRow, ExcelExport, CommandColumn, PdfExport, Filter, Sort, Page]}/>                    
                                                    </GridComponent>  
                                                </BlockUi>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </React.Fragment>);
    }
    openProvinceModal(tipoSinistro, context = 'generali') {
        this.activeContext = context;
        this.activeTipoSinistro = tipoSinistro;

        let rawData, allowedSigle, calcolaKPIProv, isAllZeroFn;

        if (context === 'unipol') {
            allowedSigle = ['TO', 'CN', 'VC', 'NO', 'MI', 'BO', 'RM', 'CA', 'SS', 'OR'];
            rawData = this.kpiUnipolRawData;
            calcolaKPIProv = (records) => {
                const chiusi = _.filter(records, r => r.Chiuso === 1);
                const indennizzabili = _.filter(chiusi, r =>
                    r.esito_perizia !== 'NON INDENNIZZABILE' &&
                    r.TotaleDannoIndennizzabile >= 250 &&
                    r.TotaleDannoIndennizzabile <= 5000
                );
                const totalLiquidato = _.reduce(indennizzabili, (sum, r) => sum + (r.TotaleDannoIndennizzabile || 0), 0);
                const liquidatoMedio = indennizzabili.length > 0 ? totalLiquidato / indennizzabili.length : 0;
                const obiettivo = tipoSinistro === 'EVENTO NATURALE' ? 1400 : tipoSinistro === 'ALTRI RAMI ELEMENTARI' ? 1400 : 1250;
                const totalGiorni = _.reduce(chiusi, (sum, r) => sum + (r.GiorniRientro || 0), 0);
                const tempoMedio = chiusi.length > 0 ? totalGiorni / chiusi.length : 0;
                const percIncidenzaConcordato = chiusi.length > 0
                    ? (_.filter(chiusi, r => r.esito_perizia !== 'NON INDENNIZZABILE' && r.esito_perizia !== 'NON CONCORDATO').length / chiusi.length * 100)
                    : 0;
                const percScaricoAnnuale = records.length > 0
                    ? (_.filter(records, r => r.Chiuso === 1).length / records.length * 100) : 0;
                return {
                    LiquidatoMedio: parseFloat(liquidatoMedio.toFixed(2)),
                    ConteggioCampione: indennizzabili.length,
                    DeltaObiettivoKPI4: parseFloat((liquidatoMedio > obiettivo ? liquidatoMedio - obiettivo : 0).toFixed(2)),
                    TempoMedioRestituzione: parseFloat(tempoMedio.toFixed(2)),
                    DeltaObiettivoKPI2: parseFloat((tempoMedio > 45 ? Math.ceil(tempoMedio - 45) : 0).toFixed(2)),
                    PercIncidenzaConcordato: parseFloat(percIncidenzaConcordato.toFixed(2)),
                    PercScaricoAnnuale: parseFloat(percScaricoAnnuale.toFixed(2))
                };
            };
            isAllZeroFn = r => r.LiquidatoMedio === 0 && r.TempoMedioRestituzione === 0 && r.PercIncidenzaConcordato === 0 && r.PercScaricoAnnuale === 0;
            this.activeChildGridProvince = this.childGridProvinceUnipol;
            this.activeProvQCIParent = this.onQueryCellInfoProvinceUnipol.bind(this);
        } else {
            // HDI e SARA: stesso calcolo di Generali, ma senza filtro su Aree/Province
            const siglePerTipo = context === 'generali' ? { 'ACQUA CONDOTTA': ['MI', 'BI', 'NO', 'TO', 'VC', 'CA', 'OR', 'SS'] } : {};
            allowedSigle = siglePerTipo[tipoSinistro] || null;
            rawData = context === 'hdi' ? this.kpiHDIRawData : context === 'sara' ? this.kpiSARARawData : this.kpiGeneraliRawData;
            calcolaKPIProv = (records) => {
                const chiusi = _.filter(records, r => r.Chiuso === 1);
                const indennizzabili = _.filter(chiusi, r =>
                    r.esito_perizia !== 'NON INDENNIZZABILE' &&
                    r.TotaleDannoIndennizzabile >= 1 &&
                    r.TotaleDannoIndennizzabile <= 50000
                );
                const totalLiquidato = _.reduce(indennizzabili, (sum, r) => sum + (r.TotaleDannoIndennizzabile || 0), 0);
                const liquidatoMedio = indennizzabili.length > 0 ? totalLiquidato / indennizzabili.length : 0;
                const totalGiorni = _.reduce(chiusi, (sum, r) => sum + (r.GiorniRientro || 0), 0);
                const tempoMedio = chiusi.length > 0 ? totalGiorni / chiusi.length : 0;
                const percNonIndennizzabili = chiusi.length > 0
                    ? (_.filter(chiusi, r => r.esito_perizia === 'NON INDENNIZZABILE').length / chiusi.length * 100) : 0;
                const percScaricoAnnuale = records.length > 0
                    ? (_.filter(records, r => r.Chiuso === 1).length / records.length * 100) : 0;
                return {
                    LiquidatoMedio: parseFloat(liquidatoMedio.toFixed(2)),
                    ConteggioCampione: indennizzabili.length,
                    DeltaObiettivoKPI1: parseFloat((liquidatoMedio > 1250 ? liquidatoMedio - 1250 : 0).toFixed(2)),
                    TempoMedioRestituzione: parseFloat(tempoMedio.toFixed(2)),
                    DeltaObiettivoKPI4: parseFloat((tempoMedio > 45 ? Math.ceil(tempoMedio - 45) : 0).toFixed(2)),
                    PercNonIndennizzabili: parseFloat(percNonIndennizzabili.toFixed(2)),
                    PercScaricoAnnuale: parseFloat(percScaricoAnnuale.toFixed(2))
                };
            };
            isAllZeroFn = r => r.LiquidatoMedio === 0 && r.TempoMedioRestituzione === 0 && r.PercNonIndennizzabili === 0 && r.PercScaricoAnnuale === 0;
            this.activeChildGridProvince = this.childGridProvince;
            this.activeProvQCIParent = this.onQueryCellInfoProvince.bind(this);
        }

        const data = _.filter(
            rawData,
            r => r.TipoSinistro === tipoSinistro &&
                (!allowedSigle || allowedSigle.includes((r.provincia_corta || '').toUpperCase()))
        );

        const groupedByProv = _.groupBy(data, 'provincia_corta');
        this.gridDataProv1 = _.sortBy(
            _.filter(
                _.map(groupedByProv, (records, sigla) => ({
                    ProvinciaCorta: sigla,
                    Provincia: records[0]?.provincia || '',
                    ...calcolaKPIProv(records)
                })),
                r => !isAllZeroFn(r)
            ),
            'ProvinciaCorta'
        );
        this.gridDataProv2 = [];
        _.each(groupedByProv, (records, sigla) => {
            _.each(_.groupBy(records, 'id_perito'), (peritoRecords, peritoId) => {
                this.gridDataProv2.push({
                    ProvinciaCorta: sigla,
                    id_perito: peritoId,
                    NominativoPerito: peritoRecords[0]?.NominativoPerito || 'Sconosciuto',
                    ...calcolaKPIProv(peritoRecords)
                });
            });
        });
        this.gridDataProv2 = _.filter(this.gridDataProv2, r => !isAllZeroFn(r));
        this.activeChildGridProvince.dataSource = this.gridDataProv2;

        const modalIcon =
            tipoSinistro === 'ACQUA CONDOTTA'  ? '💧' :
            tipoSinistro === 'EVENTO NATURALE' ? '🌪️' :
            tipoSinistro === 'R.C. Auto'       ? '🚗' : '🗺️';
        this.dialogInstance2.header = `<div style="display:flex;align-items:center;gap:10px;padding:2px 0">
            <span style="font-size:1.6em;line-height:1">${modalIcon}</span>
            <span style="font-size:1.4vw;font-weight:bold;color:#1565c0">DETTAGLIO KPI PER PROVINCIA - ${tipoSinistro}</span>
        </div>`;
        this.dialogInstance2.width = '92%';
        this.dialogInstance2.height = '90%';
        this.dialogInstance2.minHeight = '90%';
        this.dialogInstance2.buttons = [];
        this.dialogInstance2.beforeOpen = () => {
            const container = document.getElementById('defaultDialogContentProvince');
            const root = createRoot(container);
            root.unmount();
        };
        this.dialogInstance2.open = () => {
            const container = document.getElementById('defaultDialogContentProvince');
            const root = createRoot(container);
            root.render(this.GrigliaProvinceRender(tipoSinistro));
        };
        this.dialogInstance2.show();
    }
    GrigliaProvinceRender(tipoSinistro) {
        ++this.childKey;
        const isUnipol  = this.activeContext === 'unipol';
        const isAllianz = this.activeContext === 'allianz';
        const totProv = this.gridDataProv1.length;
        const totSinistri = _.reduce(this.gridDataProv1, (sum, r) => sum + (r.ConteggioCampione || 0), 0);
        const tipoIcon =
            tipoSinistro === 'ACQUA CONDOTTA'  ? '💧' :
            tipoSinistro === 'EVENTO NATURALE' ? '🌪️' :
            tipoSinistro === 'R.C. Auto'       ? '🚗' : '🗺️';

        if (isAllianz) {
            return (
                <React.Fragment>
                    <div style={{
                        background: 'linear-gradient(135deg, #ffebee 0%, #ffcdd2 60%, #fff3e0 100%)',
                        borderRadius: '10px', padding: '16px 28px', marginBottom: '18px',
                        display: 'flex', alignItems: 'center', gap: '28px',
                        boxShadow: '0 2px 10px rgba(183,28,28,0.12)', border: '1px solid #ef9a9a'
                    }}>
                        <div style={{ textAlign: 'center' }}>
                            <div style={{ fontSize: '2vw', fontWeight: '800', color: '#b71c1c', lineHeight: 1.1 }}>{totProv}</div>
                            <div style={{ fontSize: '0.85vw', color: '#c62828', fontWeight: '600', marginTop: '2px' }}>Province</div>
                        </div>
                        <div style={{ width: '1px', height: '44px', background: '#ef9a9a' }}></div>
                        <div style={{ textAlign: 'center' }}>
                            <div style={{ fontSize: '2vw', fontWeight: '800', color: '#2e7d32', lineHeight: 1.1 }}>{totSinistri.toLocaleString('it-IT')}</div>
                            <div style={{ fontSize: '0.85vw', color: '#388e3c', fontWeight: '600', marginTop: '2px' }}>Campione KPI2</div>
                        </div>
                        <div style={{ flex: 1 }}></div>
                        <div style={{ fontSize: '0.9vw', color: '#546e7a', fontStyle: 'italic' }}>
                            🗺️ Espandi ogni riga per vedere il dettaglio periti della provincia
                        </div>
                    </div>
                    <GridComponent
                        id="GridProvince" key={this.childKey} ref={grid => this.gridInstanceProv = grid}
                        dataSource={this.gridDataProv1} childGrid={this.activeChildGridProvince}
                        allowSorting={true} allowFiltering={false} allowSelection={false}
                        enableHover={false} allowTextWrap={true} allowPaging={false}
                        queryCellInfo={this.activeProvQCIParent}
                        dataBound={this.onDataboundProvince.bind(this)}
                        rowDataBound={this.onRowDataboundProvince.bind(this)}
                        enableAltRow={true} gridLines='Both' hierarchyPrintMode='All' height='52vh'
                    >
                        <ColumnsDirective>
                            <ColumnDirective field='ProvinciaCorta' headerText='Prov.' headerTemplate={headerTemplate} textAlign='Center' width='13%'></ColumnDirective>
                            <ColumnDirective field='Provincia' headerText='Provincia' headerTemplate={headerTemplate} textAlign='Center' width='25%'></ColumnDirective>
                            <ColumnDirective field='LiquidatoMedioGFRE' headerText='Liquidato Medio GF-RE (KPI2)' headerTemplate={headerTemplate} textAlign='Center'></ColumnDirective>
                        </ColumnsDirective>
                        <Inject services={[DetailRow, Sort, Page]}/>
                    </GridComponent>
                </React.Fragment>
            );
        }
        const banner = (
            <div style={{
                background: isUnipol
                    ? 'linear-gradient(135deg, #f3e5f5 0%, #e1bee7 60%, #ede7f6 100%)'
                    : 'linear-gradient(135deg, #e3f2fd 0%, #bbdefb 60%, #e8f5e9 100%)',
                borderRadius: '10px',
                padding: '16px 28px',
                marginBottom: '18px',
                display: 'flex',
                alignItems: 'center',
                gap: '28px',
                boxShadow: isUnipol ? '0 2px 10px rgba(106,27,154,0.12)' : '0 2px 10px rgba(21,101,192,0.12)',
                border: isUnipol ? '1px solid #ce93d8' : '1px solid #90caf9'
            }}>
                <div style={{ textAlign: 'center' }}>
                    <div style={{ fontSize: '2vw', fontWeight: '800', color: isUnipol ? '#6a1b9a' : '#1565c0', lineHeight: 1.1 }}>{totProv}</div>
                    <div style={{ fontSize: '0.85vw', color: isUnipol ? '#7b1fa2' : '#1976d2', fontWeight: '600', marginTop: '2px' }}>Province</div>
                </div>
                <div style={{ width: '1px', height: '44px', background: isUnipol ? '#ce93d8' : '#90caf9' }}></div>
                <div style={{ textAlign: 'center' }}>
                    <div style={{ fontSize: '2vw', fontWeight: '800', color: '#2e7d32', lineHeight: 1.1 }}>{totSinistri.toLocaleString('it-IT')}</div>
                    <div style={{ fontSize: '0.85vw', color: '#388e3c', fontWeight: '600', marginTop: '2px' }}>Sinistri {tipoSinistro}</div>
                </div>
                <div style={{ flex: 1 }}></div>
                <div style={{ fontSize: '0.9vw', color: '#546e7a', fontStyle: 'italic' }}>
                    {tipoIcon} Espandi ogni riga per vedere il dettaglio periti della provincia
                </div>
            </div>
        );

        if (isUnipol) {
            return (
                <React.Fragment>
                    {banner}
                    <GridComponent
                        id="GridProvince"
                        key={this.childKey}
                        ref={grid => this.gridInstanceProv = grid}
                        dataSource={this.gridDataProv1}
                        childGrid={this.activeChildGridProvince}
                        allowSorting={true}
                        allowFiltering={false}
                        allowSelection={false}
                        enableHover={false}
                        allowTextWrap={true}
                        allowPaging={false}
                        queryCellInfo={this.activeProvQCIParent}
                        dataBound={this.onDataboundProvince.bind(this)}
                        rowDataBound={this.onRowDataboundProvince.bind(this)}
                        enableAltRow={true}
                        gridLines='Both'
                        hierarchyPrintMode='All'
                        height='60vh'
                    >
                        <ColumnsDirective>
                            <ColumnDirective field='ProvinciaCorta' headerText='Prov.' headerTemplate={headerTemplate} textAlign='Center' width='7%'></ColumnDirective>
                            <ColumnDirective field='Provincia' headerText='Provincia' headerTemplate={headerTemplate} textAlign='Center' width='17%'></ColumnDirective>
                            <ColumnDirective field='LiquidatoMedio' headerText='Liquidato Medio (KPI4)' headerTemplate={headerTemplate} textAlign='Center'></ColumnDirective>
                            <ColumnDirective field='DeltaObiettivoKPI4' headerText='Delta su obiettivo (KPI4)' headerTemplate={headerTemplate} textAlign='Center'></ColumnDirective>
                            <ColumnDirective field='PercScaricoAnnuale' headerText='% Scarico Annuale (KPI3)' headerTemplate={headerTemplate} textAlign='Center'></ColumnDirective>
                            <ColumnDirective field='TempoMedioRestituzione' headerText='Tempo Medio Restituzione (KPI2)' headerTemplate={headerTemplate} textAlign='Center'></ColumnDirective>
                            <ColumnDirective field='DeltaObiettivoKPI2' headerText='Delta su obiettivo (KPI2)' headerTemplate={headerTemplate} textAlign='Center'></ColumnDirective>
                            <ColumnDirective field='PercIncidenzaConcordato' headerText='% Incidenza Concordato (KPI5)' headerTemplate={headerTemplate} textAlign='Center'></ColumnDirective>
                        </ColumnsDirective>
                        <Inject services={[DetailRow, Sort, Page]}/>
                    </GridComponent>
                </React.Fragment>
            );
        }

        return (
            <React.Fragment>
                {banner}
                <GridComponent
                    id="GridProvince"
                    key={this.childKey}
                    ref={grid => this.gridInstanceProv = grid}
                    dataSource={this.gridDataProv1}
                    childGrid={this.activeChildGridProvince}
                    allowSorting={true}
                    allowFiltering={false}
                    allowSelection={false}
                    enableHover={false}
                    allowTextWrap={true}
                    allowPaging={false}
                    queryCellInfo={this.activeProvQCIParent}
                    dataBound={this.onDataboundProvince.bind(this)}
                    rowDataBound={this.onRowDataboundProvince.bind(this)}
                    enableAltRow={true}
                    gridLines='Both'
                    hierarchyPrintMode='All'
                    height='60vh'
                >
                    <ColumnsDirective>
                        <ColumnDirective field='ProvinciaCorta' headerText='Prov.' headerTemplate={headerTemplate} textAlign='Center' width='7%'></ColumnDirective>
                        <ColumnDirective field='Provincia' headerText='Provincia' headerTemplate={headerTemplate} textAlign='Center' width='17%'></ColumnDirective>
                        <ColumnDirective field='LiquidatoMedio' headerText='Liquidato Medio (KPI1)' headerTemplate={headerTemplate} textAlign='Center'></ColumnDirective>
                        <ColumnDirective field='DeltaObiettivoKPI1' headerText='Delta su obiettivo (KPI1)' headerTemplate={headerTemplate} textAlign='Center'></ColumnDirective>
                        <ColumnDirective field='PercScaricoAnnuale' headerText='% Scarico Annuale (KPI2)' headerTemplate={headerTemplate} textAlign='Center'></ColumnDirective>
                        <ColumnDirective field='TempoMedioRestituzione' headerText='Tempo Medio Restituzione (KPI4)' headerTemplate={headerTemplate} textAlign='Center'></ColumnDirective>
                        <ColumnDirective field='DeltaObiettivoKPI4' headerText='Delta su obiettivo (KPI4)' headerTemplate={headerTemplate} textAlign='Center'></ColumnDirective>
                        <ColumnDirective field='PercNonIndennizzabili' headerText='% Non Indennizzabili (KPI3)' headerTemplate={headerTemplate} textAlign='Center'></ColumnDirective>
                    </ColumnsDirective>
                    <Inject services={[DetailRow, Sort, Page]}/>
                </GridComponent>
            </React.Fragment>
        );
    }
    GrigliaKPIGeneraliRender() {
        ++this.childKey;
        return(<React.Fragment>
            <div className="control-section card-control-section basic_card_layout">
                <div className="e-card-resize-container">
                    <div className="card-layout">
                        <div className="col-xs-12 col-sm-12 col-lg-12 col-md-12">                                           
                            <div tabIndex="0" className="e-card" id="main_card">                                                
                                <div className="e-card-content">
                                    
                                    {/* ACCORDION LEGENDA KPI */}
                                    <div className='row'>
                                        <div className="col-xs-12 col-sm-12 col-lg-12 col-md-12">
                                            <div style={{ marginTop: '10px', marginBottom: '15px' }}>
                                                <AccordionComponent>
                                                    <AccordionItemsDirective>
                                                        <AccordionItemDirective 
                                                            header='📊 LEGENDA KPI - INFO E VALORI TARGET' 
                                                            content={this.legendaKPIGeneraliContent.bind(this)}
                                                        />
                                                    </AccordionItemsDirective>
                                                </AccordionComponent>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='row'>
                                        <div className="col-xs-12 col-sm-12 col-lg-12 col-md-12">
                                            <BlockUi tag='div' id='blockUI2' blocking={this.state.blocking3} keepInView={true} loader={CustomJS.loaderSpinners[random(CustomJS.loaderSpinners.length - 1)]}> 
                                                <GridComponent id="GridKPIGenerali" key={this.childKey} ref={grid => this.gridInstance4 = grid} toolbar={this.toolbarOptions3} childGrid={this.childGrid4} allowSelection={false} enableHover={false} allowTextWrap={true}  
                                                    allowPaging={false} allowSorting={false} allowFiltering={false} allowExcelExport={true} allowPdfExport={true} queryCellInfo={this.onQueryCellInfo5} pageSettings={{ pageCount: 5, pageSize: 10, pageSizes: ['10', '50', 'Tutti'] }}
                                                    dataBound={this.onDatabound6.bind(this)} toolbarClick={this.toolbarClick4.bind(this)} rowDataBound={this.onRowDatabound4} enableAltRow={true} gridLines='Both' hierarchyPrintMode='All' height='60vh'>
                                                        <ColumnsDirective>
                                                            <ColumnDirective field='TipoSinistro' headerText='Tipo Sinistro' headerTemplate={headerTemplate} textAlign='Center' width='20%'></ColumnDirective>
                                                            <ColumnDirective field='LiquidatoMedio' headerText='Liquidato Medio (KPI1)' headerTemplate={headerTemplate} textAlign='Center'></ColumnDirective>
                                                            <ColumnDirective field='DeltaObiettivoKPI1' headerText='Delta su obiettivo (KPI1)' headerTemplate={headerTemplate} textAlign='Center'></ColumnDirective>
                                                            <ColumnDirective field='PercScaricoAnnuale' headerText='% Scarico Annuale (KPI2)' headerTemplate={headerTemplate} textAlign='Center'></ColumnDirective>
                                                            {/* <ColumnDirective field='DeltaObiettivoKPI2' headerText='Delta sinistri per obiettivo (KPI2)' headerTemplate={headerTemplate} textAlign='Center'></ColumnDirective> */}
                                                            <ColumnDirective field='TempoMedioRestituzione' headerText='Tempo Medio Restituzione (KPI4)' headerTemplate={headerTemplate} textAlign='Center'></ColumnDirective>
                                                            <ColumnDirective field='DeltaObiettivoKPI4' headerText='Delta su obiettivo (KPI4)' headerTemplate={headerTemplate} textAlign='Center'></ColumnDirective>
                                                            <ColumnDirective field='PercNonIndennizzabili' headerText='% Non Indennizzabili (KPI3)' headerTemplate={headerTemplate} textAlign='Center'></ColumnDirective>
                                                            <ColumnDirective headerText='' width='12%' textAlign='Center' template={this.provinceButtonTemplate}></ColumnDirective>
                                                        </ColumnsDirective>
                                                    <Inject services={[Toolbar, DetailRow, ExcelExport, CommandColumn, PdfExport, Filter, Sort, Page]}/>
                                                </GridComponent>  
                                            </BlockUi>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>);
    }
    legendaKPIGeneraliContent() {
        return (
            <div style={stylesLegend.legendContainer}>
                
                {/* Dicitura Aree/Ispettorati */}
                <div style={stylesLegend.infoBox}>
                    <div style={stylesLegend.infoIcon}>ℹ️</div>
                    <div style={stylesLegend.infoContent}>
                        <div style={stylesLegend.infoTitle}>Aree/Ispettorati Inclusi</div>
                        <div style={stylesLegend.infoText}>
                            L'estrazione attuale comprende le aree/ispettorati indicati di seguito (esclusi i sinistri <strong>R.C.</strong>):
                        </div>
                        <div style={stylesLegend.areaList}>
                            <strong>P0E, M2A, M2B, M2C, P1E, P2E, P1W, P2W, P3W, P0P, P1S, RFS, 2CP, M2F, O1P, O2P, O3P, O4P</strong>
                        </div>
                    </div>
                </div>

                {/* Dicitura Aree/Ispettorati RC */}
                <div style={stylesLegend.rcInfoBox}>
                    <div style={stylesLegend.infoIcon}>ℹ️</div>
                    <div style={stylesLegend.infoContent}>
                        <div style={stylesLegend.rcInfoTitle}>Aree/Ispettorati — Sinistri R.C.</div>
                        <div style={stylesLegend.rcInfoText}>
                            Per i sinistri di tipo <strong>R.C.</strong>, vengono considerate esclusivamente le seguenti aree/ispettorati:
                        </div>
                        <div style={stylesLegend.rcAreaList}>
                            <strong>U0R, U4R, U5R, O1G</strong>
                        </div>
                    </div>
                </div>

                {/* KPI1 Section */}
                <div style={stylesLegend.kpiSection}>
                    <div style={stylesLegend.kpiHeader}>
                        <span style={stylesLegend.kpiBadge}>KPI1</span>
                        <span>Liquidato Medio</span>
                    </div>
                    
                    <div style={stylesLegend.legendItem}>
                        <div style={stylesLegend.legendLabel}>
                            <span style={{...stylesLegend.legendIndicator, ...stylesLegend.indicatorBlue}}></span>
                            Acqua Condotta e altri tipi sinistro
                        </div>
                        <div style={stylesLegend.legendValue}>
                            <span style={stylesLegend.euroSymbol}>€</span> 1.250
                        </div>
                    </div>

                    <div style={stylesLegend.legendItem}>
                        <div style={stylesLegend.legendLabel}>
                            <span style={{...stylesLegend.legendIndicator, ...stylesLegend.indicatorOrange}}></span>
                            Evento Naturale
                        </div>
                        <div style={stylesLegend.legendValue}>
                            <span style={stylesLegend.euroSymbol}>€</span> 2.200
                        </div>
                    </div>

                    <div style={stylesLegend.legendItem}>
                        <div style={stylesLegend.legendLabel}>
                            <span style={{...stylesLegend.legendIndicator, ...stylesLegend.indicatorGreen}}></span>
                            Altri Rami Elementari
                        </div>
                        <div style={stylesLegend.legendValue}>
                            <span style={stylesLegend.euroSymbol}>€</span> 2.500
                        </div>
                    </div>
                </div>

                {/* KPI4 Section */}
                <div style={stylesLegend.kpiSection}>
                    <div style={stylesLegend.kpiHeader}>
                        <span style={stylesLegend.kpiBadge}>KPI4</span>
                        <span>Tempo Medio Restituzione</span>
                    </div>
                    
                    <div style={stylesLegend.legendItem}>
                        <div style={stylesLegend.legendLabel}>
                            <span style={{...stylesLegend.legendIndicator, ...stylesLegend.indicatorPurple}}></span>
                            Giorni Target
                        </div>
                        <div style={stylesLegend.legendValue}>
                            45 <span style={stylesLegend.daysLabel}>giorni</span>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
    GrigliaKPIHDIRender() {
        ++this.childKey;
        return(<React.Fragment>
            <div className="control-section card-control-section basic_card_layout">
                <div className="e-card-resize-container">
                    <div className="card-layout">
                        <div className="col-xs-12 col-sm-12 col-lg-12 col-md-12">
                            <div tabIndex="0" className="e-card" id="main_card">
                                <div className="e-card-content">

                                    {/* ACCORDION LEGENDA KPI */}
                                    <div className='row'>
                                        <div className="col-xs-12 col-sm-12 col-lg-12 col-md-12">
                                            <div style={{ marginTop: '10px', marginBottom: '15px' }}>
                                                <AccordionComponent>
                                                    <AccordionItemsDirective>
                                                        <AccordionItemDirective
                                                            header='📊 LEGENDA KPI - INFO E VALORI TARGET'
                                                            content={this.legendaKPIHDIContent.bind(this)}
                                                        />
                                                    </AccordionItemsDirective>
                                                </AccordionComponent>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='row'>
                                        <div className="col-xs-12 col-sm-12 col-lg-12 col-md-12">
                                            <BlockUi tag='div' id='blockUI2' blocking={this.state.blocking3} keepInView={true} loader={CustomJS.loaderSpinners[random(CustomJS.loaderSpinners.length - 1)]}>
                                                <GridComponent id="GridKPIHDI" key={this.childKey} ref={grid => this.gridInstanceHDI = grid} toolbar={this.toolbarOptions3} childGrid={this.childGridHDI} allowSelection={false} enableHover={false} allowTextWrap={true}
                                                    allowPaging={false} allowSorting={false} allowFiltering={false} allowExcelExport={true} allowPdfExport={true} queryCellInfo={this.onQueryCellInfo5} pageSettings={{ pageCount: 5, pageSize: 10, pageSizes: ['10', '50', 'Tutti'] }}
                                                    dataBound={this.onDataboundHDI.bind(this)} toolbarClick={this.toolbarClickHDI.bind(this)} rowDataBound={this.onRowDatabound4} enableAltRow={true} gridLines='Both' hierarchyPrintMode='All' height='60vh'>
                                                        <ColumnsDirective>
                                                            <ColumnDirective field='TipoSinistro' headerText='Tipo Sinistro' headerTemplate={headerTemplate} textAlign='Center' width='20%'></ColumnDirective>
                                                            <ColumnDirective field='LiquidatoMedio' headerText='Liquidato Medio (KPI1)' headerTemplate={headerTemplate} textAlign='Center'></ColumnDirective>
                                                            <ColumnDirective field='DeltaObiettivoKPI1' headerText='Delta su obiettivo (KPI1)' headerTemplate={headerTemplate} textAlign='Center'></ColumnDirective>
                                                            <ColumnDirective field='PercScaricoAnnuale' headerText='% Scarico Annuale (KPI2)' headerTemplate={headerTemplate} textAlign='Center'></ColumnDirective>
                                                            <ColumnDirective field='TempoMedioRestituzione' headerText='Tempo Medio Restituzione (KPI4)' headerTemplate={headerTemplate} textAlign='Center'></ColumnDirective>
                                                            <ColumnDirective field='DeltaObiettivoKPI4' headerText='Delta su obiettivo (KPI4)' headerTemplate={headerTemplate} textAlign='Center'></ColumnDirective>
                                                            <ColumnDirective field='PercNonIndennizzabili' headerText='% Non Indennizzabili (KPI3)' headerTemplate={headerTemplate} textAlign='Center'></ColumnDirective>
                                                            <ColumnDirective headerText='' width='12%' textAlign='Center' template={this.provinceButtonTemplateHDI}></ColumnDirective>
                                                        </ColumnsDirective>
                                                    <Inject services={[Toolbar, DetailRow, ExcelExport, CommandColumn, PdfExport, Filter, Sort, Page]}/>
                                                </GridComponent>
                                            </BlockUi>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>);
    }
    legendaKPIHDIContent() {
        return (
            <div style={stylesLegend.legendContainer}>

                {/* KPI1 Section */}
                <div style={stylesLegend.kpiSection}>
                    <div style={stylesLegend.kpiHeader}>
                        <span style={stylesLegend.kpiBadge}>KPI1</span>
                        <span>Liquidato Medio</span>
                    </div>

                    <div style={stylesLegend.legendItem}>
                        <div style={stylesLegend.legendLabel}>
                            <span style={{...stylesLegend.legendIndicator, ...stylesLegend.indicatorBlue}}></span>
                            Acqua Condotta e altri tipi sinistro
                        </div>
                        <div style={stylesLegend.legendValue}>
                            <span style={stylesLegend.euroSymbol}>€</span> 1.250
                        </div>
                    </div>

                    <div style={stylesLegend.legendItem}>
                        <div style={stylesLegend.legendLabel}>
                            <span style={{...stylesLegend.legendIndicator, ...stylesLegend.indicatorOrange}}></span>
                            Evento Naturale
                        </div>
                        <div style={stylesLegend.legendValue}>
                            <span style={stylesLegend.euroSymbol}>€</span> 2.200
                        </div>
                    </div>

                    <div style={stylesLegend.legendItem}>
                        <div style={stylesLegend.legendLabel}>
                            <span style={{...stylesLegend.legendIndicator, ...stylesLegend.indicatorGreen}}></span>
                            Altri Rami Elementari
                        </div>
                        <div style={stylesLegend.legendValue}>
                            <span style={stylesLegend.euroSymbol}>€</span> 2.500
                        </div>
                    </div>
                </div>

                {/* KPI4 Section */}
                <div style={stylesLegend.kpiSection}>
                    <div style={stylesLegend.kpiHeader}>
                        <span style={stylesLegend.kpiBadge}>KPI4</span>
                        <span>Tempo Medio Restituzione</span>
                    </div>

                    <div style={stylesLegend.legendItem}>
                        <div style={stylesLegend.legendLabel}>
                            <span style={{...stylesLegend.legendIndicator, ...stylesLegend.indicatorPurple}}></span>
                            Giorni Target
                        </div>
                        <div style={stylesLegend.legendValue}>
                            45 <span style={stylesLegend.daysLabel}>giorni</span>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
    GrigliaKPISARARender() {
        ++this.childKey;
        return(<React.Fragment>
            <div className="control-section card-control-section basic_card_layout">
                <div className="e-card-resize-container">
                    <div className="card-layout">
                        <div className="col-xs-12 col-sm-12 col-lg-12 col-md-12">
                            <div tabIndex="0" className="e-card" id="main_card">
                                <div className="e-card-content">

                                    {/* ACCORDION LEGENDA KPI */}
                                    <div className='row'>
                                        <div className="col-xs-12 col-sm-12 col-lg-12 col-md-12">
                                            <div style={{ marginTop: '10px', marginBottom: '15px' }}>
                                                <AccordionComponent>
                                                    <AccordionItemsDirective>
                                                        <AccordionItemDirective
                                                            header='📊 LEGENDA KPI - INFO E VALORI TARGET'
                                                            content={this.legendaKPISARAContent.bind(this)}
                                                        />
                                                    </AccordionItemsDirective>
                                                </AccordionComponent>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='row'>
                                        <div className="col-xs-12 col-sm-12 col-lg-12 col-md-12">
                                            <BlockUi tag='div' id='blockUI2' blocking={this.state.blocking3} keepInView={true} loader={CustomJS.loaderSpinners[random(CustomJS.loaderSpinners.length - 1)]}>
                                                <GridComponent id="GridKPISARA" key={this.childKey} ref={grid => this.gridInstanceSARA = grid} toolbar={this.toolbarOptions3} childGrid={this.childGridSARA} allowSelection={false} enableHover={false} allowTextWrap={true}
                                                    allowPaging={false} allowSorting={false} allowFiltering={false} allowExcelExport={true} allowPdfExport={true} queryCellInfo={this.onQueryCellInfo5} pageSettings={{ pageCount: 5, pageSize: 10, pageSizes: ['10', '50', 'Tutti'] }}
                                                    dataBound={this.onDataboundSARA.bind(this)} toolbarClick={this.toolbarClickSARA.bind(this)} rowDataBound={this.onRowDatabound4} enableAltRow={true} gridLines='Both' hierarchyPrintMode='All' height='60vh'>
                                                        <ColumnsDirective>
                                                            <ColumnDirective field='TipoSinistro' headerText='Tipo Sinistro' headerTemplate={headerTemplate} textAlign='Center' width='20%'></ColumnDirective>
                                                            <ColumnDirective field='LiquidatoMedio' headerText='Liquidato Medio (KPI1)' headerTemplate={headerTemplate} textAlign='Center'></ColumnDirective>
                                                            <ColumnDirective field='DeltaObiettivoKPI1' headerText='Delta su obiettivo (KPI1)' headerTemplate={headerTemplate} textAlign='Center'></ColumnDirective>
                                                            <ColumnDirective field='PercScaricoAnnuale' headerText='% Scarico Annuale (KPI2)' headerTemplate={headerTemplate} textAlign='Center'></ColumnDirective>
                                                            <ColumnDirective field='TempoMedioRestituzione' headerText='Tempo Medio Restituzione (KPI4)' headerTemplate={headerTemplate} textAlign='Center'></ColumnDirective>
                                                            <ColumnDirective field='DeltaObiettivoKPI4' headerText='Delta su obiettivo (KPI4)' headerTemplate={headerTemplate} textAlign='Center'></ColumnDirective>
                                                            <ColumnDirective field='PercNonIndennizzabili' headerText='% Non Indennizzabili (KPI3)' headerTemplate={headerTemplate} textAlign='Center'></ColumnDirective>
                                                            <ColumnDirective headerText='' width='12%' textAlign='Center' template={this.provinceButtonTemplateSARA}></ColumnDirective>
                                                        </ColumnsDirective>
                                                    <Inject services={[Toolbar, DetailRow, ExcelExport, CommandColumn, PdfExport, Filter, Sort, Page]}/>
                                                </GridComponent>
                                            </BlockUi>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>);
    }
    legendaKPISARAContent() {
        return (
            <div style={stylesLegend.legendContainer}>

                {/* KPI1 Section */}
                <div style={stylesLegend.kpiSection}>
                    <div style={stylesLegend.kpiHeader}>
                        <span style={stylesLegend.kpiBadge}>KPI1</span>
                        <span>Liquidato Medio</span>
                    </div>

                    <div style={stylesLegend.legendItem}>
                        <div style={stylesLegend.legendLabel}>
                            <span style={{...stylesLegend.legendIndicator, ...stylesLegend.indicatorBlue}}></span>
                            Acqua Condotta e altri tipi sinistro
                        </div>
                        <div style={stylesLegend.legendValue}>
                            <span style={stylesLegend.euroSymbol}>€</span> 1.250
                        </div>
                    </div>

                    <div style={stylesLegend.legendItem}>
                        <div style={stylesLegend.legendLabel}>
                            <span style={{...stylesLegend.legendIndicator, ...stylesLegend.indicatorOrange}}></span>
                            Evento Naturale
                        </div>
                        <div style={stylesLegend.legendValue}>
                            <span style={stylesLegend.euroSymbol}>€</span> 2.200
                        </div>
                    </div>

                    <div style={stylesLegend.legendItem}>
                        <div style={stylesLegend.legendLabel}>
                            <span style={{...stylesLegend.legendIndicator, ...stylesLegend.indicatorGreen}}></span>
                            Altri Rami Elementari
                        </div>
                        <div style={stylesLegend.legendValue}>
                            <span style={stylesLegend.euroSymbol}>€</span> 2.500
                        </div>
                    </div>
                </div>

                {/* KPI4 Section */}
                <div style={stylesLegend.kpiSection}>
                    <div style={stylesLegend.kpiHeader}>
                        <span style={stylesLegend.kpiBadge}>KPI4</span>
                        <span>Tempo Medio Restituzione</span>
                    </div>

                    <div style={stylesLegend.legendItem}>
                        <div style={stylesLegend.legendLabel}>
                            <span style={{...stylesLegend.legendIndicator, ...stylesLegend.indicatorPurple}}></span>
                            Giorni Target
                        </div>
                        <div style={stylesLegend.legendValue}>
                            45 <span style={stylesLegend.daysLabel}>giorni</span>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
    GrigliaKPIUnipolRender() {
        ++this.childKey;
        return(<React.Fragment>
            <div className="control-section card-control-section basic_card_layout">
                <div className="e-card-resize-container">
                    <div className="card-layout">
                        <div className="col-xs-12 col-sm-12 col-lg-12 col-md-12">                                           
                            <div tabIndex="0" className="e-card" id="main_card">                                                
                                <div className="e-card-content">
                                    
                                    {/* ACCORDION LEGENDA KPI */}
                                    <div className='row'>
                                        <div className="col-xs-12 col-sm-12 col-lg-12 col-md-12">
                                            <div style={{ marginTop: '10px', marginBottom: '15px' }}>
                                                <AccordionComponent>
                                                    <AccordionItemsDirective>
                                                        <AccordionItemDirective 
                                                            header='📊 LEGENDA KPI - INFO E VALORI TARGET' 
                                                            content={this.legendaKPIUnipolContent.bind(this)}
                                                        />
                                                    </AccordionItemsDirective>
                                                </AccordionComponent>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='row'>
                                        <div className="col-xs-12 col-sm-12 col-lg-12 col-md-12">
                                            <BlockUi tag='div' id='blockUI2' blocking={this.state.blocking3} keepInView={true} loader={CustomJS.loaderSpinners[random(CustomJS.loaderSpinners.length - 1)]}> 
                                                <GridComponent id="GridKPIUnipol" key={this.childKey} ref={grid => this.gridInstance5 = grid} toolbar={this.toolbarOptions3} childGrid={this.childGrid5} allowSelection={false} enableHover={false} allowTextWrap={true}
                                                    allowPaging={false} allowSorting={false} allowFiltering={false} allowExcelExport={true} allowPdfExport={true} queryCellInfo={this.onQueryCellInfo6} pageSettings={{ pageCount: 5, pageSize: 10, pageSizes: ['10', '50', 'Tutti'] }}
                                                    dataBound={this.onDatabound8.bind(this)} toolbarClick={this.toolbarClick5.bind(this)} rowDataBound={this.onRowDatabound4} enableAltRow={true} gridLines='Both' hierarchyPrintMode='All' height='60vh'>
                                                        <ColumnsDirective>
                                                            <ColumnDirective field='TipoSinistro' headerText='Tipo Sinistro' headerTemplate={headerTemplate} textAlign='Center' width='20%'></ColumnDirective>
                                                            <ColumnDirective field='LiquidatoMedio' headerText='Liquidato Medio (KPI4)' headerTemplate={headerTemplate} textAlign='Center'></ColumnDirective>
                                                            <ColumnDirective field='DeltaObiettivoKPI4' headerText='Delta su obiettivo (KPI4)' headerTemplate={headerTemplate} textAlign='Center'></ColumnDirective>
                                                            <ColumnDirective field='PercScaricoAnnuale' headerText='% Scarico Annuale (KPI3)' headerTemplate={headerTemplate} textAlign='Center'></ColumnDirective>
                                                            {/* <ColumnDirective field='DeltaObiettivoKPI3' headerText='Delta sinistri per obiettivo (KPI3)' headerTemplate={headerTemplate} textAlign='Center'></ColumnDirective> */}
                                                            <ColumnDirective field='TempoMedioRestituzione' headerText='Tempo Medio Restituzione (KPI2)' headerTemplate={headerTemplate} textAlign='Center'></ColumnDirective>
                                                            <ColumnDirective field='DeltaObiettivoKPI2' headerText='Delta su obiettivo (KPI2)' headerTemplate={headerTemplate} textAlign='Center'></ColumnDirective>
                                                            <ColumnDirective field='PercIncidenzaConcordato' headerText='Incidenza concordato (KPI5)' headerTemplate={headerTemplate} textAlign='Center'></ColumnDirective>
                                                            <ColumnDirective headerText='' width='12%' textAlign='Center' template={this.provinceButtonTemplateUnipol}></ColumnDirective>
                                                        </ColumnsDirective>
                                                    <Inject services={[Toolbar, DetailRow, ExcelExport, CommandColumn, PdfExport, Filter, Sort, Page]}/>
                                                </GridComponent>  
                                            </BlockUi>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>);
    }
    legendaKPIUnipolContent() {
        return (
            <div style={stylesLegend.legendContainer}>
                
                {/* KPI4 Section */}
                <div style={stylesLegend.kpiSection}>
                    <div style={stylesLegend.kpiHeader}>
                        <span style={stylesLegend.kpiBadge}>KPI4</span>
                        <span>Liquidato Medio</span>
                    </div>
                    
                    <div style={stylesLegend.legendItem}>
                        <div style={stylesLegend.legendLabel}>
                            <span style={{...stylesLegend.legendIndicator, ...stylesLegend.indicatorBlue}}></span>
                            Acqua Condotta e altri tipi sinistro
                        </div>
                        <div style={stylesLegend.legendValue}>
                            <span style={stylesLegend.euroSymbol}>€</span> 1.250
                        </div>
                    </div>

                    <div style={stylesLegend.legendItem}>
                        <div style={stylesLegend.legendLabel}>
                            <span style={{...stylesLegend.legendIndicator, ...stylesLegend.indicatorOrange}}></span>
                            Evento Naturale
                        </div>
                        <div style={stylesLegend.legendValue}>
                            <span style={stylesLegend.euroSymbol}>€</span> 1.400
                        </div>
                    </div>

                    <div style={stylesLegend.legendItem}>
                        <div style={stylesLegend.legendLabel}>
                            <span style={{...stylesLegend.legendIndicator, ...stylesLegend.indicatorGreen}}></span>
                            Altri Rami Elementari
                        </div>
                        <div style={stylesLegend.legendValue}>
                            <span style={stylesLegend.euroSymbol}>€</span> 1.400
                        </div>
                    </div>
                </div>

                {/* KPI2 Section */}
                <div style={stylesLegend.kpiSection}>
                    <div style={stylesLegend.kpiHeader}>
                        <span style={stylesLegend.kpiBadge}>KPI2</span>
                        <span>Tempo Medio Restituzione</span>
                    </div>
                    
                    <div style={stylesLegend.legendItem}>
                        <div style={stylesLegend.legendLabel}>
                            <span style={{...stylesLegend.legendIndicator, ...stylesLegend.indicatorPurple}}></span>
                            Giorni Target
                        </div>
                        <div style={stylesLegend.legendValue}>
                            45 <span style={stylesLegend.daysLabel}>giorni</span>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
    onQueryCellInfoSinistriPotenziali(args) {
        args.cell.style.fontWeight = 'bold';
        args.cell.style.fontSize = '1.0vw';
        if (args.column.index === 0 || args.column.index === 1) {
            args.cell.style.color = '#133B95';
        } else if (args.column.index === 2) {
            const val = parseInt(args.cell.innerText, 10);
            if (!isNaN(val)) {
                args.cell.innerText = val.toLocaleString('it-IT');
                args.cell.style.color = 'whitesmoke';
                // Lampeggio arancione quando mancano 5 giorni o meno alla scadenza obiettivo (30 o 45 gg)
                const sogliaLampeggio = (this.activeGiorni || 30) - 5;
                if (val > sogliaLampeggio) {
                    args.cell.bgColor = '#e65100';
                    args.cell.classList.add('kpi-glow-pulse');
                } else {
                    args.cell.bgColor = val < 30 ? '#2e7d32' : '#e65100';
                }
            }
        }
    }
    onDataboundSinistriPotenziali(args) {
        for (let ind = 0; ind <= 2; ind++) {
            const col = document.getElementById('GridSinistriPotenziali')?.querySelectorAll('.e-columnheader')[0]?.children[ind];
            if (col) col.style.backgroundColor = 'Linen';
        }
    }
    openSinistriPotenziali(giorni, idPerito = null) {
        this.activeGiorni = giorni;
        const useAllianzMode = this.state.kpiAllianzViewMode === 'kpiAllianz';
        let sinistri = _.filter(this.allianzRawDataAll, r =>
            r.ramo_50 === 'SI' &&
            ['Chiuso', 'In carico', 'Restituito'].includes(r.gruppo_stato) &&
            (r.grado || '').trim().toLowerCase() === 'semplice' &&
            r.Chiuso === 0 &&
            r.GiorniApertura != null &&
            r.GiorniApertura < giorni &&
            (!useAllianzMode || this.isInCoorteKPIAllianz(r))
        );
        if (idPerito) {
            sinistri = _.filter(sinistri, r => String(r.id_perito) === String(idPerito));
        }
        // Dal più vecchio (giorni di apertura più alti) al più recente
        sinistri = _.sortBy(sinistri, r => -r.GiorniApertura);

        this.dialogInstance2.header = `<div style="display:flex;align-items:center;gap:10px;padding:2px 0">
            <span style="font-size:1.6em;line-height:1">⏱️</span>
            <span style="font-size:1.2vw;font-weight:bold;color:#e65100">SINISTRI POTENZIALI CHIUSURA ${giorni} GG</span>
        </div>`;
        this.dialogInstance2.width = '45%';
        this.dialogInstance2.height = '82%';
        this.dialogInstance2.minHeight = '82%';
        this.dialogInstance2.buttons = [];
        this.dialogInstance2.beforeOpen = () => {
            const container = document.getElementById('defaultDialogContentProvince');
            const root = createRoot(container);
            root.unmount();
        };
        this.dialogInstance2.open = () => {
            const container = document.getElementById('defaultDialogContentProvince');
            const root = createRoot(container);
            root.render(this.GrigliaKPISinistriPotenziali(giorni, sinistri));
        };
        this.dialogInstance2.show();
    }
    GrigliaKPISinistriPotenziali(giorni, sinistri) {
        ++this.childKey;
        const entro30      = _.filter(sinistri, r => r.GiorniApertura < 30).length;
        const tra30e45     = _.filter(sinistri, r => r.GiorniApertura >= 30 && r.GiorniApertura < giorni).length;
        return (
            <React.Fragment>
                <div style={{
                    background: 'linear-gradient(135deg, #fff3e0 0%, #ffe0b2 60%, #fff8e1 100%)',
                    borderRadius: '10px',
                    padding: '14px 24px',
                    marginBottom: '16px',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '24px',
                    boxShadow: '0 2px 10px rgba(230,81,0,0.12)',
                    border: '1px solid #ffcc80'
                }}>
                    <div style={{ textAlign: 'center' }}>
                        <div style={{ fontSize: '1.8vw', fontWeight: '800', color: '#2e7d32', lineHeight: 1.1 }}>{entro30}</div>
                        <div style={{ fontSize: '0.8vw', color: '#2e7d32', fontWeight: '600', marginTop: '2px' }}>Entro 30 gg 🟢</div>
                    </div>
                    {giorni > 30 && <><div style={{ width: '1px', height: '40px', background: '#ffcc80' }}></div>
                    <div style={{ textAlign: 'center' }}>
                        <div style={{ fontSize: '1.8vw', fontWeight: '800', color: '#e65100', lineHeight: 1.1 }}>{tra30e45}</div>
                        <div style={{ fontSize: '0.8vw', color: '#e65100', fontWeight: '600', marginTop: '2px' }}>30–{giorni} gg 🟠</div>
                    </div></>}
                    <div style={{ width: '1px', height: '40px', background: '#ffcc80' }}></div>
                    <div style={{ fontSize: '0.85vw', color: '#546e7a', fontStyle: 'italic' }}>
                        ⏱️ 🟢 ancora entro target{giorni > 30 ? ` — 🟠 tra 30 e ${giorni} gg` : ''}
                    </div>
                </div>
                <GridComponent
                    id="GridSinistriPotenziali"
                    key={this.childKey}
                    ref={grid => this.gridInstancePot = grid}
                    dataSource={sinistri}
                    allowSorting={true}
                    allowPaging={false}
                    allowSelection={false}
                    enableHover={false}
                    allowTextWrap={true}
                    queryCellInfo={this.onQueryCellInfoSinistriPotenziali.bind(this)}
                    dataBound={this.onDataboundSinistriPotenziali.bind(this)}
                    enableAltRow={true}
                    gridLines='Both'
                    height='52vh'
                >
                    <ColumnsDirective>
                        <ColumnDirective field='IdSinistro' headerText='ID' headerTemplate={headerTemplate} textAlign='Center' width='20%'></ColumnDirective>
                        <ColumnDirective field='NominativoPerito' headerText='Perito' headerTemplate={headerTemplate} textAlign='Center' width='55%'></ColumnDirective>
                        <ColumnDirective field='GiorniApertura' headerText='Giorni' headerTemplate={headerTemplate} textAlign='Center' width='25%'></ColumnDirective>
                    </ColumnsDirective>
                    <Inject services={[Sort]}/>
                </GridComponent>
            </React.Fragment>
        );
    }
    onQueryCellInfoProvinceAllianz(args) {
        // Livello 1 — Province, solo KPI2
        // Cols: 0=ProvinciaCorta, 1=Provincia, 2=LiquidatoMedioGFRE, 3=ConteggioCampionGFRE
        args.cell.style.fontSize = '1.0vw';
        args.cell.style.fontWeight = 'bold';
        if (args.column.index === 0) {
            args.cell.style.color = 'white';
            args.cell.bgColor = '#b71c1c';
            args.cell.style.textAlign = 'center';
        } else if (args.column.index === 1) {
            args.cell.style.color = '#133B95';
        } else if (args.column.index === 2) {
            const val = Number(args.data?.LiquidatoMedioGFRE) || 0;
            args.cell.innerText = val.toLocaleString('it-IT', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
            if (val > 0) {
                args.cell.style.color = 'whitesmoke';
                args.cell.bgColor = val > 1679 ? '#DC143C' : '#00802B';
            } else {
                args.cell.style.color = 'purple';
            }
            if (args.data.ConteggioCampionGFRE !== undefined) {
                const testo = args.cell.innerText;
                args.cell.innerHTML = `${testo}<span style="font-size:0.65em;margin-left:5px">(${args.data.ConteggioCampionGFRE})</span>`;
            }
        }
    }
    onQueryCellInfoProvincePeritorAllianz(args) {
        // Livello 2 — Periti, solo KPI2
        // Cols: 0=NominativoPerito, 1=LiquidatoMedioGFRE
        args.cell.style.fontSize = '1.0vw';
        args.cell.style.fontWeight = 'bold';
        if (args.column.index === 0) {
            args.cell.style.color = '#133B95';
        } else if (args.column.index === 1) {
            const val = Number(args.data?.LiquidatoMedioGFRE) || 0;
            args.cell.innerText = val.toLocaleString('it-IT', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
            if (val > 0) {
                args.cell.style.color = 'whitesmoke';
                args.cell.bgColor = val > 1679 ? '#DC143C' : '#00802B';
            } else {
                args.cell.style.color = 'purple';
            }
            if (args.data.ConteggioCampionGFRE !== undefined) {
                const testo = args.cell.innerText;
                args.cell.innerHTML = `${testo}<span style="font-size:0.65em;margin-left:5px">(${args.data.ConteggioCampionGFRE})</span>`;
            }
        }
    }
    openKPI2PerProvinciaAllianz(idPerito = null) {
        this.activeContext = 'allianz';
        this.activeChildGridProvince = this.childGridProvinceAllianz;
        this.activeProvQCIParent = this.onQueryCellInfoProvinceAllianz.bind(this);

        const sigleAllianz = ['MI', 'TO', 'AT', 'CO', 'MB', 'SS', 'VA'];

        let data = _.filter(this.allianzRawData, r =>
            sigleAllianz.includes((r.provincia_corta || '').toUpperCase())
        );
        if (idPerito) {
            data = _.filter(data, r => String(r.id_perito) === String(idPerito));
        }

        const calcolaKPI2Prov = (records) => {
            const chiusi = _.filter(records, r => r.Chiuso === 1);
            const indennizzabili = _.filter(chiusi, r =>
                r.TotaleDannoIndennizzabile >= 1 && r.TotaleDannoIndennizzabile <= 10000
            );
            const totalLiquidato = _.reduce(indennizzabili, (sum, r) => sum + (r.TotaleDannoIndennizzabile || 0), 0);
            const liquidatoMedio = indennizzabili.length > 0 ? totalLiquidato / indennizzabili.length : 0;
            return {
                LiquidatoMedioGFRE: parseFloat(liquidatoMedio.toFixed(2)),
                ConteggioCampionGFRE: indennizzabili.length,
                ConteggioCampione: indennizzabili.length
            };
        };

        const groupedByProv = _.groupBy(data, 'provincia_corta');
        this.gridDataProv1 = _.sortBy(
            _.filter(
                _.map(groupedByProv, (records, sigla) => ({
                    ProvinciaCorta: sigla,
                    Provincia: records[0]?.provincia || sigla,
                    ...calcolaKPI2Prov(records)
                })),
                r => r.ConteggioCampionGFRE > 0
            ),
            'ProvinciaCorta'
        );
        this.gridDataProv2 = [];
        _.each(groupedByProv, (records, sigla) => {
            _.each(_.groupBy(records, 'id_perito'), (peritoRecords, peritoId) => {
                const kpi = calcolaKPI2Prov(peritoRecords);
                if (kpi.ConteggioCampionGFRE > 0) {
                    this.gridDataProv2.push({
                        ProvinciaCorta: sigla,
                        id_perito: peritoId,
                        NominativoPerito: peritoRecords[0]?.NominativoPerito || 'Sconosciuto',
                        ...kpi
                    });
                }
            });
        });
        this.activeChildGridProvince.dataSource = this.gridDataProv2;

        this.dialogInstance2.header = `<div style="display:flex;align-items:center;gap:10px;padding:2px 0">
            <span style="font-size:1.6em;line-height:1">🗺️</span>
            <span style="font-size:1.4vw;font-weight:bold;color:#b71c1c">KPI2 — LIQUIDATO MEDIO GF-RE PER PROVINCIA · ALLIANZ</span>
        </div>`;
        this.dialogInstance2.width = '60%';
        this.dialogInstance2.height = '85%';
        this.dialogInstance2.minHeight = '85%';
        this.dialogInstance2.buttons = [];
        this.dialogInstance2.beforeOpen = () => {
            const container = document.getElementById('defaultDialogContentProvince');
            const root = createRoot(container);
            root.unmount();
        };
        this.dialogInstance2.open = () => {
            const container = document.getElementById('defaultDialogContentProvince');
            const root = createRoot(container);
            root.render(this.GrigliaProvinceRender('KPI2 ALLIANZ'));
        };
        this.dialogInstance2.show();
    }
    GrigliaKPIAllianzRender() {
        ++this.childKey;
        return(<React.Fragment>
            <div className="control-section card-control-section basic_card_layout">
                <div className="e-card-resize-container">
                    <div className="card-layout">
                        <div className="col-xs-12 col-sm-12 col-lg-12 col-md-12">                                           
                            <div tabIndex="0" className="e-card" id="main_card">                                                
                                <div className="e-card-content">

                                    {/* TOGGLE MODALITÀ VISUALIZZAZIONE KPI (KPI3 — scarico 30/45 gg) */}
                                    <div className='row'>
                                        <div className="col-xs-12 col-sm-12 col-lg-12 col-md-12">
                                            <div style={{
                                                background: 'linear-gradient(135deg, #e3f2fd 0%, #ffffff 100%)',
                                                borderRadius: '10px',
                                                padding: '14px 20px',
                                                marginTop: '10px',
                                                marginBottom: '15px',
                                                border: '3px solid #1565c0',
                                                boxShadow: '0 2px 12px rgba(21,101,192,0.35)',
                                                display: 'flex',
                                                alignItems: 'center',
                                                flexWrap: 'wrap',
                                                gap: '10px'
                                            }}>
                                                <span style={{ fontSize: '0.9vw', fontWeight: 'bold', color: '#133B95', marginRight: 'auto' }}>
                                                    🔀 Modalità di visualizzazione KPI3
                                                </span>
                                                <ButtonComponent
                                                    id='btnKPIAllianzRealtime'
                                                    cssClass={this.state.kpiAllianzViewMode === 'realtime' ? 'e-primary' : 'e-flat'}
                                                    onClick={() => this.cambiaModalitaKPIAllianz('realtime')}
                                                >VISUALIZZAZIONE KPI3 IN TEMPO REALE</ButtonComponent>
                                                <ButtonComponent
                                                    id='btnKPIAllianzUfficiale'
                                                    cssClass={this.state.kpiAllianzViewMode === 'kpiAllianz' ? 'e-primary' : 'e-flat'}
                                                    onClick={() => this.cambiaModalitaKPIAllianz('kpiAllianz')}
                                                >VISUALIZZAZIONE KPI3 ALLIANZ</ButtonComponent>
                                            </div>
                                        </div>
                                    </div>

                                    {/* ACCORDION LEGENDA KPI */}
                                    <div className='row'>
                                        <div className="col-xs-12 col-sm-12 col-lg-12 col-md-12">
                                            <div style={{ marginTop: '10px', marginBottom: '15px' }}>
                                                <AccordionComponent>
                                                    <AccordionItemsDirective>
                                                        <AccordionItemDirective
                                                            header='📊 LEGENDA KPI - INFO E VALORI TARGET'
                                                            content={this.legendaKPIAllianzContent.bind(this)}
                                                        />
                                                    </AccordionItemsDirective>
                                                </AccordionComponent>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='row'>
                                        <div className="col-xs-12 col-sm-12 col-lg-12 col-md-12">
                                            <BlockUi tag='div' id='blockUI2' blocking={this.state.blocking3} keepInView={true} loader={CustomJS.loaderSpinners[random(CustomJS.loaderSpinners.length - 1)]}> 
                                                <GridComponent id="GridKPIAllianz" key={this.childKey} ref={grid => this.gridInstance6 = grid} toolbar={this.toolbarOptions3} allowSelection={false} enableHover={false} allowTextWrap={true} childGrid={this.childGrid6} 
                                                    allowPaging={false} allowSorting={false} allowFiltering={false} allowExcelExport={true} allowPdfExport={true} queryCellInfo={this.onQueryCellInfo7.bind(this)} pageSettings={{ pageCount: 5, pageSize: 10, pageSizes: ['10', '50', 'Tutti'] }}
                                                    dataBound={this.onDatabound10.bind(this)} toolbarClick={this.toolbarClick6.bind(this)} enableAltRow={true} gridLines='Both' hierarchyPrintMode='All' height='60vh'>
                                                        <ColumnsDirective>
                                                            <ColumnDirective field='TipoSinistro' headerText='Tipo Sinistro' visible={false} headerTemplate={headerTemplate} textAlign='Center' width='20%'></ColumnDirective>
                                                            <ColumnDirective field='LiquidatoMedioGFRE' headerText='Liquidato Medio GF-RE (KPI2)' headerTemplate={headerTemplate} textAlign='Center'></ColumnDirective>
                                                            <ColumnDirective field='DeltaObiettivoKPI2' headerText='Delta su obiettivo (KPI2)' headerTemplate={headerTemplate} textAlign='Center'></ColumnDirective>
                                                            <ColumnDirective field='PercScaricoGFRE' headerText='% Scarico GF-RE (KPI1)' headerTemplate={headerTemplate} textAlign='Center'></ColumnDirective>
                                                            <ColumnDirective field='DeltaObiettivoKPI1' headerText='Sinistri mancanti obiettivo (KPI1)' headerTemplate={headerTemplate} textAlign='Center'></ColumnDirective>
                                                            <ColumnDirective field='PercScaricoHome30GG' headerText='% Scarico Rami HOME 30 GG (KPI3)' headerTemplate={headerTemplate} textAlign='Center'></ColumnDirective>
                                                            <ColumnDirective field='DeltaObiettivoKPI330' headerText='Sinistri mancanti obiettivo 30 GG (KPI3)' headerTemplate={headerTemplate} textAlign='Center'></ColumnDirective>
                                                            <ColumnDirective field='PercScaricoHome45GG' headerText='% Scarico Rami HOME 45 GG (KPI3)' headerTemplate={headerTemplate} textAlign='Center'></ColumnDirective>
                                                            <ColumnDirective field='DeltaObiettivoKPI345' headerText='Sinistri mancanti obiettivo 45 GG (KPI3)' headerTemplate={headerTemplate} textAlign='Center'></ColumnDirective>
                                                            <ColumnDirective field='PercScaricoRCD' headerText='% Scarico RCD (KPI4)' headerTemplate={headerTemplate} textAlign='Center'></ColumnDirective>
                                                            <ColumnDirective field='DeltaObiettivoKPI4' headerText='Sinistri mancanti obiettivo (KPI4)' headerTemplate={headerTemplate} textAlign='Center'></ColumnDirective>
                                                            <ColumnDirective field='PercScaricoVideoperiziaHome' headerText='% Videoperizia Rami HOME (KPI5)' headerTemplate={headerTemplate} textAlign='Center'></ColumnDirective>
                                                            <ColumnDirective field='DeltaObiettivoKPI5' headerText='Sinistri mancanti obiettivo (KPI5)' headerTemplate={headerTemplate} textAlign='Center'></ColumnDirective>
                                                            <ColumnDirective headerText='' width='9%' textAlign='Center' template={this.allianzKPI2ProvinceButton}></ColumnDirective>
                                                        </ColumnsDirective>
                                                    <Inject services={[Toolbar, DetailRow, ExcelExport, CommandColumn, PdfExport, Filter, Sort, Page]}/>
                                                </GridComponent>  
                                            </BlockUi>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>);
    }
    legendaKPIAllianzContent() {
        const meseCorrente = `${new Date().getFullYear()}${String(new Date().getMonth() + 1).padStart(2, '0')}`; // es. '202511'
        const obiettivoJSONGFRE = CurvaObiettivi.CurvaObiettivi.find(o => o.RAMO === "PERCSCARALLIANZGFRE");
        const obiettivoMensileGFRE = obiettivoJSONGFRE ? parseFloat(obiettivoJSONGFRE[meseCorrente]) : 0;
        const obiettivoJSONRCD = CurvaObiettivi.CurvaObiettivi.find(o => o.RAMO === "PERCSCARALLIANZRCD");
        const obiettivoMensileRCD = obiettivoJSONRCD ? parseFloat(obiettivoJSONRCD[meseCorrente]) : 0;
        const riferimentoKPI2 = 1679.00;

        return (
            <div style={stylesLegend.legendContainer}>
                {/* KPI1 Section */}
                <div style={stylesLegend.kpiSection}>
                    <div style={stylesLegend.kpiHeader}>
                        <span style={stylesLegend.kpiBadge}>KPI1</span>
                        <span>Percentuale Scarico GF-RE</span>
                    </div>
                    <div style={stylesLegend.legendItem}>
                        <div style={stylesLegend.legendLabel}>
                            <span style={{...stylesLegend.legendIndicator, ...stylesLegend.indicatorBlue}}></span>
                            Obiettivo Mensile
                        </div>
                        <div style={stylesLegend.legendValue}>
                            {obiettivoMensileGFRE} <span style={stylesLegend.percLabel}>%</span>
                        </div>
                    </div>
                </div>

                {/* KPI2 Section */}
                <div style={stylesLegend.kpiSection}>
                    <div style={stylesLegend.kpiHeader}>
                        <span style={stylesLegend.kpiBadge}>KPI2</span>
                        <span>Liquidato Medio GF-RE</span>
                    </div>
                    <div style={stylesLegend.legendItem}>
                        <div style={stylesLegend.legendLabel}>
                            <span style={{...stylesLegend.legendIndicator, ...stylesLegend.indicatorOrange}}></span>
                            Obiettivo Riferimento
                        </div>
                        <div style={stylesLegend.legendValue}>
                            <span style={stylesLegend.euroSymbol}>€</span> {riferimentoKPI2.toLocaleString()}
                        </div>
                    </div>
                </div>

                {/* KPI3 Section */}
                <div style={stylesLegend.kpiSection}>
                    <div style={stylesLegend.kpiHeader}>
                        <span style={stylesLegend.kpiBadge}>KPI3</span>
                        <span>Percentuale Scarico Rami HOME</span>
                    </div>
                    <div style={stylesLegend.legendItem}>
                        <div style={stylesLegend.legendLabel}>
                            <span style={{...stylesLegend.legendIndicator, ...stylesLegend.indicatorGreen}}></span>
                            Obiettivo Entro 30 Giorni
                        </div>
                        <div style={stylesLegend.legendValue}>
                            75 <span style={stylesLegend.percLabel}>%</span>
                        </div>
                    </div>
                    <div style={stylesLegend.legendItem}>
                        <div style={stylesLegend.legendLabel}>
                            <span style={{...stylesLegend.legendIndicator, ...stylesLegend.indicatorPurple}}></span>
                            Obiettivo Entro 45 Giorni
                        </div>
                        <div style={stylesLegend.legendValue}>
                            80 <span style={stylesLegend.percLabel}>%</span>
                        </div>
                    </div>
                </div>

                {/* KPI4 Section */}
                <div style={stylesLegend.kpiSection}>
                    <div style={stylesLegend.kpiHeader}>
                        <span style={stylesLegend.kpiBadge}>KPI4</span>
                        <span>Percentuale Scarico RCD</span>
                    </div>
                    <div style={stylesLegend.legendItem}>
                        <div style={stylesLegend.legendLabel}>
                            <span style={{...stylesLegend.legendIndicator, ...stylesLegend.indicatorBlue}}></span>
                            Obiettivo Mensile
                        </div>
                        <div style={stylesLegend.legendValue}>
                            {obiettivoMensileRCD} <span style={stylesLegend.percLabel}>%</span>
                        </div>
                    </div>
                </div>

                {/* KPI5 Section */}
                <div style={stylesLegend.kpiSection}>
                    <div style={stylesLegend.kpiHeader}>
                        <span style={stylesLegend.kpiBadge}>KPI5</span>
                        <span>Percentuale Videoperizia Rami HOME</span>
                    </div>
                    <div style={stylesLegend.legendItem}>
                        <div style={stylesLegend.legendLabel}>
                            <span style={{...stylesLegend.legendIndicator, ...stylesLegend.indicatorBlue}}></span>
                            Obiettivo Riferimento
                        </div>
                        <div style={stylesLegend.legendValue}>
                            45 <span style={stylesLegend.percLabel}>%</span>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    render() {
        const { visibleColumnGroups } = this.state;
        return (<React.Fragment>
            {/* <img src={LavoriInCorso} alt='' width='70%' height='auto'/>  */}
            <div className='container-fluid'>   
                <DialogComponent id="defaultDialogObiettivi" showCloseIcon={true} target='body' animationSettings={this.animationSettings} visible={this.state.showDialog1}
                        ref={dialog => this.dialogInstance = dialog} isModal={true} height='90%' width='90%' minHeight='90%'>
                            <div id='defaultDialogContentObiettivi'></div>
                </DialogComponent>
                <DialogComponent id="defaultDialogProvince" showCloseIcon={true} target='body' animationSettings={this.animationSettings} visible={false}
                        ref={dialog => this.dialogInstance2 = dialog} isModal={true} height='90%' width='92%' minHeight='90%'>
                            <div id='defaultDialogContentProvince'></div>
                </DialogComponent>
                <div className='row'>
                    <div className="col-xs-12 col-sm-3 col-lg-3 col-md-3 ml-2" style={{ marginTop: '15px', marginBottom: '15px' }}>
                        <span style={{ fontSize: '2.0vw', fontWeight: 'bolder', color:'#133B95'}}>
                            {this.state.meseAtt + ' ' + yyyy.toString()}
                        </span>
                    </div> 
                    <div className="col-xs-12 col-sm-2 col-lg-9 col-md-9 text-center" style={{ marginTop: '15px', marginBottom: '15px'}}>
                        <span id='testoChiusiAnnoCorr' style={{ fontSize: '1.4vw', fontWeight: 'bolder', color:'#133B95'}}>
                            {visibleColumnGroups.includes('AC') && `OBIETTIVO AC: ${this.state.ObietMeseACatt}%`}
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            {visibleColumnGroups.includes('RE') && `OBIETTIVO RE: ${this.state.ObietMeseREatt}%`}
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            {visibleColumnGroups.includes('RC') && `OBIETTIVO RC: ${this.state.ObietMeseRCatt}%`}
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            {visibleColumnGroups.includes('EN') && `OBIETTIVO EN: ${this.state.ObietMeseENatt}%`}
                        </span>
                    </div> 
                </div>                
                <div className='row'>
                    <div className="col-xs-12 col-sm-12 offset-lg-9 col-lg-3 offset-md-7 col-md-5">
                        <DropDownListComponent id='ddlMesi' fields={this.ddlFields} ref={ ddlObj => this.ddlInstance2 = ddlObj } enabled={false} dataSource={this.ddlMesiFiltr} change={this.onChangeMese.bind(this)}
                             placeholder="Selezionare un mese da visualizzare" floatLabelType='always' popupHeight="250px" cssClass='e-outline'></DropDownListComponent>
                    </div>
                </div> 
                <div className='row'>
                    <div className="col-xs-12 col-sm-12 col-lg-12 col-md-12">
                        <BlockUi tag='div' id='blockUI1' blocking={this.state.blocking2} keepInView={true} loader={CustomJS.loaderSpinners[random(CustomJS.loaderSpinners.length - 1)]}> 
                            <GridComponent id="GridObiettivi" ref={grid => this.gridInstance = grid} toolbar={this.toolbarOptions} childGrid={this.childGrid} allowSelection={false} enableHover={false} allowTextWrap={true} commandClick={this.onCommandClick.bind(this)} 
                                allowPaging={false} allowSorting={false} allowFiltering={false} allowExcelExport={true} allowPdfExport={true} queryCellInfo={this.onQueryCellInfo.bind(this)} pageSettings={{ pageCount: 5, pageSize: 10, pageSizes: ['10', '50', 'Tutti'] }}
                                dataBound={this.onDatabound.bind(this)} toolbarClick={this.toolbarClick.bind(this)} rowDataBound={this.onRowDatabound} enableAltRow={true} gridLines='Both' hierarchyPrintMode='All'>
                                    <ColumnsDirective>
                                        <ColumnDirective field='DescrCompagnia' headerText='Compagnia' headerTemplate={headerTemplate} textAlign='Center' width='18%'></ColumnDirective>
                                        <ColumnDirective 
                                            visible={visibleColumnGroups.includes('AC')}
                                            columns={[
                                                { field: 'ScarTotSinAC', headerText: 'Scarico Totale', headerTemplate: headerTemplate3, textAlign: 'Center' }, 
                                                { field: 'NumSinistriMancantiAC', headerText: 'Sinistri Mancanti', headerTemplate: headerTemplate3, textAlign:'Center' },
                                                { field: 'TempoMedioScaricoAC', headerText: 'Tempo Medio Scarico', headerTemplate: headerTemplate3, textAlign: 'Center'}
                                            ]} 
                                            headerText='Acqua Condotta' 
                                            headerTemplate={headerTemplate} 
                                            textAlign='Center'>
                                        </ColumnDirective>                                        
                                        <ColumnDirective 
                                            visible={visibleColumnGroups.includes('RE')}
                                            columns={[
                                                { field: 'ScarTotSinRE', headerText: 'Scarico Totale', headerTemplate: headerTemplate3, textAlign: 'Center' }, 
                                                { field: 'NumSinistriMancantiRE', headerText: 'Sinistri Mancanti', headerTemplate: headerTemplate3, textAlign:'Center' },
                                                { field: 'TempoMedioScaricoRE', headerText: 'Tempo Medio Scarico', headerTemplate: headerTemplate3, textAlign: 'Center'}
                                            ]} 
                                            headerText='Rami Elementari' 
                                            headerTemplate={headerTemplate} 
                                            textAlign='Center'>
                                        </ColumnDirective>                                        
                                        <ColumnDirective 
                                            visible={visibleColumnGroups.includes('RC')}
                                            columns={[
                                                { field: 'ScarTotSinRC', headerText: 'Scarico Totale', headerTemplate: headerTemplate3, textAlign: 'Center' }, 
                                                { field: 'NumSinistriMancantiRC', headerText: 'Sinistri Mancanti', headerTemplate: headerTemplate3, textAlign:'Center' },
                                                { field: 'TempoMedioScaricoRC', headerText: 'Tempo Medio Scarico', headerTemplate: headerTemplate3, textAlign: 'Center'}
                                            ]} 
                                            headerText='Responsabilità Civile' 
                                            headerTemplate={headerTemplate} 
                                            textAlign='Center'>
                                        </ColumnDirective>                                        
                                        <ColumnDirective 
                                            visible={visibleColumnGroups.includes('EN')}
                                            columns={[
                                                { field: 'ScarTotSinEN', headerText: 'Scarico Totale', headerTemplate: headerTemplate3, textAlign: 'Center' }, 
                                                { field: 'NumSinistriMancantiEN', headerText: 'Sinistri Mancanti', headerTemplate: headerTemplate3, textAlign:'Center' },
                                                { field: 'TempoMedioScaricoEN', headerText: 'Tempo Medio Scarico', headerTemplate: headerTemplate3, textAlign: 'Center'}
                                            ]} 
                                            headerText='Eventi Naturali' 
                                            headerTemplate={headerTemplate} 
                                            textAlign='Center'>
                                        </ColumnDirective>
                                        <ColumnDirective field='Comandi' headerText="" commands={this.commands} width='4%' textAlign='Left'></ColumnDirective>
                                    </ColumnsDirective>
                                <Inject services={[Toolbar, DetailRow, ExcelExport, CommandColumn, PdfExport, Filter, Sort, Page]}/>                    
                            </GridComponent>  
                        </BlockUi>
                    </div>
                </div>
                <div className="row"  style={{ marginTop: '50px', marginBottom: '20px', display: 'none' }}>   
                    <div className="col-xs-12 col-sm-12 col-lg-12 col-md-12">
                        <span style={{ fontSize: '1.6vw', fontWeight: 'bold', color:'#133B95'}}>Confronto andamento obiettivi/risultati sinistri RE</span>
                    </div>               
                </div> 
                <div className='row' style={{ display: 'none' }}>
                    <div className="col-xs-12 col-sm-12 col-lg-12 col-md-12">
                        <ChartComponent id='ChartObiettRE' style={{ textAlign: "center" }}
                            className='col-xs-12 col-sm-12 col-lg-12 col-md-12'
                            ref={chart => {this.chartInstance1 = chart}}
                            primaryXAxis={{
                                valueType: 'DateTime',
                                labelFormat: 'MMMM',
                                intervalType: 'Months',
                                edgeLabelPlacement: 'Shift',
                                majorGridLines: { width: 0 }                
                            }}
                            primaryYAxis={{
                                labelFormat: '{value}',
                                rangePadding: 'None',                                
                                interval: 10,
                                lineStyle: { width: 0 },                                
                                minimum: 0,
                                majorTickLines: { width: 0 },
                                minorTickLines: { width: 0 }
                            }}
                            chartArea={{ border: { width: 0 } }}
                            tooltip={{ enable: true }}
                            title='' 
                            width='97%'
                            legendSettings={{ visible: true }}>
                            <Inject services={[LineSeries, DateTime, Legend, Tooltip, Trendlines]} />
                            <SeriesCollectionDirective>
                                <SeriesDirective xName='x' yName='y' name={`Obiettivi mensili RE`}
                                    width={3} marker={{ visible: true, width: 10, height: 10 }} type='Line'>
                                </SeriesDirective>
                                <SeriesDirective xName='x' yName='y' name={`Risultati mensili RE`}
                                    width={3} marker={{ visible: true, width: 10, height: 10 }} type='Line'>
                                </SeriesDirective>
                            </SeriesCollectionDirective>
                        </ChartComponent>
                    </div>
                </div>
                <div className='row'  style={{ marginTop: '50px', marginBottom: '20px', display: 'none' }}>                       
                    <div className="col-xs-12 col-sm-12 col-lg-12 col-md-12">
                        <span style={{ fontSize: '1.6vw', fontWeight: 'bold', color:'#133B95'}}>Confronto andamento obiettivi/risultati sinistri RC</span>
                    </div>        
                </div>    
                <div className='row' style={{ display: 'none' }}>
                    <div className="col-xs-12 col-sm-12 col-lg-12 col-md-12">
                        <ChartComponent id='ChartObiettRC' style={{ textAlign: "center"}}
                            className='col-xs-12 col-sm-12 col-lg-12 col-md-12'
                            ref={chart => {this.chartInstance1 = chart}}
                            primaryXAxis={{
                                valueType: 'DateTime',
                                labelFormat: 'MMMM',
                                intervalType: 'Months',
                                edgeLabelPlacement: 'Shift',
                                majorGridLines: { width: 0 }                
                            }}
                            primaryYAxis={{
                                labelFormat: '{value}',
                                rangePadding: 'None',                                
                                interval: 10,
                                lineStyle: { width: 0 },                                
                                minimum: 0,
                                majorTickLines: { width: 0 },
                                minorTickLines: { width: 0 }
                            }}
                            chartArea={{ border: { width: 0 } }}
                            tooltip={{ enable: true }}
                            width='97%'
                            title='' 
                            legendSettings={{ visible: true }}>
                            <Inject services={[LineSeries, DateTime, Legend, Tooltip, Trendlines]} />
                            <SeriesCollectionDirective>
                                <SeriesDirective xName='x' yName='y' name={`Obiettivi mensili RC`}
                                    width={3} marker={{ visible: true, width: 10, height: 10 }} type='Line'>
                                </SeriesDirective>
                                <SeriesDirective xName='x' yName='y' name={`Risultati mensili RC`}
                                    width={3} marker={{ visible: true, width: 10, height: 10 }} type='Line'>
                                </SeriesDirective>
                            </SeriesCollectionDirective>
                        </ChartComponent>
                    </div>
                </div>
            </div>
        </React.Fragment>);
    }      
    componentDidMount() {
        CustomJS.callAPI(`${CustomJS.APIMonitorURLProd}/api/Monitor/portingTutteAPI/compagnie/[NO]/[NO]/[NO]/[NO]/[NO]/[NO]`, '', 'GET', '', retData => {
            ddlData = retData;     
            this.ddlInstance2.value = mm;           
        }, error => {
            let messaggio = (_.isString(error) && error.indexOf('Not Found')) > -1 ? CustomJS.messaggioAPIBackendNonTrovata : CustomJS.messaggioNoBackend;
            toast.warn(messaggio, {
                containerId: 'toastContainer1',
                position: "top-right",
                autoClose: 8000,
                hideProgressBar: false,            
                closeOnClick: true,
                pauseOnHover: true,
                draggable: false,
                progress: undefined,
                newestOnTop: true,
                rtl: false,
                pauseOnFocusLoss: true
            })
        }, true, false);    
    }
    componentWillUnmount() {
        // ✅ Cleanup refs
        if (this.ddlGruppiColonneInstance && !this.ddlGruppiColonneInstance.isDestroyed) {
            try {
                this.ddlGruppiColonneInstance.destroy();
            } catch (e) {
                console.warn('Errore durante cleanup ddlGruppiColonne:', e);
            }
        }
        
        if (this.ddlGruppiColonneInstance2 && !this.ddlGruppiColonneInstance2.isDestroyed) {
            try {
                this.ddlGruppiColonneInstance2.destroy();
            } catch (e) {
                console.warn('Errore durante cleanup ddlGruppiColonne2:', e);
            }
        }
    }
    caricaDati() {
        GridData1 = []; GridData2 = []; data1 = []; data2 = []; data3 = []; data4 = []; periti = [];
        let dataFineEstr = '';
        if (this.ddlInstance2.value === mm)
            dataFineEstr = dataCorrente;
        else { 
            const meseEstr = this.ddlInstance2.value;
            const giorno = (mm === '02') ? CustomJS.leapYear(yyyy.toString()) ? '29' : '28' : (meseEstr === '01' || meseEstr === '03' || meseEstr === '05' || meseEstr === '07' || meseEstr === '08' || meseEstr === '10' || meseEstr === '12') ? '31' : '30';            
            dataFineEstr = yyyy.toString() + this.ddlInstance2.value + giorno;
            //dataFineEstr = yyyy.toString() + '-' + this.ddlInstance2.value + '-' + giorno;
        }
        ObietMeseAC = _.find(CurvaObiettivi.CurvaObiettivi, elm => { return elm.RAMO === 'AC'})[yyyy.toString() + this.ddlInstance2.value]; 
        ObietMeseRE = _.find(CurvaObiettivi.CurvaObiettivi, elm => { return elm.RAMO === 'RE'})[yyyy.toString() + this.ddlInstance2.value]; 
        ObietMeseRC = _.find(CurvaObiettivi.CurvaObiettivi, elm => { return elm.RAMO === 'RC'})[yyyy.toString() + this.ddlInstance2.value];
        ObietMeseEN = _.find(CurvaObiettivi.CurvaObiettivi, elm => { return elm.RAMO === 'EN'})?.[yyyy.toString() + this.ddlInstance2.value];
        this.toggleBlocking();
        CustomJS.callAPI(`${CustomJS.APIMonitorURLProd}/api/Monitor/portingTutteAPI/scaricoCompagnie/${yyyy.toString()}-01-01 00:00:00/${dataFineEstr}/[NO]/[NO]/[NO]/rercacen`, '', 'GET', '', retData => {
            retData = retData.filter(elm => !this.excludedCompany.includes(Number(elm.IdCompagnia)));
            let  groupedArr = _.groupBy(retData, 'IdCompagnia');
            let NumChiusiAC = 0, NumEntratiAC = 0, NumChiusiRE = 0, NumEntratiRE = 0, NumChiusiRC = 0, NumEntratiRC = 0, NumChiusiEN = 0, NumEntratiEN = 0;
            let TempoMedioScarAC = 0, TempoMedioScarRE = 0, TempoMedioScarRC = 0, TempoMedioScarEN = 0, PesoParzialeAC = 0, PesoParzialeRE = 0, PesoParzialeRC = 0;
            Object.values(groupedArr).forEach((elm, idx) => {
                NumChiusiAC = elm.sum('NumSinistriChiusi', 'AC');
                NumEntratiAC = elm.sum('NumSinistriEntrati', 'AC');
                NumChiusiRE = elm.sum('NumSinistriChiusi', 'RE');
                NumEntratiRE = elm.sum('NumSinistriEntrati', 'RE');
                NumChiusiRC = elm.sum('NumSinistriChiusi', 'RC');
                NumEntratiRC = elm.sum('NumSinistriEntrati', 'RC');
                NumChiusiEN = elm.sum('NumSinistriChiusi', 'EN');
                NumEntratiEN = elm.sum('NumSinistriEntrati', 'EN');
                TempoMedioScarAC = elm.mediaPonderataMedie('GiorniMediRientro', 'NumSinistriChiusi', 'AC');
                TempoMedioScarRE = elm.mediaPonderataMedie('GiorniMediRientro', 'NumSinistriChiusi', 'RE');
                TempoMedioScarRC = elm.mediaPonderataMedie('GiorniMediRientro', 'NumSinistriChiusi', 'RC');
                TempoMedioScarEN = elm.mediaPonderataMedie('GiorniMediRientro', 'NumSinistriChiusi', 'EN');
                GridData1.push({
                    IdCompagnia: Object.keys(groupedArr)[idx],
                    DescrCompagnia:_.find(ddlData, (obj) => { return obj.IdCompagnia.toString() === Object.keys(groupedArr)[idx]; })?.DescrizioneCompagnia,
                    ScarTotSinAC: ((NumChiusiAC / NumEntratiAC) * 100) < 100 && ((NumChiusiAC / NumEntratiAC) * 100) > 0 
                                    && (((NumChiusiAC / NumEntratiAC) * 100) - Math.floor(((NumChiusiAC / NumEntratiAC) * 100))) !== 0
                                ? ((NumChiusiAC / NumEntratiAC) * 100).toFixed(2)
                                : ((NumChiusiAC / NumEntratiAC) * 100).toFixed(0),
                    NumSinistriMancantiAC: NumChiusiAC - calcolaSinistriObiettivo(NumEntratiAC, 'AC'),
                    TempoMedioScaricoAC: TempoMedioScarAC,
                    ScarTotSinRE: ((NumChiusiRE / NumEntratiRE) * 100) < 100 && ((NumChiusiRE / NumEntratiRE) * 100) > 0 
                                    && (((NumChiusiRE / NumEntratiRE) * 100) - Math.floor(((NumChiusiRE / NumEntratiRE) * 100))) !== 0
                                ? ((NumChiusiRE / NumEntratiRE) * 100).toFixed(2)
                                : ((NumChiusiRE / NumEntratiRE) * 100).toFixed(0),
                    NumSinistriMancantiRE: NumChiusiRE - calcolaSinistriObiettivo(NumEntratiRE, 'RE'),
                    TempoMedioScaricoRE: TempoMedioScarRE,
                    ScarTotSinRC: ((NumChiusiRC / NumEntratiRC) * 100) < 100 && ((NumChiusiRC / NumEntratiRC) * 100) > 0 
                                    && (((NumChiusiRC / NumEntratiRC) * 100) - Math.floor(((NumChiusiRC / NumEntratiRC) * 100))) !== 0
                                ? ((NumChiusiRC / NumEntratiRC) * 100).toFixed(2)
                                : ((NumChiusiRC / NumEntratiRC) * 100).toFixed(0), 
                    NumSinistriMancantiRC: NumChiusiRC - calcolaSinistriObiettivo(NumEntratiRC, 'RC'),
                    TempoMedioScaricoRC: TempoMedioScarRC,
                    ScarTotSinEN: ((NumChiusiEN / NumEntratiEN) * 100) < 100 && ((NumChiusiEN / NumEntratiEN) * 100) > 0 
                                    && (((NumChiusiEN / NumEntratiEN) * 100) - Math.floor(((NumChiusiEN / NumEntratiEN) * 100))) !== 0
                                ? ((NumChiusiEN / NumEntratiEN) * 100).toFixed(2)
                                : ((NumChiusiEN / NumEntratiEN) * 100).toFixed(0), 
                    NumSinistriMancantiEN: NumChiusiEN - calcolaSinistriObiettivo(NumEntratiEN, 'EN'),
                    TempoMedioScaricoEN: TempoMedioScarEN
                }); 
            });    
            GridData1 = _.sortBy(GridData1, obj => { return obj.NumSinistriMancantiAC + obj.NumSinistriMancantiRE + obj.NumSinistriMancantiRC + obj.NumSinistriMancantiEN; });
            let sortedArr = _.filter(retData, obj => obj.NominativoPerito !== "TOTALI");

            // Raggruppa per combinazione perito-compagnia
            let groupedByPeritoCompagnia = _.groupBy(sortedArr, obj => `${obj.IdPerito}_${obj.IdCompagnia}`);

            GridData2 = [];
            let periti = [];

            // Per ogni gruppo perito-compagnia
            _.each(groupedByPeritoCompagnia, (gruppo) => {
                // Prendi i valori comuni del gruppo
                let idPerito = gruppo[0].IdPerito;
                let idCompagnia = gruppo[0].IdCompagnia;
                let nomePerito = gruppo[0].NominativoPerito;
                
                // Filtra e somma per AC
                let dataAC = _.filter(gruppo, elm => elm.Raggruppamento === 'AC');
                let NumChiusiAC = _.reduce(dataAC, (sum, elm) => sum + elm.NumSinistriChiusi, 0);
                let NumEntratiAC = _.reduce(dataAC, (sum, elm) => sum + elm.NumSinistriEntrati, 0);
                let PesoParzialeAC = _.reduce(dataAC, (sum, elm) => sum + (elm.GiorniMediRientro * elm.NumSinistriChiusi), 0);
                
                // Filtra e somma per RE
                let dataRE = _.filter(gruppo, elm => elm.Raggruppamento === 'RE');
                let NumChiusiRE = _.reduce(dataRE, (sum, elm) => sum + elm.NumSinistriChiusi, 0);
                let NumEntratiRE = _.reduce(dataRE, (sum, elm) => sum + elm.NumSinistriEntrati, 0);
                let PesoParzialeRE = _.reduce(dataRE, (sum, elm) => sum + (elm.GiorniMediRientro * elm.NumSinistriChiusi), 0);
                
                // Filtra e somma per RC
                let dataRC = _.filter(gruppo, elm => elm.Raggruppamento === 'RC');
                let NumChiusiRC = _.reduce(dataRC, (sum, elm) => sum + elm.NumSinistriChiusi, 0);
                let NumEntratiRC = _.reduce(dataRC, (sum, elm) => sum + elm.NumSinistriEntrati, 0);
                let PesoParzialeRC = _.reduce(dataRC, (sum, elm) => sum + (elm.GiorniMediRientro * elm.NumSinistriChiusi), 0);
                
                let dataEN = _.filter(gruppo, elm => elm.Raggruppamento === 'EN');
                let NumChiusiEN = _.reduce(dataEN, (sum, elm) => sum + elm.NumSinistriChiusi, 0);
                let NumEntratiEN = _.reduce(dataEN, (sum, elm) => sum + elm.NumSinistriEntrati, 0);
                let PesoParzialeEN = _.reduce(dataEN, (sum, elm) => sum + (elm.GiorniMediRientro * elm.NumSinistriChiusi), 0);

                // Push UNA SOLA VOLTA per la combinazione perito-compagnia con TUTTI i valori
                GridData2.push({
                    IdCompagnia: idCompagnia,
                    IdPerito: idPerito,
                    NominativoPerito: nomePerito,
                    ScarTotSinAC: ((NumChiusiAC / NumEntratiAC) * 100) < 100 && ((NumChiusiAC / NumEntratiAC) * 100) > 0 
                                    && (((NumChiusiAC / NumEntratiAC) * 100) - Math.floor(((NumChiusiAC / NumEntratiAC) * 100))) !== 0
                                    ? ((NumChiusiAC / NumEntratiAC) * 100).toFixed(2)
                                    : ((NumChiusiAC / NumEntratiAC) * 100).toFixed(0),
                    NumSinistriMancantiAC: NumChiusiAC - calcolaSinistriObiettivo(NumEntratiAC, 'AC'),
                    TempoMedioScaricoAC: NumChiusiAC === 0 ? 0 : parseFloat(PesoParzialeAC / NumChiusiAC).toFixed(2),
                    ScarTotSinRE: ((NumChiusiRE / NumEntratiRE) * 100) < 100 && ((NumChiusiRE / NumEntratiRE) * 100) > 0 
                                    && (((NumChiusiRE / NumEntratiRE) * 100) - Math.floor(((NumChiusiRE / NumEntratiRE) * 100))) !== 0
                                    ? ((NumChiusiRE / NumEntratiRE) * 100).toFixed(2)
                                    : ((NumChiusiRE / NumEntratiRE) * 100).toFixed(0),
                    NumSinistriMancantiRE: NumChiusiRE - calcolaSinistriObiettivo(NumEntratiRE, 'RE'),
                    TempoMedioScaricoRE: NumChiusiRE === 0 ? 0 : parseFloat(PesoParzialeRE / NumChiusiRE).toFixed(2),
                    ScarTotSinRC: ((NumChiusiRC / NumEntratiRC) * 100) < 100 && ((NumChiusiRC / NumEntratiRC) * 100) > 0 
                                    && (((NumChiusiRC / NumEntratiRC) * 100) - Math.floor(((NumChiusiRC / NumEntratiRC) * 100))) !== 0
                                    ? ((NumChiusiRC / NumEntratiRC) * 100).toFixed(2)
                                    : ((NumChiusiRC / NumEntratiRC) * 100).toFixed(0),
                    NumSinistriMancantiRC: NumChiusiRC - calcolaSinistriObiettivo(NumEntratiRC, 'RC'),
                    TempoMedioScaricoRC: NumChiusiRC === 0 ? 0 : parseFloat(PesoParzialeRC / NumChiusiRC).toFixed(2),
                    ScarTotSinEN: ((NumChiusiEN / NumEntratiEN) * 100) < 100 && ((NumChiusiEN / NumEntratiEN) * 100) > 0 
                                    && (((NumChiusiEN / NumEntratiEN) * 100) - Math.floor(((NumChiusiEN / NumEntratiEN) * 100))) !== 0
                                    ? ((NumChiusiEN / NumEntratiEN) * 100).toFixed(2)
                                    : ((NumChiusiEN / NumEntratiEN) * 100).toFixed(0),
                    NumSinistriMancantiEN: NumChiusiEN - calcolaSinistriObiettivo(NumEntratiEN, 'EN'),
                    TempoMedioScaricoEN: NumChiusiEN === 0 ? 0 : parseFloat(PesoParzialeEN / NumChiusiEN).toFixed(2)
                });
                
                // Aggiungi perito alla lista
                periti.push({ Value: idPerito.toString(), Text: nomePerito });
            });

            GridData2 = _.sortBy(GridData2, obj => obj.NumSinistriMancantiAC + obj.NumSinistriMancantiRE + obj.NumSinistriMancantiRC + obj.NumSinistriMancantiEN);
            localStorage.setItem("MonitorDSObiettiviSecondoLiv", JSON.stringify(GridData2));
            periti.unshift({ Value: '', Text: '' }); 
            periti = _.uniq(periti, elm => elm.Value);
            document.getElementById('GridObiettivi').ej2_instances[0].dataSource = GridData1;
            document.getElementById('GridObiettivi').ej2_instances[0].childGrid.dataSource = GridData2; 
            document.getElementById('GridObiettivi').ej2_instances[0].refresh();  
            setTimeout(() => {
                document.getElementById('ddlPeriti').ej2_instances[0].dataSource = periti;
            }, 200);
            this.toggleBlocking();
        }, error => {
            let messaggio = (_.isString(error) && error.indexOf('Not Found')) > -1 ? CustomJS.messaggioAPIBackendNonTrovata : CustomJS.messaggioNoBackend;
            toast.warn(messaggio, {
                containerId: 'toastContainer1',
                position: "top-right",
                autoClose: 8000,
                hideProgressBar: false,            
                closeOnClick: true,
                pauseOnHover: true,
                draggable: false,
                progress: undefined,
                newestOnTop: true,
                rtl: false,
                pauseOnFocusLoss: true
            })
        }, true, false);
        
        // CustomJS.callAPI(`${CustomJS.APIMonitorURLProd}/api/Monitor/portingTutteAPI/scaricoCompagnie/[NO]/[NO]/[NO]/[NO]/[NO]/rerc-mese`, '', 'GET', '', retData => {
        //     retData = _.filter(retData, elm => { return elm.NominativoPerito !== 'TOTALI' });
        //     let groupedArr = _.groupBy(retData, 'periodo');
        //     let calcoloCumulMese = (meseFinale, raggr) => { 
        //         let totEntrati = 0, totChiusi = 0;
        //         for (let ind=0;ind<=meseFinale;ind++) {
        //             totEntrati += !_.isArray(Object.values(groupedArr)[ind]) ? 0 : Object.values(groupedArr)[ind].sum('NumSinistriEntrati', raggr);
        //             totChiusi += !_.isArray(Object.values(groupedArr)[ind]) ? 0 : Object.values(groupedArr)[ind].sum('NumSinistriChiusi', raggr);
        //         }  
        //         return meseFinale > new Date().getMonth() ? 0 : parseFloat(totChiusi/totEntrati*100).toFixed(2)
        //     }
        //     for (let ind=1; ind<=12;ind++) {  
        //         ObietMese = _.find(CurvaObiettivi.CurvaObiettivi, elm => { return elm.RAMO === 'RE'})[yyyy.toString() + ind.toString().padStart(2,'0')];
        //         data1.push({ x: ind === 1 ? new Date(yyyy, 0, 1) : ind === 2 ? new Date(yyyy, 1, 1)  : ind === 3 ? new Date(yyyy, 2, 1)  : ind === 4 ? new Date(yyyy, 3, 1)
        //                     : ind === 5 ? new Date(yyyy, 4, 1)  : ind === 6 ? new Date(yyyy, 5, 1) : ind === 7 ? new Date(yyyy, 6, 1)  : ind === 8 ? new Date(yyyy, 7, 1)  
        //                     : ind === 9 ? new Date(yyyy, 8, 1)  : ind === 10 ? new Date(yyyy, 9, 1)  : ind === 11 ? new Date(yyyy, 10, 1)  : new Date(yyyy, 11, 1), y: ObietMese  }); 
        //         data2.push({ x: ind === 1 ? new Date(yyyy, 0, 1) : ind === 2 ? new Date(yyyy, 1, 1) : ind === 3 ? new Date(yyyy, 2, 1) : ind === 4 ? new Date(yyyy, 3, 1) : ind === 5 ? new Date(yyyy, 4, 1) : ind === 6 ? new Date(yyyy, 5, 1) 
        //                     : ind === 7 ? new Date(yyyy, 6, 1) : ind === 8 ? new Date(yyyy, 7, 1) : ind === 9 ? new Date(yyyy, 8, 1) : ind === 10 ? new Date(yyyy, 9, 1) : ind === 11 ? new Date(yyyy, 10, 1) : new Date(yyyy, 11, 1), y: calcoloCumulMese(ind-1, 'RE') }); 
        //     }  
        //     for (let ind=1; ind<=12;ind++) {  
        //         ObietMese = _.find(CurvaObiettivi.CurvaObiettivi, elm => { return elm.RAMO === 'RC'})[yyyy.toString() + ind.toString().padStart(2,'0')];
        //         data3.push({ x: ind === 1 ? new Date(yyyy, 0, 1) : ind === 2 ? new Date(yyyy, 1, 1)  : ind === 3 ? new Date(yyyy, 2, 1)  : ind === 4 ? new Date(yyyy, 3, 1)
        //                     : ind === 5 ? new Date(yyyy, 4, 1)  : ind === 6 ? new Date(yyyy, 5, 1) : ind === 7 ? new Date(yyyy, 6, 1)  : ind === 8 ? new Date(yyyy, 7, 1)  
        //                     : ind === 9 ? new Date(yyyy, 8, 1)  : ind === 10 ? new Date(yyyy, 9, 1)  : ind === 11 ? new Date(yyyy, 10, 1)  : new Date(yyyy, 11, 1), y: ObietMese  }); 
        //         data4.push({ x: ind === 1 ? new Date(yyyy, 0, 1) : ind === 2 ? new Date(yyyy, 1, 1) : ind === 3 ? new Date(yyyy, 2, 1) : ind === 4 ? new Date(yyyy, 3, 1) : ind === 5 ? new Date(yyyy, 4, 1) : ind === 6 ? new Date(yyyy, 5, 1) 
        //                     : ind === 7 ? new Date(yyyy, 6, 1) : ind === 8 ? new Date(yyyy, 7, 1) : ind === 9 ? new Date(yyyy, 8, 1) : ind === 10 ? new Date(yyyy, 9, 1) : ind === 11 ? new Date(yyyy, 10, 1) : new Date(yyyy, 11, 1), y: calcoloCumulMese(ind-1, 'RC') }); 
        //     }   
        //     data2 = _.filter(data2, elm => { return elm.y > 0 });
        //     data4 = _.filter(data4, elm => { return elm.y > 0 });
        //     document.getElementById('ChartObiettRE').ej2_instances[0].series[0].dataSource = data1;
        //     document.getElementById('ChartObiettRE').ej2_instances[0].series[1].dataSource = data2;
        //     document.getElementById('ChartObiettRC').ej2_instances[0].series[0].dataSource = data3;
        //     document.getElementById('ChartObiettRC').ej2_instances[0].series[1].dataSource = data4;
        // }, error => {
        //     let messaggio = (_.isString(error) && error.indexOf('Not Found')) > -1 ? CustomJS.messaggioAPIBackendNonTrovata : CustomJS.messaggioNoBackend;
        //     toast.warn(messaggio, {
        //         containerId: 'toastContainer1',
        //         position: "top-right",
        //         autoClose: 8000,
        //         hideProgressBar: false,            
        //         closeOnClick: true,
        //         pauseOnHover: true,
        //         draggable: false,
        //         progress: undefined,
        //         newestOnTop: true,
        //         rtl: false,
        //         pauseOnFocusLoss: true
        //     })
        // }, true, false);
    }   
    caricaDati2(IdCompagnia) {
        GridData1 = []; GridData2 = []; data1 = []; data2 = []; data3 = []; data4 = []; periti = [];
        let dataFineEstr = '';
        if (this.ddlInstance2.value === mm)
            dataFineEstr = dataCorrente;
        else { 
            const meseEstr = this.ddlInstance2.value;
            const giorno = (mm === '02') ? CustomJS.leapYear(yyyy.toString()) ? '29' : '28' : (meseEstr === '01' || meseEstr === '03' || meseEstr === '05' || meseEstr === '07' || meseEstr === '08' || meseEstr === '10' || meseEstr === '12') ? '31' : '30';            
            dataFineEstr = yyyy.toString() + this.ddlInstance2.value + giorno;
        }
        ObietMeseAC = _.find(CurvaObiettivi.CurvaObiettivi, elm => { return elm.RAMO === 'AC'})[yyyy.toString() + this.ddlInstance2.value]; 
        ObietMeseRE = _.find(CurvaObiettivi.CurvaObiettivi, elm => { return elm.RAMO === 'RE'})[yyyy.toString() + this.ddlInstance2.value]; 
        ObietMeseRC = _.find(CurvaObiettivi.CurvaObiettivi, elm => { return elm.RAMO === 'RC'})[yyyy.toString() + this.ddlInstance2.value];
        ObietMeseEN = _.find(CurvaObiettivi.CurvaObiettivi, elm => { return elm.RAMO === 'EN'})[yyyy.toString() + this.ddlInstance2.value];
        this.toggleBlocking2();
        CustomJS.callAPI(`${CustomJS.APIMonitorURLProd}/api/Monitor/portingTutteAPI/scaricoCompagnie/${yyyy.toString()}-01-01 00:00:00/${dataFineEstr}/[NO]/[NO]/[NO]/rercacen`, '', 'GET', '', retData => {
            debugger; 
            let groupedArr = [];
            retData = _.filter(retData, elm => { return elm.IdCompagnia === IdCompagnia && !CustomJS.isNullEmpty(elm.Area)});
            groupedArr = _.groupBy(retData, 'Area');
            let NumChiusiAC = 0, NumEntratiAC = 0, NumChiusiRE = 0, NumEntratiRE = 0, NumChiusiRC = 0, NumEntratiRC = 0, NumChiusiEN = 0, NumEntratiEN = 0;
            let TempoMedioScarAC = 0, TempoMedioScarRE = 0, TempoMedioScarRC = 0, TempoMedioScarEN = 0, PesoParzialeAC = 0, PesoParzialeRE = 0, PesoParzialeRC = 0;
            Object.values(groupedArr).forEach((elm, idx) => {
                NumChiusiAC = elm.sum('NumSinistriChiusi', 'AC');
                NumEntratiAC = elm.sum('NumSinistriEntrati', 'AC');
                NumChiusiRE = elm.sum('NumSinistriChiusi', 'RE');
                NumEntratiRE = elm.sum('NumSinistriEntrati', 'RE');
                NumChiusiRC = elm.sum('NumSinistriChiusi', 'RC');
                NumEntratiRC = elm.sum('NumSinistriEntrati', 'RC');
                NumChiusiEN = elm.sum('NumSinistriChiusi', 'EN');
                NumEntratiEN = elm.sum('NumSinistriEntrati', 'EN');
                TempoMedioScarAC = elm.mediaPonderataMedie('GiorniMediRientro', 'NumSinistriChiusi', 'AC');
                TempoMedioScarRE = elm.mediaPonderataMedie('GiorniMediRientro', 'NumSinistriChiusi', 'RE');
                TempoMedioScarRC = elm.mediaPonderataMedie('GiorniMediRientro', 'NumSinistriChiusi', 'RC');
                TempoMedioScarEN = elm.mediaPonderataMedie('GiorniMediRientro', 'NumSinistriChiusi', 'EN');
                GridData1.push({
                    DescrArea: !CustomJS.isNullEmpty(IdCompagnia) ? Object.keys(groupedArr)[idx] : '',
                    ScarTotSinAC: ((NumChiusiAC / NumEntratiAC) * 100) < 100 && ((NumChiusiAC / NumEntratiAC) * 100) > 0 
                                    && (((NumChiusiAC / NumEntratiAC) * 100) - Math.floor(((NumChiusiAC / NumEntratiAC) * 100))) !== 0
                                ? ((NumChiusiAC / NumEntratiAC) * 100).toFixed(2)
                                : ((NumChiusiAC / NumEntratiAC) * 100).toFixed(0),
                    NumSinistriMancantiAC: NumChiusiAC - calcolaSinistriObiettivo(NumEntratiAC, 'AC'),
                    TempoMedioScaricoAC: TempoMedioScarAC,
                    ScarTotSinRE: ((NumChiusiRE / NumEntratiRE) * 100) < 100 && ((NumChiusiRE / NumEntratiRE) * 100) > 0 
                                    && (((NumChiusiRE / NumEntratiRE) * 100) - Math.floor(((NumChiusiRE / NumEntratiRE) * 100))) !== 0
                                ? ((NumChiusiRE / NumEntratiRE) * 100).toFixed(2)
                                : ((NumChiusiRE / NumEntratiRE) * 100).toFixed(0),
                    NumSinistriMancantiRE: NumChiusiRE - calcolaSinistriObiettivo(NumEntratiRE, 'RE'),
                    TempoMedioScaricoRE: TempoMedioScarRE,
                    ScarTotSinRC: ((NumChiusiRC / NumEntratiRC) * 100) < 100 && ((NumChiusiRC / NumEntratiRC) * 100) > 0 
                                    && (((NumChiusiRC / NumEntratiRC) * 100) - Math.floor(((NumChiusiRC / NumEntratiRC) * 100))) !== 0
                                ? ((NumChiusiRC / NumEntratiRC) * 100).toFixed(2)
                                : ((NumChiusiRC / NumEntratiRC) * 100).toFixed(0), 
                    NumSinistriMancantiRC: NumChiusiRC - calcolaSinistriObiettivo(NumEntratiRC, 'RC'),
                    TempoMedioScaricoRC: TempoMedioScarRC,
                    ScarTotSinEN: ((NumChiusiEN / NumEntratiEN) * 100) < 100 && ((NumChiusiEN / NumEntratiEN) * 100) > 0 
                                    && (((NumChiusiEN / NumEntratiEN) * 100) - Math.floor(((NumChiusiEN / NumEntratiEN) * 100))) !== 0
                                ? ((NumChiusiEN / NumEntratiEN) * 100).toFixed(2)
                                : ((NumChiusiEN / NumEntratiEN) * 100).toFixed(0), 
                    NumSinistriMancantiEN: NumChiusiEN - calcolaSinistriObiettivo(NumEntratiEN, 'EN'),
                    TempoMedioScaricoEN: TempoMedioScarEN
                }); 
            });    
            GridData1 = _.sortBy(GridData1, obj => { return obj.NumSinistriMancantiAC + obj.NumSinistriMancantiRE + obj.NumSinistriMancantiRC + obj.NumSinistriMancantiEN; });

            let sortedArr = _.filter(retData, obj => obj.NominativoPerito !== "TOTALI");

            // Raggruppa per combinazione perito-area
            let groupedByPeritoArea = _.groupBy(sortedArr, obj => `${obj.IdPerito}_${obj.Area}`);

            GridData2 = [];
            let periti = [];

            // Per ogni gruppo perito-area
            _.each(groupedByPeritoArea, (gruppo) => {
                // Prendi i valori comuni del gruppo
                let idPerito = gruppo[0].IdPerito;
                let descrArea = gruppo[0].Area;
                let nomePerito = gruppo[0].NominativoPerito;
                
                // Filtra e somma per AC
                let dataAC = _.filter(gruppo, elm => elm.Raggruppamento === 'AC');
                let NumChiusiAC = _.reduce(dataAC, (sum, elm) => sum + elm.NumSinistriChiusi, 0);
                let NumEntratiAC = _.reduce(dataAC, (sum, elm) => sum + elm.NumSinistriEntrati, 0);
                let PesoParzialeAC = _.reduce(dataAC, (sum, elm) => sum + (elm.GiorniMediRientro * elm.NumSinistriChiusi), 0);
                
                // Filtra e somma per RE
                let dataRE = _.filter(gruppo, elm => elm.Raggruppamento === 'RE');
                let NumChiusiRE = _.reduce(dataRE, (sum, elm) => sum + elm.NumSinistriChiusi, 0);
                let NumEntratiRE = _.reduce(dataRE, (sum, elm) => sum + elm.NumSinistriEntrati, 0);
                let PesoParzialeRE = _.reduce(dataRE, (sum, elm) => sum + (elm.GiorniMediRientro * elm.NumSinistriChiusi), 0);
                
                // Filtra e somma per RC
                let dataRC = _.filter(gruppo, elm => elm.Raggruppamento === 'RC');
                let NumChiusiRC = _.reduce(dataRC, (sum, elm) => sum + elm.NumSinistriChiusi, 0);
                let NumEntratiRC = _.reduce(dataRC, (sum, elm) => sum + elm.NumSinistriEntrati, 0);
                let PesoParzialeRC = _.reduce(dataRC, (sum, elm) => sum + (elm.GiorniMediRientro * elm.NumSinistriChiusi), 0);
                
                // Filtra e somma per EN
                let dataEN = _.filter(gruppo, elm => elm.Raggruppamento === 'EN');
                let NumChiusiEN = _.reduce(dataEN, (sum, elm) => sum + elm.NumSinistriChiusi, 0);
                let NumEntratiEN = _.reduce(dataEN, (sum, elm) => sum + elm.NumSinistriEntrati, 0);
                let PesoParzialeEN = _.reduce(dataEN, (sum, elm) => sum + (elm.GiorniMediRientro * elm.NumSinistriChiusi), 0);

                // Push UNA SOLA VOLTA per la combinazione perito-area con TUTTI i valori
                GridData2.push({
                    DescrArea: descrArea,
                    IdPerito: idPerito,
                    NominativoPerito: nomePerito,
                    ScarTotSinAC: ((NumChiusiAC / NumEntratiAC) * 100) < 100 && ((NumChiusiAC / NumEntratiAC) * 100) > 0 
                                    && (((NumChiusiAC / NumEntratiAC) * 100) - Math.floor(((NumChiusiAC / NumEntratiAC) * 100))) !== 0
                                    ? ((NumChiusiAC / NumEntratiAC) * 100).toFixed(2)
                                    : ((NumChiusiAC / NumEntratiAC) * 100).toFixed(0),
                    NumSinistriMancantiAC: NumChiusiAC - calcolaSinistriObiettivo(NumEntratiAC, 'AC'),
                    TempoMedioScaricoAC: NumChiusiAC === 0 ? 0 : parseFloat(PesoParzialeAC / NumChiusiAC).toFixed(2),
                    ScarTotSinRE: ((NumChiusiRE / NumEntratiRE) * 100) < 100 && ((NumChiusiRE / NumEntratiRE) * 100) > 0 
                                    && (((NumChiusiRE / NumEntratiRE) * 100) - Math.floor(((NumChiusiRE / NumEntratiRE) * 100))) !== 0
                                    ? ((NumChiusiRE / NumEntratiRE) * 100).toFixed(2)
                                    : ((NumChiusiRE / NumEntratiRE) * 100).toFixed(0),
                    NumSinistriMancantiRE: NumChiusiRE - calcolaSinistriObiettivo(NumEntratiRE, 'RE'),
                    TempoMedioScaricoRE: NumChiusiRE === 0 ? 0 : parseFloat(PesoParzialeRE / NumChiusiRE).toFixed(2),
                    ScarTotSinRC: ((NumChiusiRC / NumEntratiRC) * 100) < 100 && ((NumChiusiRC / NumEntratiRC) * 100) > 0 
                                    && (((NumChiusiRC / NumEntratiRC) * 100) - Math.floor(((NumChiusiRC / NumEntratiRC) * 100))) !== 0
                                    ? ((NumChiusiRC / NumEntratiRC) * 100).toFixed(2)
                                    : ((NumChiusiRC / NumEntratiRC) * 100).toFixed(0),
                    NumSinistriMancantiRC: NumChiusiRC - calcolaSinistriObiettivo(NumEntratiRC, 'RC'),
                    TempoMedioScaricoRC: NumChiusiRC === 0 ? 0 : parseFloat(PesoParzialeRC / NumChiusiRC).toFixed(2),
                    ScarTotSinEN: ((NumChiusiEN / NumEntratiEN) * 100) < 100 && ((NumChiusiEN / NumEntratiEN) * 100) > 0 
                                    && (((NumChiusiEN / NumEntratiEN) * 100) - Math.floor(((NumChiusiEN / NumEntratiEN) * 100))) !== 0
                                    ? ((NumChiusiEN / NumEntratiEN) * 100).toFixed(2)
                                    : ((NumChiusiEN / NumEntratiEN) * 100).toFixed(0),
                    NumSinistriMancantiEN: NumChiusiEN - calcolaSinistriObiettivo(NumEntratiEN, 'EN'),
                    TempoMedioScaricoEN: NumChiusiEN === 0 ? 0 : parseFloat(PesoParzialeEN / NumChiusiEN).toFixed(2)
                });
                
                // Aggiungi perito alla lista
                periti.push({ Value: idPerito.toString(), Text: nomePerito });
            });

            GridData2 = _.sortBy(GridData2, obj => obj.NumSinistriMancantiAC + obj.NumSinistriMancantiRE + obj.NumSinistriMancantiRC + obj.NumSinistriMancantiEN);
            localStorage.setItem("MonitorDSObiettiviAreeSecondoLiv", JSON.stringify(GridData2));
            periti.unshift({ Value: '', Text: '' }); 
            periti = _.uniq(periti, elm => elm.Value);
            document.getElementById('GridObiettiviAree').ej2_instances[0].dataSource = GridData1;
            document.getElementById('GridObiettiviAree').ej2_instances[0].childGrid.dataSource = GridData2; 
            document.getElementById('GridObiettiviAree').ej2_instances[0].refresh();  
            setTimeout(() => {
                document.getElementById('ddlPeriti2').ej2_instances[0].dataSource = periti;
            }, 200);
            this.toggleBlocking2();
        }, error => {
            let messaggio = (_.isString(error) && error.indexOf('Not Found')) > -1 ? CustomJS.messaggioAPIBackendNonTrovata : CustomJS.messaggioNoBackend;
            toast.warn(messaggio, {
                containerId: 'toastContainer1',
                position: "top-right",
                autoClose: 8000,
                hideProgressBar: false,            
                closeOnClick: true,
                pauseOnHover: true,
                draggable: false,
                progress: undefined,
                newestOnTop: true,
                rtl: false,
                pauseOnFocusLoss: true
            })
        }, true, false);       
    } 
    caricaDati3() {
        GridData1 = []; GridData2 = [];

        this.toggleBlocking();

        CustomJS.callAPI(`${CustomJS.APIMonitorURLProd}/api/Monitor/portingTutteAPI/KPI-Intesa/[NO]/[NO]/[NO]/[NO]/[NO]/[NO]`, '', 'GET', '', retData => {
            this.toggleBlocking();
            
            // arricchisco i dati con GiorniLavorativi (solo chiusi)
            retData.forEach(r => {
                if (r.Chiuso === 1)
                    r.GiorniLavorativi = CustomJS.workingDaysBetween(r.DataApertura, r.DataChiusura);
            });

            this.intesaRawData = retData;

            // ---- GRIDDATA1 ---- (solo chiusi per le medie)
            let groupedByTipo = _.groupBy(retData, "TipoSinistro");

            GridData1 = _.map(groupedByTipo, (records, tipo) => {
                let centroNord = _.filter(records, r => r.AreaGeografica === "CentroNord" && r.Chiuso === 1);
                let sud = _.filter(records, r => r.AreaGeografica === "Sud" && r.Chiuso === 1);

                let mediaCentroNord = centroNord.length > 0
                    ? _.reduce(centroNord, (m, r) => m + r.GiorniLavorativi, 0) / centroNord.length
                    : null;

                let mediaSud = sud.length > 0
                    ? _.reduce(sud, (m, r) => m + r.GiorniLavorativi, 0) / sud.length
                    : null;

                return {
                    TipoSinistro: tipo,
                    MediaGiorniCentroNord: mediaCentroNord?.toFixed(2) ?? null,
                    MediaGiorniSud: mediaSud?.toFixed(2) ?? null
                };
            });

            // ---- GRIDDATA2 ---- (solo chiusi per le medie)
            let groupedByTipoPerito = _.groupBy(retData, r => r.TipoSinistro + "|" + r.id_perito);

            GridData2 = _.map(groupedByTipoPerito, (records, key) => {
                let tipo = key.split("|")[0];

                let centroNord = _.filter(records, r => r.AreaGeografica === "CentroNord" && r.Chiuso === 1);
                let sud = _.filter(records, r => r.AreaGeografica === "Sud" && r.Chiuso === 1);

                let mediaCentroNord = centroNord.length > 0
                    ? _.reduce(centroNord, (m, r) => m + r.GiorniLavorativi, 0) / centroNord.length
                    : null;

                let mediaSud = sud.length > 0
                    ? _.reduce(sud, (m, r) => m + r.GiorniLavorativi, 0) / sud.length
                    : null;

                return {
                    TipoSinistro: tipo,
                    id_perito: records[0]?.id_perito,
                    NominativoPerito: records[0]?.NominativoPerito,
                    MediaGiorniCentroNord: mediaCentroNord?.toFixed(2) ?? null,
                    MediaGiorniSud: mediaSud?.toFixed(2) ?? null
                };
            });

            this.gridInstance3.dataSource = GridData1;
            this.gridInstance3.childGrid.dataSource = GridData2;

        }, error => {
            let messaggio = (_.isString(error) && error.indexOf("Not Found")) > -1 ? CustomJS.messaggioAPIBackendNonTrovata : CustomJS.messaggioNoBackend;
            toast.warn(messaggio, {
                containerId: "toastContainer1",
                position: "top-right",
                autoClose: 8000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: false,
                progress: undefined,
                newestOnTop: true,
                rtl: false,
                pauseOnFocusLoss: true
            });
        }, true, false);
    }  
    caricaDati4() {
        GridData1 = []; 
        GridData2 = [];

        this.toggleBlocking();

        CustomJS.callAPI(`${CustomJS.APIMonitorURLProd}/api/Monitor/portingTutteAPI/KPI-Generali/[NO]/[NO]/[NO]/[NO]/[NO]/[NO]`, '', 'GET', '', retData => {
            this.toggleBlocking();
            if (!_.isArray(retData) || retData.length === 0) return;

            this.kpiGeneraliRawData = retData;

            // Funzione di supporto per calcolare KPI su un array di record
            const calcolaKPI = (records, tipo) => {
                const chiusi = _.filter(records, r => r.Chiuso === 1);
                const indennizzabili = _.filter(chiusi, r =>
                    r.esito_perizia !== "NON INDENNIZZABILE" &&
                    r.TotaleDannoIndennizzabile >= 1 &&
                    r.TotaleDannoIndennizzabile <= 50000
                );

                const totalLiquidato = _.reduce(indennizzabili, (sum, r) => sum + (r.TotaleDannoIndennizzabile || 0), 0);
                const liquidatoMedio = indennizzabili.length > 0 ? totalLiquidato / indennizzabili.length : 0;
                const deltaKP1 = liquidatoMedio > (
                    tipo === "EVENTO NATURALE" ? 2200 :
                    tipo === "ALTRI RAMI ELEMENTARI" ? 2500 : 
                    1250
                ) ? liquidatoMedio - (
                    tipo === "EVENTO NATURALE" ? 2200 :
                    tipo === "ALTRI RAMI ELEMENTARI" ? 2500 : 
                    1250
                ) : 0;

                const totalGiorni = _.reduce(chiusi, (sum, r) => sum + (r.GiorniRientro || 0), 0);
                const tempoMedio = chiusi.length > 0 ? totalGiorni / chiusi.length : 0;
                const deltaKPI4 = tempoMedio > 45 ? Math.ceil(tempoMedio - 45) : 0;

                const percNonIndennizzabili = chiusi.length > 0
                    ? (_.filter(chiusi, r => r.esito_perizia === "NON INDENNIZZABILE").length / chiusi.length * 100)
                    : 0;

                const percScaricoAnnuale = records.length > 0
                    ? (_.filter(records, r => r.Chiuso === 1).length / records.length * 100)
                    : 0;

                return {
                    LiquidatoMedio: parseFloat(liquidatoMedio.toFixed(2)),
                    ConteggioCampione: indennizzabili.length,
                    DeltaObiettivoKPI1: parseFloat(deltaKP1.toFixed(2)),
                    TempoMedioRestituzione: parseFloat(tempoMedio.toFixed(2)),
                    DeltaObiettivoKPI4: parseFloat(deltaKPI4.toFixed(2)),
                    PercNonIndennizzabili: parseFloat(percNonIndennizzabili.toFixed(2)),
                    PercScaricoAnnuale: parseFloat(percScaricoAnnuale.toFixed(2))
                };
            };

            // Raggruppamento per TipoSinistro
            const groupedByTipo = _.groupBy(retData, 'TipoSinistro');

            // Costruzione GridData1
            GridData1 = _.map(groupedByTipo, (records, tipo) => ({
                TipoSinistro: tipo,
                ...calcolaKPI(records, tipo)
            }));

            // TEMPORANEO: riga TOTALE RE esclusa dalla griglia in attesa di allineamento sui criteri di calcolo
            // const totaleRERecords = _.filter(retData, r => r.cod_gruppo_sinistro === 'RE');
            // if (totaleRERecords.length > 0) {
            //     GridData1.push({
            //         TipoSinistro: 'TOTALE RE',
            //         ...calcolaKPI(totaleRERecords, 'TOTALE RE')
            //     });
            // }
            const totaleRERecords = _.filter(retData, r => r.cod_gruppo_sinistro === 'RE');

            // Filtra righe con tutti valori a zero in GridData1
            GridData1 = _.filter(GridData1, r => !(
                r.LiquidatoMedio === 0 &&
                r.TempoMedioRestituzione === 0 &&
                r.PercNonIndennizzabili === 0 &&
                r.PercScaricoAnnuale === 0
            ));

            // Costruzione GridData2 (per TipoSinistro e id_perito / NominativoPerito)
            GridData2 = [];
            _.each(groupedByTipo, (records, tipo) => {
                const peritoGroup = _.groupBy(records, 'id_perito');
                _.each(peritoGroup, (peritoRecords, peritoId) => {
                    const nominativo = peritoRecords[0]?.NominativoPerito || 'Sconosciuto';
                    GridData2.push({
                        TipoSinistro: tipo,
                        id_perito: peritoId,
                        NominativoPerito: nominativo,
                        ...calcolaKPI(peritoRecords, tipo)
                    });
                });
            });

            // Aggiungi TOTALE RE per perito
            const peritoGroupRE = _.groupBy(totaleRERecords, 'id_perito');
            _.each(peritoGroupRE, (peritoRecords, peritoId) => {
                const nominativo = peritoRecords[0]?.NominativoPerito || 'Sconosciuto';
                GridData2.push({
                    TipoSinistro: 'TOTALE RE',
                    id_perito: peritoId,
                    NominativoPerito: nominativo,
                    ...calcolaKPI(peritoRecords, 'TOTALE RE')
                });
            });

            // Filtra righe con tutti valori a zero in GridData2
            GridData2 = _.filter(GridData2, r => !(
                r.LiquidatoMedio === 0 &&
                r.TempoMedioRestituzione === 0 &&
                r.PercNonIndennizzabili === 0 &&
                r.PercScaricoAnnuale === 0
            ));

            // Aggiorna datasource delle griglie
            this.gridInstance4.dataSource = GridData1;
            this.gridInstance4.childGrid.dataSource = GridData2;

        }, error => {
            let messaggio = (_.isString(error) && error.indexOf("Not Found")) > -1 
                ? CustomJS.messaggioAPIBackendNonTrovata 
                : CustomJS.messaggioNoBackend;
            toast.warn(messaggio, {
                containerId: "toastContainer1",
                position: "top-right",
                autoClose: 8000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: false,
                progress: undefined,
                newestOnTop: true,
                rtl: false,
                pauseOnFocusLoss: true
            });
            this.toggleBlocking();
        }, true, false);
    }
    caricaDatiHDI() {
        GridData1 = [];
        GridData2 = [];

        this.toggleBlocking();

        CustomJS.callAPI(`${CustomJS.APIMonitorURLProd}/api/Monitor/portingTutteAPI/KPI-HDI/[NO]/[NO]/[NO]/[NO]/[NO]/[NO]`, '', 'GET', '', retData => {
            this.toggleBlocking();
            if (!_.isArray(retData) || retData.length === 0) return;

            this.kpiHDIRawData = retData;

            // Stesso calcolo di calcolaKPI usato per Generali (soglie KPI1: 1250/2200/2500 — KPI4: 45gg)
            const calcolaKPI = (records, tipo) => {
                const chiusi = _.filter(records, r => r.Chiuso === 1);
                const indennizzabili = _.filter(chiusi, r =>
                    r.esito_perizia !== "NON INDENNIZZABILE" &&
                    r.TotaleDannoIndennizzabile >= 1 &&
                    r.TotaleDannoIndennizzabile <= 50000
                );

                const totalLiquidato = _.reduce(indennizzabili, (sum, r) => sum + (r.TotaleDannoIndennizzabile || 0), 0);
                const liquidatoMedio = indennizzabili.length > 0 ? totalLiquidato / indennizzabili.length : 0;
                const deltaKP1 = liquidatoMedio > (
                    tipo === "EVENTO NATURALE" ? 2200 :
                    tipo === "ALTRI RAMI ELEMENTARI" ? 2500 :
                    1250
                ) ? liquidatoMedio - (
                    tipo === "EVENTO NATURALE" ? 2200 :
                    tipo === "ALTRI RAMI ELEMENTARI" ? 2500 :
                    1250
                ) : 0;

                const totalGiorni = _.reduce(chiusi, (sum, r) => sum + (r.GiorniRientro || 0), 0);
                const tempoMedio = chiusi.length > 0 ? totalGiorni / chiusi.length : 0;
                const deltaKPI4 = tempoMedio > 45 ? Math.ceil(tempoMedio - 45) : 0;

                const percNonIndennizzabili = chiusi.length > 0
                    ? (_.filter(chiusi, r => r.esito_perizia === "NON INDENNIZZABILE").length / chiusi.length * 100)
                    : 0;

                const percScaricoAnnuale = records.length > 0
                    ? (_.filter(records, r => r.Chiuso === 1).length / records.length * 100)
                    : 0;

                return {
                    LiquidatoMedio: parseFloat(liquidatoMedio.toFixed(2)),
                    ConteggioCampione: indennizzabili.length,
                    DeltaObiettivoKPI1: parseFloat(deltaKP1.toFixed(2)),
                    TempoMedioRestituzione: parseFloat(tempoMedio.toFixed(2)),
                    DeltaObiettivoKPI4: parseFloat(deltaKPI4.toFixed(2)),
                    PercNonIndennizzabili: parseFloat(percNonIndennizzabili.toFixed(2)),
                    PercScaricoAnnuale: parseFloat(percScaricoAnnuale.toFixed(2))
                };
            };

            const groupedByTipo = _.groupBy(retData, 'TipoSinistro');

            GridData1 = _.map(groupedByTipo, (records, tipo) => ({
                TipoSinistro: tipo,
                ...calcolaKPI(records, tipo)
            }));

            GridData1 = _.filter(GridData1, r => !(
                r.LiquidatoMedio === 0 &&
                r.TempoMedioRestituzione === 0 &&
                r.PercNonIndennizzabili === 0 &&
                r.PercScaricoAnnuale === 0
            ));

            GridData2 = [];
            _.each(groupedByTipo, (records, tipo) => {
                const peritoGroup = _.groupBy(records, 'id_perito');
                _.each(peritoGroup, (peritoRecords, peritoId) => {
                    const nominativo = peritoRecords[0]?.NominativoPerito || 'Sconosciuto';
                    GridData2.push({
                        TipoSinistro: tipo,
                        id_perito: peritoId,
                        NominativoPerito: nominativo,
                        ...calcolaKPI(peritoRecords, tipo)
                    });
                });
            });

            GridData2 = _.filter(GridData2, r => !(
                r.LiquidatoMedio === 0 &&
                r.TempoMedioRestituzione === 0 &&
                r.PercNonIndennizzabili === 0 &&
                r.PercScaricoAnnuale === 0
            ));

            this.gridInstanceHDI.dataSource = GridData1;
            this.gridInstanceHDI.childGrid.dataSource = GridData2;

        }, error => {
            let messaggio = (_.isString(error) && error.indexOf("Not Found")) > -1
                ? CustomJS.messaggioAPIBackendNonTrovata
                : CustomJS.messaggioNoBackend;
            toast.warn(messaggio, {
                containerId: "toastContainer1",
                position: "top-right",
                autoClose: 8000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: false,
                progress: undefined,
                newestOnTop: true,
                rtl: false,
                pauseOnFocusLoss: true
            });
            this.toggleBlocking();
        }, true, false);
    }
    caricaDatiSARA() {
        GridData1 = [];
        GridData2 = [];

        this.toggleBlocking();

        CustomJS.callAPI(`${CustomJS.APIMonitorURLProd}/api/Monitor/portingTutteAPI/KPI-SARA/[NO]/[NO]/[NO]/[NO]/[NO]/[NO]`, '', 'GET', '', retData => {
            this.toggleBlocking();
            if (!_.isArray(retData) || retData.length === 0) return;

            this.kpiSARARawData = retData;

            // Stesso calcolo di calcolaKPI usato per Generali (soglie KPI1: 1250/2200/2500 — KPI4: 45gg)
            const calcolaKPI = (records, tipo) => {
                const chiusi = _.filter(records, r => r.Chiuso === 1);
                const indennizzabili = _.filter(chiusi, r =>
                    r.esito_perizia !== "NON INDENNIZZABILE" &&
                    r.TotaleDannoIndennizzabile >= 1 &&
                    r.TotaleDannoIndennizzabile <= 50000
                );

                const totalLiquidato = _.reduce(indennizzabili, (sum, r) => sum + (r.TotaleDannoIndennizzabile || 0), 0);
                const liquidatoMedio = indennizzabili.length > 0 ? totalLiquidato / indennizzabili.length : 0;
                const deltaKP1 = liquidatoMedio > (
                    tipo === "EVENTO NATURALE" ? 2200 :
                    tipo === "ALTRI RAMI ELEMENTARI" ? 2500 :
                    1250
                ) ? liquidatoMedio - (
                    tipo === "EVENTO NATURALE" ? 2200 :
                    tipo === "ALTRI RAMI ELEMENTARI" ? 2500 :
                    1250
                ) : 0;

                const totalGiorni = _.reduce(chiusi, (sum, r) => sum + (r.GiorniRientro || 0), 0);
                const tempoMedio = chiusi.length > 0 ? totalGiorni / chiusi.length : 0;
                const deltaKPI4 = tempoMedio > 45 ? Math.ceil(tempoMedio - 45) : 0;

                const percNonIndennizzabili = chiusi.length > 0
                    ? (_.filter(chiusi, r => r.esito_perizia === "NON INDENNIZZABILE").length / chiusi.length * 100)
                    : 0;

                const percScaricoAnnuale = records.length > 0
                    ? (_.filter(records, r => r.Chiuso === 1).length / records.length * 100)
                    : 0;

                return {
                    LiquidatoMedio: parseFloat(liquidatoMedio.toFixed(2)),
                    ConteggioCampione: indennizzabili.length,
                    DeltaObiettivoKPI1: parseFloat(deltaKP1.toFixed(2)),
                    TempoMedioRestituzione: parseFloat(tempoMedio.toFixed(2)),
                    DeltaObiettivoKPI4: parseFloat(deltaKPI4.toFixed(2)),
                    PercNonIndennizzabili: parseFloat(percNonIndennizzabili.toFixed(2)),
                    PercScaricoAnnuale: parseFloat(percScaricoAnnuale.toFixed(2))
                };
            };

            const groupedByTipo = _.groupBy(retData, 'TipoSinistro');

            GridData1 = _.map(groupedByTipo, (records, tipo) => ({
                TipoSinistro: tipo,
                ...calcolaKPI(records, tipo)
            }));

            GridData1 = _.filter(GridData1, r => !(
                r.LiquidatoMedio === 0 &&
                r.TempoMedioRestituzione === 0 &&
                r.PercNonIndennizzabili === 0 &&
                r.PercScaricoAnnuale === 0
            ));

            GridData2 = [];
            _.each(groupedByTipo, (records, tipo) => {
                const peritoGroup = _.groupBy(records, 'id_perito');
                _.each(peritoGroup, (peritoRecords, peritoId) => {
                    const nominativo = peritoRecords[0]?.NominativoPerito || 'Sconosciuto';
                    GridData2.push({
                        TipoSinistro: tipo,
                        id_perito: peritoId,
                        NominativoPerito: nominativo,
                        ...calcolaKPI(peritoRecords, tipo)
                    });
                });
            });

            GridData2 = _.filter(GridData2, r => !(
                r.LiquidatoMedio === 0 &&
                r.TempoMedioRestituzione === 0 &&
                r.PercNonIndennizzabili === 0 &&
                r.PercScaricoAnnuale === 0
            ));

            this.gridInstanceSARA.dataSource = GridData1;
            this.gridInstanceSARA.childGrid.dataSource = GridData2;

        }, error => {
            let messaggio = (_.isString(error) && error.indexOf("Not Found")) > -1
                ? CustomJS.messaggioAPIBackendNonTrovata
                : CustomJS.messaggioNoBackend;
            toast.warn(messaggio, {
                containerId: "toastContainer1",
                position: "top-right",
                autoClose: 8000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: false,
                progress: undefined,
                newestOnTop: true,
                rtl: false,
                pauseOnFocusLoss: true
            });
            this.toggleBlocking();
        }, true, false);
    }
    caricaDati5() {
        GridData1 = [];
        GridData2 = [];

        this.toggleBlocking();

        CustomJS.callAPI(
            `${CustomJS.APIMonitorURLProd}/api/Monitor/portingTutteAPI/KPI-Unipol/[NO]/[NO]/[NO]/[NO]/[NO]/[NO]`,
            '',
            'GET',
            '',
            retData => {
                this.toggleBlocking();
                if (!_.isArray(retData) || retData.length === 0) return;

                // Mappa tipo sinistro per coerenza
                const mappaTipoSinistro = r => {
                    if (r.cod_gruppo_sinistro === 'AC') return 'ACQUA CONDOTTA';
                    if (r.tipo_sinistro?.toLowerCase().includes('evento atmosferico')) return 'EVENTO NATURALE';
                    if (r.cod_gruppo_sinistro === 'RC' && r.tipo_sinistro?.toLowerCase().includes('r.c. auto')) return 'R.C. Auto';
                    if (r.cod_gruppo_sinistro === 'RC') return 'R.C.';
                    if (r.cod_gruppo_sinistro !== 'RC' && r.cod_gruppo_sinistro !== 'AC') return 'ALTRI RAMI ELEMENTARI';
                    return 'ALTRO';
                };

                // Calcolo GiorniRientro se non presente
                retData = retData.map(r => ({
                    ...r,
                    TipoSinistro: r.TipoSinistro || mappaTipoSinistro(r),
                    GiorniRientro: r.GiorniRientro || (
                        r.data_rest_compagnia && r.data_pervenimento
                            ? Math.floor((new Date(r.data_rest_compagnia) - new Date(r.data_pervenimento)) / (1000 * 60 * 60 * 24))
                            : 0
                    )
                }));

                this.kpiUnipolRawData = retData;

                // Funzione di supporto KPI
                const calcolaKPI = (records, tipo) => {
                    const chiusi = _.filter(records, r => r.Chiuso === 1);
                    const indennizzabili = _.filter(chiusi, r =>
                        r.esito_perizia !== "NON INDENNIZZABILE" &&
                        r.TotaleDannoIndennizzabile >= 250 &&
                        r.TotaleDannoIndennizzabile <= 5000
                    );

                    const totalLiquidato = _.reduce(indennizzabili, (sum, r) => sum + (r.TotaleDannoIndennizzabile || 0), 0);
                    const liquidatoMedio = indennizzabili.length > 0 ? totalLiquidato / indennizzabili.length : 0;

                    // Obiettivi per tipo sinistro
                    const obiettivo =
                        tipo === "EVENTO NATURALE" ? 1400 :
                        tipo === "ALTRI RAMI ELEMENTARI" ? 1400 : 1250;

                    const deltaKPI4 = liquidatoMedio > obiettivo ? (liquidatoMedio - obiettivo) : 0;

                    const totalGiorni = _.reduce(chiusi, (sum, r) => sum + (r.GiorniRientro || 0), 0);
                    const tempoMedio = chiusi.length > 0 ? totalGiorni / chiusi.length : 0;
                    const deltaKPI2 = tempoMedio > 45 ? Math.ceil(tempoMedio - 45) : 0;

                    const percIncidenzaConcordato = chiusi.length > 0
                        ? (_.filter(chiusi, r => r.esito_perizia !== "NON INDENNIZZABILE" && r.esito_perizia !== "NON CONCORDATO").length / chiusi.length * 100)
                        : 0;

                    const percScaricoAnnuale = records.length > 0
                        ? (_.filter(records, r => r.Chiuso === 1).length / records.length * 100)
                        : 0;

                    return {
                        LiquidatoMedio: parseFloat(liquidatoMedio.toFixed(2)),
                        ConteggioCampione: indennizzabili.length,
                        DeltaObiettivoKPI4: parseFloat(deltaKPI4.toFixed(2)),
                        TempoMedioRestituzione: parseFloat(tempoMedio.toFixed(2)),
                        DeltaObiettivoKPI2: parseFloat(deltaKPI2.toFixed(2)),
                        PercIncidenzaConcordato: parseFloat(percIncidenzaConcordato.toFixed(2)),
                        PercScaricoAnnuale: parseFloat(percScaricoAnnuale.toFixed(2))
                    };
                };

                // Raggruppamento per TipoSinistro
                const groupedByTipo = _.groupBy(retData, 'TipoSinistro');

                // Costruzione GridData1
                GridData1 = _.map(groupedByTipo, (records, tipo) => ({
                    TipoSinistro: tipo,
                    ...calcolaKPI(records, tipo)
                }));

                // TEMPORANEO: riga TOTALE RE esclusa dalla griglia in attesa di allineamento sui criteri di calcolo
                // if (totaleRERecords.length > 0) {
                //     GridData1.push({
                //         TipoSinistro: 'TOTALE RE',
                //         ...calcolaKPI(totaleRERecords, 'TOTALE RE')
                //     });
                // }
                const totaleRERecords = _.filter(retData, r => r.cod_gruppo_sinistro === 'RE');

                // Costruzione GridData2 (per perito)
                GridData2 = [];
                _.each(groupedByTipo, (records, tipo) => {
                    const peritoGroup = _.groupBy(records, 'id_perito');
                    _.each(peritoGroup, (peritoRecords, peritoId) => {
                        const nominativo = peritoRecords[0]?.NominativoPerito || 'Sconosciuto';
                        GridData2.push({
                            TipoSinistro: tipo,
                            id_perito: peritoId,
                            NominativoPerito: nominativo,
                            ...calcolaKPI(peritoRecords, tipo)
                        });
                    });
                });

                // TEMPORANEO: riga TOTALE RE esclusa dalla griglia in attesa di allineamento sui criteri di calcolo
                // const peritoGroupRE = _.groupBy(totaleRERecords, 'id_perito');
                // _.each(peritoGroupRE, (peritoRecords, peritoId) => {
                //     const nominativo = peritoRecords[0]?.NominativoPerito || 'Sconosciuto';
                //     GridData2.push({
                //         TipoSinistro: 'TOTALE RE',
                //         id_perito: peritoId,
                //         NominativoPerito: nominativo,
                //         ...calcolaKPI(peritoRecords, 'TOTALE RE')
                //     });
                // });

                // Filtro per rimuovere righe con tutti valori a zero
                const isAllZero = r =>
                    r.LiquidatoMedio === 0 &&
                    r.TempoMedioRestituzione === 0 &&
                    r.PercIncidenzaConcordato === 0 &&
                    r.PercScaricoAnnuale === 0;

                GridData1 = _.reject(GridData1, isAllZero);
                GridData2 = _.reject(GridData2, isAllZero);

                // Aggiorna datasource delle griglie
                this.gridInstance5.dataSource = GridData1;
                this.gridInstance5.childGrid.dataSource = GridData2;
            },
            error => {
                const messaggio = (_.isString(error) && error.indexOf("Not Found")) > -1
                    ? CustomJS.messaggioAPIBackendNonTrovata
                    : CustomJS.messaggioNoBackend;
                toast.warn(messaggio, {
                    containerId: "toastContainer1",
                    position: "top-right",
                    autoClose: 8000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: false,
                    progress: undefined,
                    newestOnTop: true,
                    rtl: false,
                    pauseOnFocusLoss: true
                });
                this.toggleBlocking();
            },
            true,
            false
        );
    }
    caricaDati6() {
        this.toggleBlocking();

        CustomJS.callAPI(
            `${CustomJS.APIMonitorURLProd}/api/Monitor/portingTutteAPI/KPI-Allianz/[NO]/[NO]/[NO]/[NO]/[NO]/[NO]`,
            '',
            'GET',
            '',
            retData => {
                this.toggleBlocking();
                if (!_.isArray(retData) || retData.length === 0) return;

                // Dataset completo (usato per KPI3 — tutti i tipi sinistro)
                const retDataAll = retData.slice();

                // Filtro sui tipi sinistro GF/RE rilevanti
                const tipiGFRE = [
                    'acq. cond./ric. guasto',
                    'atto vandalico',
                    'evento atmosferico',
                    'fenomeno elettrico',
                    'furto/rapina',
                    'guasti ladri',
                    'guasti macchine',
                    'incendio',
                    'rottura lastre-insegne',
                    'urto veicoli'
                ];
                retData = _.filter(retData, r =>
                    !r.TipoSinistro ||
                    tipiGFRE.includes((r.TipoSinistro || '').trim().toLowerCase())
                );

                this.allianzRawData = retData;
                this.allianzRawDataAll = retDataAll;

                this.ricalcolaGriglie6();
            },
        error => {
            toast.warn("Errore durante la chiamata API.", {
                containerId: "toastContainer1",
                position: "top-right",
                autoClose: 8000
            });
            this.toggleBlocking();
        }, true, false
        );
    }
    cambiaModalitaKPIAllianz(mode) {
        if (this.state.kpiAllianzViewMode === mode) return;
        this.setState({ kpiAllianzViewMode: mode }, () => {
            this.ricalcolaGriglie6();
            // Il pulsante vive in un root React separato (creato dal dialog Allianz),
            // quindi non si ri-renderizza da solo col setState: aggiorniamo le classi a mano.
            const btnRealtime = document.getElementById('btnKPIAllianzRealtime');
            const btnUfficiale = document.getElementById('btnKPIAllianzUfficiale');
            if (btnRealtime && btnUfficiale) {
                btnRealtime.classList.toggle('e-primary', mode === 'realtime');
                btnRealtime.classList.toggle('e-flat', mode !== 'realtime');
                btnUfficiale.classList.toggle('e-primary', mode === 'kpiAllianz');
                btnUfficiale.classList.toggle('e-flat', mode !== 'kpiAllianz');
            }
        });
    }
    // Coorte "KPI Allianz": sinistri entrati dal 1° gennaio dell'anno corrente
    // fino all'ultimo giorno del mese precedente (esclude il mese in corso).
    isInCoorteKPIAllianz(r) {
        if (r.GiorniApertura == null) return false;
        const oggi = new Date();
        const inizioAnnoCorrente = new Date(oggi.getFullYear(), 0, 1);
        const fineMesePrecedente = new Date(oggi.getFullYear(), oggi.getMonth(), 0, 23, 59, 59, 999);
        const dataEntrata = new Date(oggi.getFullYear(), oggi.getMonth(), oggi.getDate() - r.GiorniApertura);
        return dataEntrata >= inizioAnnoCorrente && dataEntrata <= fineMesePrecedente;
    }
    ricalcolaGriglie6() {
        if (!this.allianzRawData || !this.allianzRawDataAll || !this.gridInstance6) return;

        const retData = this.allianzRawData;
        const retDataAll = this.allianzRawDataAll;

        GridData1 = [];
        GridData2 = [];

        const meseCorrente = `${new Date().getFullYear()}${String(new Date().getMonth() + 1).padStart(2, '0')}`;

        const obiettivoJSONGFRE = CurvaObiettivi.CurvaObiettivi.find(o => o.RAMO === "PERCSCARALLIANZGFRE");
        const obiettivoMensileKPI1 = obiettivoJSONGFRE ? parseFloat(obiettivoJSONGFRE[meseCorrente]) : 0;

        const obiettivoJSONRCD = CurvaObiettivi.CurvaObiettivi.find(o => o.RAMO === "PERCSCARALLIANZRCD");
        const obiettivoMensileRCD = obiettivoJSONRCD ? parseFloat(obiettivoJSONRCD[meseCorrente]) : 0;

        const riferimentoKPI2 = 1679;

        const useAllianzMode = this.state.kpiAllianzViewMode === 'kpiAllianz';
        const rientraInCoorteAllianz = (r) => this.isInCoorteKPIAllianz(r);

        //---------------------------------------------------------
        // FUNZIONE CALCOLO KPI
        //---------------------------------------------------------
        const calcolaKPI = (records, allRecords = records) => {

            //---------------------------------------------------------
            // KPI1 — Percentuale scarico GF-RE + Delta (senza filtro area)
            //---------------------------------------------------------
            const dominioGFRE = records;
            const totaleGFRE = dominioGFRE.length;

            const chiusiGFRE = _.filter(dominioGFRE, r => r.Chiuso === 1);
            const numChiusiGFRE = chiusiGFRE.length;

            const percScaricoGFRE = totaleGFRE > 0
                ? (numChiusiGFRE / totaleGFRE) * 100
                : 0;

            const deltaKPI1 = Math.max(
                0,
                Math.ceil((obiettivoMensileKPI1 / 100) * totaleGFRE - numChiusiGFRE)
            );


            //---------------------------------------------------------
            // KPI2 — Liquidato medio 1–10k sui sinistri del KPI1 (danni diretti)
            //---------------------------------------------------------
            const indennizzabili = _.filter(chiusiGFRE, r =>
                r.TotaleDannoIndennizzabile >= 1 &&
                r.TotaleDannoIndennizzabile <= 10000
            );

            const totalLiquidato = _.reduce(indennizzabili, (sum, r) => sum + (r.TotaleDannoIndennizzabile || 0), 0);
            const liquidatoMedio = indennizzabili.length > 0 ? totalLiquidato / indennizzabili.length : 0;

            const deltaKPI2 = liquidatoMedio > riferimentoKPI2
                ? parseFloat((liquidatoMedio - riferimentoKPI2).toFixed(2))
                : 0;


            //---------------------------------------------------------
            // KPI3 — Home 30gg e 45gg (solo ramo_50 = 'SI')
            // Il Delta (sinistri mancanti obiettivo) resta sempre calcolato
            // in tempo reale; solo le due percentuali variano in base alla
            // modalità di visualizzazione selezionata (tempo reale / KPI Allianz).
            //---------------------------------------------------------
            const dominioHome = _.filter(allRecords, r =>
                r.ramo_50 === 'SI' &&
                ['Chiuso', 'In carico', 'Restituito'].includes(r.gruppo_stato) &&
                (r.grado || '').trim().toLowerCase() === 'semplice'
            );
            const totaleHome = dominioHome.length;
            const chiusiHome = _.filter(dominioHome, r => r.Chiuso === 1);
            const chiusi30 = _.filter(chiusiHome, r => r.GiorniRientro <= 30);
            const chiusi45 = _.filter(chiusiHome, r => r.GiorniRientro <= 45);

            const percScaricoHome30GG = totaleHome > 0 ? (chiusi30.length / totaleHome) * 100 : 0;
            const percScaricoHome45GG = totaleHome > 0 ? (chiusi45.length / totaleHome) * 100 : 0;

            const deltaKPI330 = Math.max(0, Math.ceil(0.75 * totaleHome - chiusi30.length));
            const deltaKPI345 = Math.max(0, Math.ceil(0.80 * totaleHome - chiusi45.length));

            const dominioHomeAllianz = _.filter(dominioHome, rientraInCoorteAllianz);
            const totaleHomeAllianz = dominioHomeAllianz.length;
            const chiusiHomeAllianz = _.filter(dominioHomeAllianz, r => r.Chiuso === 1);
            const chiusi30Allianz = _.filter(chiusiHomeAllianz, r => r.GiorniRientro <= 30);
            const chiusi45Allianz = _.filter(chiusiHomeAllianz, r => r.GiorniRientro <= 45);

            const percScaricoHome30GGAllianz = totaleHomeAllianz > 0 ? (chiusi30Allianz.length / totaleHomeAllianz) * 100 : 0;
            const percScaricoHome45GGAllianz = totaleHomeAllianz > 0 ? (chiusi45Allianz.length / totaleHomeAllianz) * 100 : 0;


            //---------------------------------------------------------
            // KPI4 — Percentuale scarico sinistri RCD
            //---------------------------------------------------------
            const dominioRCD = _.filter(records, r =>
                r.Area &&
                (r.Area.toUpperCase().includes("RCD CENTRO") ||
                r.Area.toUpperCase().includes("RCD CENTRO NORD") ||
                r.Area.toUpperCase().includes("RCD NORD EST"))
            );

            const totaleRCD = dominioRCD.length;
            const chiusiRCD = _.filter(dominioRCD, r => r.Chiuso === 1).length;

            const percScaricoRCD = totaleRCD > 0
                ? (chiusiRCD / totaleRCD) * 100
                : 0;

            const deltaKPI4 = Math.max(
                0,
                Math.ceil((obiettivoMensileRCD / 100) * totaleRCD - chiusiRCD)
            );


            //---------------------------------------------------------
            // KPI5 — Videoperizia Home (OK)
            //---------------------------------------------------------
            const dominioKPI5 = _.filter(records, r =>
                r.Area &&
                (r.Area.toUpperCase().includes("GF E RE DI TORINO") ||
                r.Area.toUpperCase().includes("GF E RE DI MILANO") ||
                r.Area.toUpperCase().includes("GF E RE DI ROMA")) &&
                r.libretto_cga && r.libretto_cga.includes("ULTRA CASA E PATRIMONIO")
            );

            const totaleVideoperizia = dominioKPI5.length;
            const chiusiVideoperizia = _.filter(dominioKPI5, r => r.videoperizia === "SI").length;

            const percScaricoVideoperizia = totaleVideoperizia > 0
                ? (chiusiVideoperizia / totaleVideoperizia) * 100
                : 0;

            const deltaObiettivoKPI5 = Math.max(
                0,
                Math.ceil(0.45 * totaleVideoperizia - chiusiVideoperizia)
            );


            //---------------------------------------------------------
            // RETURN COMPLETO
            //---------------------------------------------------------
            return {
                        LiquidatoMedioGFRE: parseFloat(liquidatoMedio.toFixed(2)),
                        ConteggioCampionGFRE: indennizzabili.length,
                        DeltaObiettivoKPI2: deltaKPI2,

                        PercScaricoGFRE: parseFloat(percScaricoGFRE.toFixed(2)),
                        DeltaObiettivoKPI1: deltaKPI1,

                        PercScaricoHome30GG: parseFloat((useAllianzMode ? percScaricoHome30GGAllianz : percScaricoHome30GG).toFixed(2)),
                        DeltaObiettivoKPI330: deltaKPI330,

                        PercScaricoHome45GG: parseFloat((useAllianzMode ? percScaricoHome45GGAllianz : percScaricoHome45GG).toFixed(2)),
                        DeltaObiettivoKPI345: deltaKPI345,

                        PercScaricoRCD: parseFloat(percScaricoRCD.toFixed(2)),
                        DeltaObiettivoKPI4: deltaKPI4,

                        PercScaricoVideoperiziaHome: parseFloat(percScaricoVideoperizia.toFixed(2)),
                        DeltaObiettivoKPI5: deltaObiettivoKPI5
                    };
        };


        //---------------------------------------------------------
        // RIGA TOTALE
        //---------------------------------------------------------
        GridData1.push({
            TipoSinistro: "TOTALE",
            ...calcolaKPI(retData, retDataAll)
        });

        //---------------------------------------------------------
        // RIGHE PERITO
        //---------------------------------------------------------
        const perGroupFiltered = _.groupBy(retData, "id_perito");
        const perGroupAll = _.groupBy(retDataAll, "id_perito");
        _.each(perGroupFiltered, (filteredRecs, id_perito) => {
            const allRecs = perGroupAll[id_perito] || [];
            const nominativo = filteredRecs[0]?.NominativoPerito || "Sconosciuto";
            GridData2.push({
                TipoSinistro: "TOTALE",
                id_perito,
                NominativoPerito: nominativo,
                ...calcolaKPI(filteredRecs, allRecs)
            });
        });

        this.gridInstance6.dataSource = GridData1;
        this.gridInstance6.childGrid.dataSource = GridData2;
    }

    //---------------------------------------------------------
    // KPI ACQUA CONDOTTA — VITTORIA ASSICURAZIONI (id_compagnia = 56)
    // Target: Tempo Medio AC 25gg — Liquidato Medio 950€
    //---------------------------------------------------------
    caricaDatiVittoria() {
        this.toggleBlocking();
        CustomJS.callAPI(
            `${CustomJS.APIMonitorURLProd}/api/Monitor/portingTutteAPI/KPI-Vittoria/[NO]/[NO]/[NO]/[NO]/[NO]/[NO]`,
            '',
            'GET',
            '',
            retData => {
                this.toggleBlocking();
                if (!_.isArray(retData)) return;
                this.vittoriaRawData = retData;
                this.ricalcolaGrigliaVittoria();
            },
        error => {
            toast.warn("Errore durante la chiamata API.", {
                containerId: "toastContainer1",
                position: "top-right",
                autoClose: 8000
            });
            this.toggleBlocking();
        }, true, false
        );
    }
    mediaVittoria(records, campo) {
        return records.length > 0
            ? _.reduce(records, (sum, r) => sum + (r[campo] || 0), 0) / records.length
            : 0;
    }
    ricalcolaGrigliaVittoria() {
        if (!this.vittoriaRawData || !this.gridInstanceVittoria) return;

        const OBIETTIVO_TEMPO_AC = 25;
        const OBIETTIVO_LIQUIDATO_AC = 950;

        // KPI1/KPI2: perizie tra 1 e 1.500€ — KPI3: tutti gli importi (già >= 1 filtrato lato backend)
        const dataset1500 = _.filter(this.vittoriaRawData, r =>
            r.TotaleDannoIndennizzabile >= 1 && r.TotaleDannoIndennizzabile <= 1501
        );
        const datasetTotale = this.vittoriaRawData;

        const liquidatoMedioAC1500 = this.mediaVittoria(dataset1500, 'TotaleDannoIndennizzabile');
        const tempoMedioAC1500 = this.mediaVittoria(
            _.filter(dataset1500, r => r.GiorniGestione != null),
            'GiorniGestione'
        );
        const liquidatoMedioACTotale = this.mediaVittoria(datasetTotale, 'TotaleDannoIndennizzabile');

        const deltaLiquidato = liquidatoMedioAC1500 > OBIETTIVO_LIQUIDATO_AC
            ? parseFloat((liquidatoMedioAC1500 - OBIETTIVO_LIQUIDATO_AC).toFixed(2))
            : 0;
        const deltaTempo = tempoMedioAC1500 > OBIETTIVO_TEMPO_AC
            ? parseFloat((tempoMedioAC1500 - OBIETTIVO_TEMPO_AC).toFixed(2))
            : 0;

        this.gridInstanceVittoria.dataSource = [{
            TipoSinistro: 'ACQUA CONDOTTA',
            LiquidatoMedioAC1500: parseFloat(liquidatoMedioAC1500.toFixed(2)),
            DeltaObiettivoLiquidatoAC: deltaLiquidato,
            TempoMedioAC1500: parseFloat(tempoMedioAC1500.toFixed(2)),
            DeltaObiettivoTempoAC: deltaTempo,
            LiquidatoMedioACTotale: parseFloat(liquidatoMedioACTotale.toFixed(2)),
            ConteggioAC1500: dataset1500.length,
            ConteggioACTotale: datasetTotale.length
        }];
    }
    onDataboundVittoria(args) {
        ['GridKPIVittoria', 'GridDettaglioVittoria'].forEach(gridId => {
            const cols = document.getElementById(gridId)?.querySelectorAll('.e-columnheader')[0]?.children;
            if (!cols) return;
            for (let ind = 0; ind < cols.length; ind++) {
                cols[ind].style.backgroundColor = 'Linen';
            }
        });
    }
    onQueryCellInfoVittoria(args) {
        args.cell.style.fontWeight = 'bold';
        args.cell.style.fontSize = '1.0vw';
        const campo = args.column.field;
        if (args.column.index === 0) {
            args.cell.style.color = '#133B95';
            return;
        }
        const val = parseFloat(args.cell.innerText);
        if (isNaN(val)) return;
        const decimali = (campo === 'ConteggioAC1500' || campo === 'ConteggioACTotale') ? 0 : 2;
        args.cell.innerText = val.toLocaleString('it-IT', { minimumFractionDigits: decimali, maximumFractionDigits: decimali });
        if (campo === 'LiquidatoMedioAC1500') {
            args.cell.style.color = 'whitesmoke';
            args.cell.bgColor = val <= 950 ? '#2e7d32' : '#c62828';
        } else if (campo === 'TempoMedioAC1500') {
            args.cell.style.color = 'whitesmoke';
            args.cell.bgColor = val <= 25 ? '#2e7d32' : '#c62828';
        } else if (campo === 'DeltaObiettivoLiquidatoAC' || campo === 'DeltaObiettivoTempoAC') {
            args.cell.style.color = val > 0 ? '#c62828' : '#2e7d32';
        } else {
            args.cell.style.color = 'purple';
        }
    }
    apriDettaglioVittoria(tipo) {
        if (!this.vittoriaRawData) return;
        const campoRaggruppamento = tipo === 'provincia' ? 'ProvinciaCorta' : 'Area';

        const dataset1500 = _.filter(this.vittoriaRawData, r =>
            r.TotaleDannoIndennizzabile >= 1 && r.TotaleDannoIndennizzabile <= 1501
        );
        const gruppi1500 = _.groupBy(dataset1500, r => r[campoRaggruppamento] || 'N/D');
        const gruppiTotale = _.groupBy(this.vittoriaRawData, r => r[campoRaggruppamento] || 'N/D');

        const chiavi = _.union(_.keys(gruppi1500), _.keys(gruppiTotale));
        let righe = _.map(chiavi, chiave => {
            const recs1500 = gruppi1500[chiave] || [];
            const recsTotale = gruppiTotale[chiave] || [];
            return {
                Chiave: chiave,
                LiquidatoMedioAC1500: parseFloat(this.mediaVittoria(recs1500, 'TotaleDannoIndennizzabile').toFixed(2)),
                TempoMedioAC1500: parseFloat(this.mediaVittoria(_.filter(recs1500, r => r.GiorniGestione != null), 'GiorniGestione').toFixed(2)),
                LiquidatoMedioACTotale: parseFloat(this.mediaVittoria(recsTotale, 'TotaleDannoIndennizzabile').toFixed(2)),
                ConteggioAC1500: recs1500.length,
                ConteggioACTotale: recsTotale.length
            };
        });
        righe = _.sortBy(righe, 'Chiave');

        const etichetta = tipo === 'provincia' ? 'Provincia' : 'Ispettorato';
        this.dialogInstance2.header = `<div style="display:flex;align-items:center;gap:10px;padding:2px 0">
            <span style="font-size:1.2vw;font-weight:bold;color:#133B95">KPI ACQUA CONDOTTA VITTORIA — Dettaglio per ${etichetta}</span>
        </div>`;
        this.dialogInstance2.width = '65%';
        this.dialogInstance2.height = '75%';
        this.dialogInstance2.minHeight = '75%';
        this.dialogInstance2.buttons = [];
        this.dialogInstance2.beforeOpen = () => {
            const container = document.getElementById('defaultDialogContentProvince');
            const root = createRoot(container);
            root.unmount();
        };
        this.dialogInstance2.open = () => {
            const container = document.getElementById('defaultDialogContentProvince');
            const root = createRoot(container);
            root.render(this.GrigliaDettaglioVittoriaRender(etichetta, righe));
        };
        this.dialogInstance2.show();
    }
    GrigliaDettaglioVittoriaRender(etichettaColonna, righe) {
        ++this.childKey;
        return (
            <GridComponent id="GridDettaglioVittoria" key={this.childKey} dataSource={righe} allowSorting={true} allowPaging={false} allowSelection={false} enableHover={false} allowTextWrap={true}
                queryCellInfo={this.onQueryCellInfoVittoria.bind(this)} dataBound={this.onDataboundVittoria.bind(this)} enableAltRow={true} gridLines='Both' height='auto'>
                <ColumnsDirective>
                    <ColumnDirective field='Chiave' headerText={etichettaColonna} headerTemplate={headerTemplate} textAlign='Center' width='18%'></ColumnDirective>
                    <ColumnDirective field='LiquidatoMedioAC1500' headerText='Liquidato Medio 1-1.500€ (KPI1)' headerTemplate={headerTemplate} textAlign='Center'></ColumnDirective>
                    <ColumnDirective field='TempoMedioAC1500' headerText='Tempo Medio gg 1-1.500€ (KPI2)' headerTemplate={headerTemplate} textAlign='Center'></ColumnDirective>
                    <ColumnDirective field='LiquidatoMedioACTotale' headerText='Liquidato Medio tutti gli importi (KPI3)' headerTemplate={headerTemplate} textAlign='Center'></ColumnDirective>
                    <ColumnDirective field='ConteggioAC1500' headerText='N. Sinistri 1-1.500€' headerTemplate={headerTemplate} textAlign='Center'></ColumnDirective>
                    <ColumnDirective field='ConteggioACTotale' headerText='N. Sinistri Totali' headerTemplate={headerTemplate} textAlign='Center'></ColumnDirective>
                </ColumnsDirective>
                <Inject services={[Sort]}/>
            </GridComponent>
        );
    }
    GrigliaKPIVittoriaRender() {
        ++this.childKey;
        return (<React.Fragment>
            <div className="control-section card-control-section basic_card_layout">
                <div className="e-card-resize-container">
                    <div className="card-layout">
                        <div className="col-xs-12 col-sm-12 col-lg-12 col-md-12">
                            <div tabIndex="0" className="e-card" id="main_card">
                                <div className="e-card-content">

                                    <div className='row'>
                                        <div className="col-xs-12 col-sm-12 col-lg-12 col-md-12">
                                            <div style={{
                                                background: 'linear-gradient(135deg, #e8f5e9 0%, #ffffff 100%)',
                                                borderRadius: '10px', padding: '14px 20px', marginBottom: '15px',
                                                border: '3px solid #2e7d32', boxShadow: '0 2px 12px rgba(46,125,50,0.35)',
                                                fontSize: '1.15vw'
                                            }}>
                                                📊 <b>KPI Acqua Condotta VITTORIA</b> — Target Tempo Medio: <b>25 gg</b> · Target Liquidato Medio: <b>950 €</b> (perizie tra <b>1 e 1.500€</b>, chiuse dal <b>1° gennaio {new Date().getFullYear()}</b> ad oggi)
                                            </div>
                                        </div>
                                    </div>

                                    <div className='row'>
                                        <div className="col-xs-12 col-sm-12 col-lg-12 col-md-12">
                                            <div style={{
                                                background: 'linear-gradient(135deg, #e3f2fd 0%, #ffffff 100%)',
                                                borderRadius: '10px', padding: '14px 20px', marginBottom: '15px',
                                                border: '3px solid #1565c0', boxShadow: '0 2px 12px rgba(21,101,192,0.35)',
                                                display: 'flex', alignItems: 'center', justifyContent: 'flex-end', flexWrap: 'wrap', gap: '10px'
                                            }}>
                                                <ButtonComponent cssClass='e-primary' iconCss='fas fa-map-marker-alt' style={{ fontWeight: 'bold', padding: '6px 18px' }}
                                                    onClick={() => this.apriDettaglioVittoria('provincia')}>VEDI DETTAGLIO PER PROVINCIA</ButtonComponent>
                                                <ButtonComponent cssClass='e-primary' iconCss='fas fa-building' style={{ fontWeight: 'bold', padding: '6px 18px' }}
                                                    onClick={() => this.apriDettaglioVittoria('area')}>VEDI DETTAGLIO PER ISPETTORATO</ButtonComponent>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='row'>
                                        <div className="col-xs-12 col-sm-12 col-lg-12 col-md-12">
                                            <BlockUi tag='div' id='blockUI2' blocking={this.state.blocking3} keepInView={true} loader={CustomJS.loaderSpinners[random(CustomJS.loaderSpinners.length - 1)]}>
                                                <GridComponent id="GridKPIVittoria" key={this.childKey} ref={grid => this.gridInstanceVittoria = grid} allowSelection={false} enableHover={false} allowTextWrap={true}
                                                    allowPaging={false} allowSorting={false} allowFiltering={false} queryCellInfo={this.onQueryCellInfoVittoria.bind(this)} dataBound={this.onDataboundVittoria.bind(this)} enableAltRow={true} gridLines='Both'>
                                                    <ColumnsDirective>
                                                        <ColumnDirective field='TipoSinistro' headerText='Tipo Sinistro' headerTemplate={headerTemplate} textAlign='Center' width='14%'></ColumnDirective>
                                                        <ColumnDirective field='LiquidatoMedioAC1500' headerText='Liquidato Medio 1-1.500€ (KPI1)' headerTemplate={headerTemplate} textAlign='Center'></ColumnDirective>
                                                        <ColumnDirective field='DeltaObiettivoLiquidatoAC' headerText='Delta su obiettivo Liquidato (KPI1)' headerTemplate={headerTemplate} textAlign='Center'></ColumnDirective>
                                                        <ColumnDirective field='TempoMedioAC1500' headerText='Tempo Medio Gestione gg 1-1.500€ (KPI2)' headerTemplate={headerTemplate} textAlign='Center'></ColumnDirective>
                                                        <ColumnDirective field='DeltaObiettivoTempoAC' headerText='Delta su obiettivo Tempo (KPI2)' headerTemplate={headerTemplate} textAlign='Center'></ColumnDirective>
                                                        <ColumnDirective field='LiquidatoMedioACTotale' headerText='Liquidato Medio tutti gli importi (KPI3)' headerTemplate={headerTemplate} textAlign='Center'></ColumnDirective>
                                                        <ColumnDirective field='ConteggioAC1500' headerText='N. Sinistri 1-1.500€' headerTemplate={headerTemplate} textAlign='Center'></ColumnDirective>
                                                        <ColumnDirective field='ConteggioACTotale' headerText='N. Sinistri Totali' headerTemplate={headerTemplate} textAlign='Center'></ColumnDirective>
                                                    </ColumnsDirective>
                                                </GridComponent>
                                            </BlockUi>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>);
    }

    //---------------------------------------------------------
    // KPI REALE MUTUA (id_compagnia = 37, ramo RE)
    // Periodo: semestre corrente (reset automatico gen-giu / lug-dic), calcolato lato backend.
    // "Senza Seguito" = chiusi con importo indennizzabile zero. Retail/Corporate: nessun campo
    // dedicato, si riconosce "CORPORATE" nella colonna Area (vedi isAreaCorporate).
    //---------------------------------------------------------
    caricaDatiRealeMutua() {
        this.toggleBlocking();
        CustomJS.callAPI(
            `${CustomJS.APIMonitorURLProd}/api/Monitor/portingTutteAPI/KPI-RealeMutua/[NO]/[NO]/[NO]/[NO]/[NO]/[NO]`,
            '',
            'GET',
            '',
            retData => {
                this.toggleBlocking();
                if (!_.isArray(retData)) return;
                this.realeMutuaRawData = retData;
                this.ricalcolaGrigliaRealeMutua();
            },
        error => {
            toast.warn("Errore durante la chiamata API.", {
                containerId: "toastContainer1",
                position: "top-right",
                autoClose: 8000
            });
            this.toggleBlocking();
        }, true, false
        );
    }
    // Media di un campo su un array di record, ignorando i null (utility condivisa Reale Mutua)
    mediaCampoRealeMutua(records, campo) {
        const valorizzati = _.filter(records, r => r[campo] != null);
        return valorizzati.length > 0
            ? _.reduce(valorizzati, (sum, r) => sum + r[campo], 0) / valorizzati.length
            : 0;
    }
    // Non esiste un campo dedicato Retail/Corporate: un sinistro è Corporate se la sua Area contiene "CORPORATE"
    isAreaCorporate(area) {
        return !!area && area.toUpperCase().includes('CORPORATE');
    }
    calcolaKPIRealeMutua(records) {
        const chiusi = _.filter(records, r => r.Chiuso === 1);
        const totale = records.length;

        const cmPeriziato = this.mediaCampoRealeMutua(chiusi, 'DannoAccertato');
        const cmLiquidato = this.mediaCampoRealeMutua(chiusi, 'TotaleDannoIndennizzabile');

        // Fasce di importo ESCLUSIVE (confermate): 0-10k, 10k-30k (esclusi i confini inferiori), 30k-60k
        const fascia10k = _.filter(chiusi, r => r.TotaleDannoIndennizzabile != null && r.TotaleDannoIndennizzabile >= 0 && r.TotaleDannoIndennizzabile <= 10000 && r.GiorniRientro != null);
        const fascia30k = _.filter(chiusi, r => r.TotaleDannoIndennizzabile != null && r.TotaleDannoIndennizzabile > 10000 && r.TotaleDannoIndennizzabile <= 30000 && r.GiorniRientro != null);
        const fascia60k = _.filter(chiusi, r => r.TotaleDannoIndennizzabile != null && r.TotaleDannoIndennizzabile > 30000 && r.TotaleDannoIndennizzabile <= 60000 && r.GiorniRientro != null);

        const tempoMedio10k = this.mediaCampoRealeMutua(fascia10k, 'GiorniRientro');
        const tempoMedio30k = this.mediaCampoRealeMutua(fascia30k, 'GiorniRientro');
        const tempoMedio60k = this.mediaCampoRealeMutua(fascia60k, 'GiorniRientro');

        const espletamento = totale > 0 ? (chiusi.length / totale) * 100 : 0;

        // "Senza Seguito" (confermato): sinistri chiusi con importo indennizzabile pari a zero
        const senzaSeguito = chiusi.length > 0
            ? (_.filter(chiusi, r => r.TotaleDannoIndennizzabile === 0).length / chiusi.length) * 100
            : 0;

        const videoperizia = totale > 0 ? (_.filter(records, r => r.Videoperizia === 'SI').length / totale) * 100 : 0;

        // Retail/Corporate (confermato): segmentazione sulla colonna Area, nessuna occorrenza "CORPORATE" al momento
        const chiusiCorporate = _.filter(chiusi, r => this.isAreaCorporate(r.Area));
        const chiusiRetail = _.filter(chiusi, r => !this.isAreaCorporate(r.Area));
        const cmRetail = this.mediaCampoRealeMutua(chiusiRetail, 'DannoAccertato');
        const cmCorporate = this.mediaCampoRealeMutua(chiusiCorporate, 'DannoAccertato');

        return {
            CMPeriziato: parseFloat(cmPeriziato.toFixed(2)),
            CMLiquidato: parseFloat(cmLiquidato.toFixed(2)),
            TempoMedio10k: parseFloat(tempoMedio10k.toFixed(2)),
            TempoMedio30k: parseFloat(tempoMedio30k.toFixed(2)),
            TempoMedio60k: parseFloat(tempoMedio60k.toFixed(2)),
            Espletamento: parseFloat(espletamento.toFixed(2)),
            SenzaSeguito: parseFloat(senzaSeguito.toFixed(2)),
            Videoperizia: parseFloat(videoperizia.toFixed(2)),
            CMRetail: parseFloat(cmRetail.toFixed(2)),
            CMCorporate: parseFloat(cmCorporate.toFixed(2)),
            ConteggioCorporate: chiusiCorporate.length,
            ConteggioTotale: totale,
            ConteggioChiusi: chiusi.length,
            Conteggio10k: fascia10k.length,
            Conteggio30k: fascia30k.length,
            Conteggio60k: fascia60k.length
        };
    }
    ricalcolaGrigliaRealeMutua() {
        if (!this.realeMutuaRawData || !this.gridInstanceRealeMutua) return;

        const AREA_GLOBALE_FABBRICATI = 'POLO GLOBALE FABBRICATI NORD OVEST';
        const dominioGlobaleFabbricati = _.filter(this.realeMutuaRawData, r => r.Area === AREA_GLOBALE_FABBRICATI);
        const dominioTuttiCLD = _.filter(this.realeMutuaRawData, r => r.Area !== AREA_GLOBALE_FABBRICATI);

        const rigaCLD = { Dominio: 'RE - TUTTI I CLD', ...this.calcolaKPIRealeMutua(dominioTuttiCLD) };
        const rigaGF = { Dominio: 'RE - GLOBALE FABBRICATI', ...this.calcolaKPIRealeMutua(dominioGlobaleFabbricati) };

        this.gridInstanceRealeMutua.dataSource = [rigaCLD, rigaGF];
    }
    onDataboundRealeMutua(args) {
        ['GridKPIRealeMutua', 'GridDettaglioRealeMutua'].forEach(gridId => {
            const cols = document.getElementById(gridId)?.querySelectorAll('.e-columnheader')[0]?.children;
            if (!cols) return;
            for (let ind = 0; ind < cols.length; ind++) {
                cols[ind].style.backgroundColor = 'Linen';
            }
        });
    }
    onQueryCellInfoRealeMutua(args) {
        args.cell.style.fontWeight = 'bold';
        args.cell.style.fontSize = '0.95vw';
        const campo = args.column.field;
        if (args.column.index === 0) {
            args.cell.style.color = '#133B95';
            return;
        }
        // Nessun sinistro Corporate rilevato al momento (Area senza occorrenze "CORPORATE")
        if (campo === 'CMCorporate' && args.data.ConteggioCorporate === 0) {
            args.cell.innerText = 'N/D';
            args.cell.style.color = '#9e9e9e';
            args.cell.style.fontStyle = 'italic';
            return;
        }
        // "Senza Seguito" non si applica alla riga "Tutti i CLD"
        if (campo === 'SenzaSeguito' && args.data.Dominio === 'RE - TUTTI I CLD') {
            args.cell.innerText = '—';
            args.cell.style.color = '#9e9e9e';
            return;
        }
        const val = parseFloat(args.cell.innerText);
        if (isNaN(val)) return;

        const target = {
            TempoMedio10k: 40, TempoMedio30k: 50, TempoMedio60k: 60,
            Espletamento: 75, SenzaSeguito: 10
        }[campo];

        args.cell.innerText = val.toLocaleString('it-IT', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

        if (target !== undefined) {
            const inTarget = (campo === 'Espletamento') ? val >= target : val <= target;
            args.cell.style.color = 'whitesmoke';
            args.cell.bgColor = inTarget ? '#2e7d32' : '#c62828';
        } else {
            args.cell.style.color = 'purple';
        }
    }
    apriDettaglioRealeMutua() {
        if (!this.realeMutuaRawData) return;
        const AREA_GLOBALE_FABBRICATI = 'POLO GLOBALE FABBRICATI NORD OVEST';
        const dominioTuttiCLD = _.filter(this.realeMutuaRawData, r => r.Area !== AREA_GLOBALE_FABBRICATI);

        // Nessuna normalizzazione (come confermato): ogni valore di Area viene mostrato così com'è
        const gruppi = _.groupBy(dominioTuttiCLD, r => r.Area || 'N/D');
        let righe = _.map(gruppi, (records, area) => ({
            Area: area,
            ...this.calcolaKPIRealeMutua(records)
        }));
        righe = _.sortBy(righe, 'Area');

        this.dialogInstance2.header = `<div style="display:flex;align-items:center;gap:10px;padding:2px 0">
            <span style="font-size:1.2vw;font-weight:bold;color:#133B95">KPI REALE MUTUA — Dettaglio per Ispettorato (RE - Tutti i CLD)</span>
        </div>`;
        this.dialogInstance2.width = '85%';
        this.dialogInstance2.height = '75%';
        this.dialogInstance2.minHeight = '75%';
        this.dialogInstance2.buttons = [];
        this.dialogInstance2.beforeOpen = () => {
            const container = document.getElementById('defaultDialogContentProvince');
            const root = createRoot(container);
            root.unmount();
        };
        this.dialogInstance2.open = () => {
            const container = document.getElementById('defaultDialogContentProvince');
            const root = createRoot(container);
            root.render(this.GrigliaDettaglioRealeMutuaRender(righe));
        };
        this.dialogInstance2.show();
    }
    GrigliaDettaglioRealeMutuaRender(righe) {
        ++this.childKey;
        return (
            <GridComponent id="GridDettaglioRealeMutua" key={this.childKey} dataSource={righe} allowSorting={true} allowPaging={false} allowSelection={false} enableHover={false} allowTextWrap={true}
                queryCellInfo={this.onQueryCellInfoRealeMutua.bind(this)} dataBound={this.onDataboundRealeMutua.bind(this)} enableAltRow={true} gridLines='Both' height='auto'>
                <ColumnsDirective>
                    <ColumnDirective field='Area' headerText='Ispettorato (Area)' headerTemplate={headerTemplate} textAlign='Center' width='16%'></ColumnDirective>
                    <ColumnDirective field='CMPeriziato' headerText='CM Periziato (€)' headerTemplate={headerTemplate} textAlign='Center'></ColumnDirective>
                    <ColumnDirective field='TempoMedio10k' headerText='Tempo Medio gg (0-10k)' headerTemplate={headerTemplate} textAlign='Center'></ColumnDirective>
                    <ColumnDirective field='TempoMedio30k' headerText='Tempo Medio gg (10-30k)' headerTemplate={headerTemplate} textAlign='Center'></ColumnDirective>
                    <ColumnDirective field='TempoMedio60k' headerText='Tempo Medio gg (30-60k)' headerTemplate={headerTemplate} textAlign='Center'></ColumnDirective>
                    <ColumnDirective field='Espletamento' headerText='Espletamento (%)' headerTemplate={headerTemplate} textAlign='Center'></ColumnDirective>
                    <ColumnDirective field='Videoperizia' headerText='Videoperizia (%)' headerTemplate={headerTemplate} textAlign='Center'></ColumnDirective>
                    <ColumnDirective field='ConteggioChiusi' headerText='N. Sinistri Chiusi' headerTemplate={headerTemplate} textAlign='Center'></ColumnDirective>
                    <ColumnDirective field='ConteggioTotale' headerText='N. Sinistri Totali' headerTemplate={headerTemplate} textAlign='Center'></ColumnDirective>
                </ColumnsDirective>
                <Inject services={[Sort]}/>
            </GridComponent>
        );
    }
    legendaKPIRealeMutuaContent() {
        return (
            <div style={stylesLegend.legendContainer}>
                <div style={stylesLegend.infoBox}>
                    <div style={stylesLegend.infoIcon}>ℹ️</div>
                    <div style={stylesLegend.infoContent}>
                        <div style={stylesLegend.infoTitle}>Periodo e ambito</div>
                        <div style={stylesLegend.infoText}>
                            Semestre corrente (1 gen - 30 giu oppure 1 lug - 31 dic), sinistri ramo <strong>RE</strong>. I target 2026 non sono ancora disponibili: vengono usati i target 2025, con a fianco il consuntivo provvisorio 2025 come riferimento.
                        </div>
                    </div>
                </div>

                <div style={stylesLegend.kpiSection}>
                    <div style={stylesLegend.kpiHeader}>
                        <span style={stylesLegend.kpiBadge}>RE</span>
                        <span>Tutti i CLD — Retail + Corporate</span>
                    </div>
                    <div style={stylesLegend.legendItem}>
                        <div style={stylesLegend.legendLabel}><span style={{...stylesLegend.legendIndicator, ...stylesLegend.indicatorBlue}}></span>CM Periziato (€) — nessun target, solo monitoraggio</div>
                        <div style={stylesLegend.legendValue}>rif. 2025: <span style={stylesLegend.euroSymbol}>€</span> 1.718,00</div>
                    </div>
                    <div style={stylesLegend.legendItem}>
                        <div style={stylesLegend.legendLabel}><span style={{...stylesLegend.legendIndicator, ...stylesLegend.indicatorOrange}}></span>Tempo Medio (gg) 0-10k</div>
                        <div style={stylesLegend.legendValue}>40 gg (rif. 2025: 41,30)</div>
                    </div>
                    <div style={stylesLegend.legendItem}>
                        <div style={stylesLegend.legendLabel}><span style={{...stylesLegend.legendIndicator, ...stylesLegend.indicatorOrange}}></span>Tempo Medio (gg) 10-30k</div>
                        <div style={stylesLegend.legendValue}>50 gg</div>
                    </div>
                    <div style={stylesLegend.legendItem}>
                        <div style={stylesLegend.legendLabel}><span style={{...stylesLegend.legendIndicator, ...stylesLegend.indicatorOrange}}></span>Tempo Medio (gg) 30-60k</div>
                        <div style={stylesLegend.legendValue}>60 gg</div>
                    </div>
                    <div style={stylesLegend.legendItem}>
                        <div style={stylesLegend.legendLabel}><span style={{...stylesLegend.legendIndicator, ...stylesLegend.indicatorGreen}}></span>Espletamento (%)</div>
                        <div style={stylesLegend.legendValue}>75% (rif. 2025: 74,10%)</div>
                    </div>
                    <div style={stylesLegend.legendItem}>
                        <div style={stylesLegend.legendLabel}><span style={{...stylesLegend.legendIndicator, ...stylesLegend.indicatorPurple}}></span>Videoperizia (%) — nessun target, solo monitoraggio</div>
                        <div style={stylesLegend.legendValue}>rif. 2025: 0,10%</div>
                    </div>
                    <div style={stylesLegend.legendItem}>
                        <div style={stylesLegend.legendLabel}>Di cui RETAIL — CM Periziato (€), nessun target</div>
                        <div style={stylesLegend.legendValue}>rif. 2025: <span style={stylesLegend.euroSymbol}>€</span> 1.567,00</div>
                    </div>
                    <div style={stylesLegend.legendItem}>
                        <div style={stylesLegend.legendLabel}>Di cui CORPORATE — CM Periziato (€), nessun target</div>
                        <div style={stylesLegend.legendValue}>rif. 2025: <span style={stylesLegend.euroSymbol}>€</span> 2.936,00</div>
                    </div>
                </div>

                <div style={stylesLegend.kpiSection}>
                    <div style={stylesLegend.kpiHeader}>
                        <span style={stylesLegend.kpiBadge}>RE</span>
                        <span>Globale Fabbricati (Polo GF Nord Ovest)</span>
                    </div>
                    <div style={stylesLegend.legendItem}>
                        <div style={stylesLegend.legendLabel}><span style={{...stylesLegend.legendIndicator, ...stylesLegend.indicatorBlue}}></span>CM Liquidato (€) — nessun target, solo monitoraggio</div>
                        <div style={stylesLegend.legendValue}>rif. 2025: <span style={stylesLegend.euroSymbol}>€</span> 1.179,90</div>
                    </div>
                    <div style={stylesLegend.legendItem}>
                        <div style={stylesLegend.legendLabel}><span style={{...stylesLegend.legendIndicator, ...stylesLegend.indicatorOrange}}></span>Tempo Medio (gg) 0-10k</div>
                        <div style={stylesLegend.legendValue}>40 gg (rif. 2025: 43,40)</div>
                    </div>
                    <div style={stylesLegend.legendItem}>
                        <div style={stylesLegend.legendLabel}><span style={{...stylesLegend.legendIndicator, ...stylesLegend.indicatorOrange}}></span>Tempo Medio (gg) 10-30k</div>
                        <div style={stylesLegend.legendValue}>50 gg</div>
                    </div>
                    <div style={stylesLegend.legendItem}>
                        <div style={stylesLegend.legendLabel}><span style={{...stylesLegend.legendIndicator, ...stylesLegend.indicatorOrange}}></span>Tempo Medio (gg) 30-60k</div>
                        <div style={stylesLegend.legendValue}>60 gg</div>
                    </div>
                    <div style={stylesLegend.legendItem}>
                        <div style={stylesLegend.legendLabel}><span style={{...stylesLegend.legendIndicator, ...stylesLegend.indicatorGreen}}></span>Espletamento (%)</div>
                        <div style={stylesLegend.legendValue}>75% (rif. 2025: 79,10%)</div>
                    </div>
                    <div style={stylesLegend.legendItem}>
                        <div style={stylesLegend.legendLabel}><span style={{...stylesLegend.legendIndicator, ...stylesLegend.indicatorPurple}}></span>Senza Seguito (%) — chiusi con importo indennizzabile pari a zero</div>
                        <div style={stylesLegend.legendValue}>10% (rif. 2025: 16,70%)</div>
                    </div>
                    <div style={stylesLegend.legendItem}>
                        <div style={stylesLegend.legendLabel}><span style={{...stylesLegend.legendIndicator, ...stylesLegend.indicatorPurple}}></span>Videoperizia (%) — nessun target, solo monitoraggio</div>
                        <div style={stylesLegend.legendValue}>rif. 2025: 0,30%</div>
                    </div>
                </div>

                <div style={stylesLegend.rcInfoBox}>
                    <div style={stylesLegend.infoIcon}>ℹ️</div>
                    <div style={stylesLegend.infoContent}>
                        <div style={stylesLegend.rcInfoTitle}>Note di calcolo</div>
                        <div style={stylesLegend.rcInfoText}>
                            "Senza Seguito" = sinistri chiusi con importo indennizzabile pari a zero. Non esiste un campo dedicato Retail/Corporate: un sinistro è considerato Corporate se la colonna Area contiene la stringa "CORPORATE" — al momento nessuna area la contiene, quindi tutti i sinistri risultano Retail. Le aree (ispettorati) sono mostrate come compaiono a sistema, senza normalizzazione delle varianti di scrittura.
                        </div>
                    </div>
                </div>
            </div>
        );
    }
    GrigliaKPIRealeMutuaRender() {
        ++this.childKey;
        return (<React.Fragment>
            <div className="control-section card-control-section basic_card_layout">
                <div className="e-card-resize-container">
                    <div className="card-layout">
                        <div className="col-xs-12 col-sm-12 col-lg-12 col-md-12">
                            <div tabIndex="0" className="e-card" id="main_card">
                                <div className="e-card-content">

                                    <div className='row'>
                                        <div className="col-xs-12 col-sm-12 col-lg-12 col-md-12">
                                            <div style={{ marginTop: '10px', marginBottom: '15px' }}>
                                                <AccordionComponent>
                                                    <AccordionItemsDirective>
                                                        <AccordionItemDirective
                                                            header='📊 LEGENDA KPI - INFO E VALORI TARGET (rif. 2025)'
                                                            content={this.legendaKPIRealeMutuaContent.bind(this)}
                                                        />
                                                    </AccordionItemsDirective>
                                                </AccordionComponent>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='row'>
                                        <div className="col-xs-12 col-sm-12 col-lg-12 col-md-12 text-end" style={{ marginBottom: '10px' }}>
                                            <ButtonComponent cssClass='e-primary' iconCss='fas fa-map-marker-alt' style={{ fontWeight: 'bold', padding: '6px 18px' }}
                                                onClick={() => this.apriDettaglioRealeMutua()}>VEDI DETTAGLIO PER ISPETTORATO (TUTTI I CLD)</ButtonComponent>
                                        </div>
                                    </div>

                                    <div className='row'>
                                        <div className="col-xs-12 col-sm-12 col-lg-12 col-md-12">
                                            <BlockUi tag='div' id='blockUI2' blocking={this.state.blocking3} keepInView={true} loader={CustomJS.loaderSpinners[random(CustomJS.loaderSpinners.length - 1)]}>
                                                <GridComponent id="GridKPIRealeMutua" key={this.childKey} ref={grid => this.gridInstanceRealeMutua = grid} toolbar={this.toolbarOptions3} allowSelection={false} enableHover={false} allowTextWrap={true}
                                                    allowPaging={false} allowSorting={false} allowFiltering={false} allowExcelExport={true} allowPdfExport={true} queryCellInfo={this.onQueryCellInfoRealeMutua.bind(this)}
                                                    dataBound={this.onDataboundRealeMutua.bind(this)} toolbarClick={this.toolbarClickRealeMutua.bind(this)} enableAltRow={true} gridLines='Both' height='auto'>
                                                    <ColumnsDirective>
                                                        <ColumnDirective field='Dominio' headerText='Dominio' headerTemplate={headerTemplate} textAlign='Center' width='14%'></ColumnDirective>
                                                        <ColumnDirective field='CMPeriziato' headerText='CM Periziato (€)' headerTemplate={headerTemplate} textAlign='Center'></ColumnDirective>
                                                        <ColumnDirective field='CMLiquidato' headerText='CM Liquidato (€)' headerTemplate={headerTemplate} textAlign='Center'></ColumnDirective>
                                                        <ColumnDirective field='TempoMedio10k' headerText='Tempo Medio gg (0-10k)' headerTemplate={headerTemplate} textAlign='Center'></ColumnDirective>
                                                        <ColumnDirective field='TempoMedio30k' headerText='Tempo Medio gg (10-30k)' headerTemplate={headerTemplate} textAlign='Center'></ColumnDirective>
                                                        <ColumnDirective field='TempoMedio60k' headerText='Tempo Medio gg (30-60k)' headerTemplate={headerTemplate} textAlign='Center'></ColumnDirective>
                                                        <ColumnDirective field='Espletamento' headerText='Espletamento (%)' headerTemplate={headerTemplate} textAlign='Center'></ColumnDirective>
                                                        <ColumnDirective field='SenzaSeguito' headerText='Senza Seguito (%)' headerTemplate={headerTemplate} textAlign='Center'></ColumnDirective>
                                                        <ColumnDirective field='Videoperizia' headerText='Videoperizia (%)' headerTemplate={headerTemplate} textAlign='Center'></ColumnDirective>
                                                        <ColumnDirective field='CMRetail' headerText='CM Retail (€)' headerTemplate={headerTemplate} textAlign='Center'></ColumnDirective>
                                                        <ColumnDirective field='CMCorporate' headerText='CM Corporate (€)' headerTemplate={headerTemplate} textAlign='Center'></ColumnDirective>
                                                        <ColumnDirective field='ConteggioChiusi' headerText='N. Sinistri Chiusi' headerTemplate={headerTemplate} textAlign='Center'></ColumnDirective>
                                                        <ColumnDirective field='ConteggioTotale' headerText='N. Sinistri Totali' headerTemplate={headerTemplate} textAlign='Center'></ColumnDirective>
                                                    </ColumnsDirective>
                                                    <Inject services={[Toolbar, ExcelExport, PdfExport, Filter, Sort, Page]}/>
                                                </GridComponent>
                                            </BlockUi>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>);
    }
}